import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  WWS_DateTime: any,
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  WWS_JSON: any,
  /** A string, an array of strings, or a boolean */
  Answer: any,
  GDS__Any: any,
  GDS__FieldSet: any,
};


export type AddressComponents = {
   __typename?: 'AddressComponents',
  google_place?: Maybe<GooglePlace>,
  local_vendor?: Maybe<LocalVendor>,
  user_entry?: Maybe<UserEntry>,
};

export type AddressComponentsInput = {
  google_place?: Maybe<GooglePlaceInput>,
  local_vendor?: Maybe<LocalVendorInput>,
  user_entry?: Maybe<UserEntryInput>,
};

export type AiSettings = {
   __typename?: 'AISettings',
  useConversationalMemory?: Maybe<Scalars['Boolean']>,
};

export type AiSettingsArgs = {
  useConversationalMemory: Scalars['Boolean'],
};

export enum AllowedAttributes {
  WeddingDate = 'wedding_date'
}


export type AttireCategory = {
   __typename?: 'AttireCategory',
  id?: Maybe<AttireCategoryEnum>,
  label?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
};

export enum AttireCategoryEnum {
  Casual = 'casual',
  SemiFormal = 'semiFormal',
  Cocktail = 'cocktail',
  Formal = 'formal',
  BlackTie = 'blackTie',
  WhiteTie = 'whiteTie',
  Other = 'other'
}

export type Booking = {
   __typename?: 'Booking',
  address_components?: Maybe<AddressComponents>,
  category_code?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['String']>,
  id: Scalars['ID'],
  member_id?: Maybe<Scalars['ID']>,
  source?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['String']>,
  vendor_name?: Maybe<Scalars['String']>,
  vendor_profile_id?: Maybe<Scalars['String']>,
  contact_info?: Maybe<ContactInfo>,
};

export type BookingInput = {
  address_components: AddressComponentsInput,
  category_code: Scalars['String'],
  id?: Maybe<Scalars['ID']>,
  member_id: Scalars['ID'],
  source: Scalars['String'],
  vendor_name: Scalars['String'],
  vendor_profile_id?: Maybe<Scalars['String']>,
  contact_info?: Maybe<ContactInfoInput>,
};

export type CashFund = {
   __typename?: 'CashFund',
  type?: Maybe<Scalars['String']>,
  fulfilled?: Maybe<Scalars['Boolean']>,
  cashFundId?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  numRequested?: Maybe<Scalars['Int']>,
  numReceived?: Maybe<Scalars['Int']>,
  deleted?: Maybe<Scalars['Boolean']>,
  name?: Maybe<Scalars['String']>,
  priceCents?: Maybe<Scalars['Int']>,
  cashFundTemplateId?: Maybe<Scalars['Int']>,
  isArchived?: Maybe<Scalars['Boolean']>,
  isGoalHidden?: Maybe<Scalars['Boolean']>,
  imageUrl?: Maybe<Scalars['String']>,
  fundType?: Maybe<Scalars['String']>,
  memberId?: Maybe<Scalars['String']>,
  createdAt?: Maybe<Scalars['String']>,
  updatedAt?: Maybe<Scalars['String']>,
  topChoice?: Maybe<Scalars['String']>,
};

export type ContactInfo = {
   __typename?: 'ContactInfo',
  name?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
};

export type ContactInfoInput = {
  name?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
};

export type CreateMemberArgs = {
  email?: Maybe<Scalars['String']>,
  password?: Maybe<Scalars['String']>,
  firstName: Scalars['String'],
  lastName: Scalars['String'],
  fianceFirstName: Scalars['String'],
  fianceLastName: Scalars['String'],
  brand_version?: Maybe<Scalars['String']>,
};

export type CustomLinkEmailArgs = {
  subject: Scalars['String'],
  body: Scalars['String'],
  customUrl: Scalars['String'],
  linkButtonText: Scalars['String'],
  guestIds: Array<Scalars['String']>,
  token?: Maybe<Scalars['String']>,
};

export enum DatePreference {
  Range = 'Range',
  Exact = 'Exact',
  Tba = 'TBA',
  Season = 'Season',
  None = 'None'
}

export type Decision = {
   __typename?: 'Decision',
  id: Scalars['String'],
  answer: Scalars['Answer'],
  application?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['String']>,
  taxonomy_answer?: Maybe<Array<Maybe<Scalars['String']>>>,
  updated_at?: Maybe<Scalars['String']>,
};

export type DecisionInput = {
  id: Scalars['String'],
  answer: Scalars['Answer'],
  application?: Maybe<Scalars['String']>,
};

export type Experiment = {
   __typename?: 'Experiment',
  experiment_id: Scalars['String'],
  experiment_name: Scalars['String'],
  brand: Scalars['String'],
  bucketing_id_type: Scalars['String'],
  rollout?: Maybe<Scalars['Int']>,
  created_at: Scalars['String'],
  updated_at: Scalars['String'],
  variants: Array<Variant>,
};

export type ExperimentBucket = {
   __typename?: 'ExperimentBucket',
  variant_id: Scalars['String'],
  variant_name: Scalars['String'],
  experiment_id: Scalars['String'],
  bucketing_id: Scalars['String'],
  bucketing_id_type: Scalars['String'],
  created_at: Scalars['String'],
  updated_at: Scalars['String'],
};



export type Gds_Address = {
   __typename?: 'GDS_Address',
  street1?: Maybe<Scalars['String']>,
  street2?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  zip?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  fullAddress?: Maybe<Scalars['String']>,
};

export type Gds_Answer = {
   __typename?: 'GDS_Answer',
  questionId: Scalars['String'],
  optionId?: Maybe<Scalars['String']>,
  text?: Maybe<Scalars['String']>,
};

export type Gds_AnswerData = {
   __typename?: 'GDS_AnswerData',
  optionId?: Maybe<Scalars['String']>,
  text: Scalars['String'],
  responseCount?: Maybe<Scalars['Int']>,
  responses?: Maybe<Array<Maybe<Gds_Responder>>>,
};

export type Gds_CreateAddressInput = {
  street1?: Maybe<Scalars['String']>,
  street2?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  zip?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  fullAddress?: Maybe<Scalars['String']>,
};

export type Gds_CreateAnswerInput = {
  questionId: Scalars['String'],
  optionId?: Maybe<Scalars['String']>,
  text?: Maybe<Scalars['String']>,
};

export type Gds_CreateHouseholdInput = {
  weddingId: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  groupId?: Maybe<Scalars['String']>,
  rsvpNote?: Maybe<Scalars['String']>,
  coupleNote?: Maybe<Scalars['String']>,
  people: Array<Gds_CreatePersonInput>,
  address?: Maybe<Gds_CreateAddressInput>,
  answers?: Maybe<Array<Gds_CreateAnswerInput>>,
};

export type Gds_CreateInvitationInput = {
  eventId: Scalars['String'],
  rsvp?: Maybe<Scalars['Boolean']>,
  meal?: Maybe<Scalars['String']>,
  gift?: Maybe<Scalars['String']>,
  invitationSent?: Maybe<Scalars['Boolean']>,
  thankYouSent?: Maybe<Scalars['Boolean']>,
  answers?: Maybe<Array<Gds_CreateAnswerInput>>,
};

export type Gds_CreatePersonInput = {
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  isLeader?: Maybe<Scalars['Boolean']>,
  phone?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  invitations: Array<Gds_CreateInvitationInput>,
  answers?: Maybe<Array<Gds_CreateAnswerInput>>,
};

export type Gds_DeleteInvitationInput = {
  id: Scalars['String'],
  personId: Scalars['String'],
  householdId: Scalars['String'],
};

export type Gds_DeleteInvitationPayload = {
   __typename?: 'GDS_DeleteInvitationPayload',
  id?: Maybe<Scalars['String']>,
};

export type Gds_Event = {
   __typename?: 'GDS_Event',
  id: Scalars['String'],
  weddingId: Scalars['String'],
  name?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  date?: Maybe<Scalars['String']>,
  time?: Maybe<Scalars['String']>,
  endTime?: Maybe<Scalars['String']>,
  attire?: Maybe<Scalars['String']>,
  notes?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['Int']>,
  requireRsvp?: Maybe<Scalars['Boolean']>,
  sameVenue?: Maybe<Scalars['Boolean']>,
  visible?: Maybe<Scalars['Boolean']>,
  meals?: Maybe<Array<Scalars['String']>>,
  location?: Maybe<Gds_Location>,
  image?: Maybe<Gds_Image>,
  subEvents?: Maybe<Array<Gds_SubEvent>>,
  questions?: Maybe<Array<Gds_Question>>,
  createdAt: Scalars['String'],
  updatedAt: Scalars['String'],
};

export type Gds_EventQuestionResponseData = {
   __typename?: 'GDS_EventQuestionResponseData',
  eventId: Scalars['String'],
  eventName: Scalars['String'],
  questionsData?: Maybe<Array<Maybe<Gds_QuestionResponseData>>>,
};

export type Gds_EventRsvpData = {
   __typename?: 'GDS_EventRsvpData',
  eventId: Scalars['String'],
  guestCount?: Maybe<Scalars['Int']>,
  acceptCount?: Maybe<Scalars['Int']>,
  rejectCount?: Maybe<Scalars['Int']>,
};

export type Gds_Group = {
   __typename?: 'GDS_Group',
  id: Scalars['String'],
  weddingId: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  emoji?: Maybe<Scalars['String']>,
  createdAt: Scalars['String'],
  updatedAt: Scalars['String'],
};

export type Gds_GuestWedding = {
   __typename?: 'GDS_GuestWedding',
  id: Scalars['String'],
  isPrivateRsvp?: Maybe<Scalars['Boolean']>,
  sendRsvpReminder?: Maybe<Scalars['Boolean']>,
  rsvpDeadline?: Maybe<Scalars['String']>,
  rsvpMedium?: Maybe<Scalars['String']>,
  rsvpAsAPage?: Maybe<Scalars['Boolean']>,
  rsvpPageHidden?: Maybe<Scalars['Boolean']>,
  rsvpWorkflow?: Maybe<Scalars['Boolean']>,
  usesSubEvents?: Maybe<Scalars['Boolean']>,
  usesQuestions?: Maybe<Scalars['Boolean']>,
  allowGuestPreview?: Maybe<Scalars['Boolean']>,
  questions?: Maybe<Array<Gds_Question>>,
  createdAt: Scalars['String'],
  updatedAt: Scalars['String'],
};

export type Gds_GuestWeddingQuestionResponseData = {
   __typename?: 'GDS_GuestWeddingQuestionResponseData',
  guestWeddingId: Scalars['String'],
  questionsData?: Maybe<Array<Maybe<Gds_QuestionResponseData>>>,
};

export type Gds_Household = {
   __typename?: 'GDS_Household',
  id: Scalars['String'],
  weddingId: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  groupId?: Maybe<Scalars['String']>,
  rsvpNote?: Maybe<Scalars['String']>,
  coupleNote?: Maybe<Scalars['String']>,
  people: Array<Gds_Person>,
  address?: Maybe<Gds_Address>,
  answers?: Maybe<Array<Gds_Answer>>,
  createdAt: Scalars['String'],
  updatedAt: Scalars['String'],
};

export type Gds_Image = {
   __typename?: 'GDS_Image',
  id: Scalars['String'],
  height?: Maybe<Scalars['Int']>,
  width?: Maybe<Scalars['Int']>,
  rotationAngle?: Maybe<Scalars['Int']>,
  cropBox?: Maybe<Scalars['String']>,
  createdAt: Scalars['String'],
  updatedAt: Scalars['String'],
};

export type Gds_Invitation = {
   __typename?: 'GDS_Invitation',
  id: Scalars['String'],
  eventId: Scalars['String'],
  rsvp?: Maybe<Scalars['Boolean']>,
  meal?: Maybe<Scalars['String']>,
  gift?: Maybe<Scalars['String']>,
  invitationSent?: Maybe<Scalars['Boolean']>,
  thankYouSent?: Maybe<Scalars['Boolean']>,
  answers?: Maybe<Array<Gds_Answer>>,
  createdAt: Scalars['String'],
  updatedAt: Scalars['String'],
};

export type Gds_Location = {
   __typename?: 'GDS_Location',
  name?: Maybe<Scalars['String']>,
  street1?: Maybe<Scalars['String']>,
  street2?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  zip?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  fullAddress?: Maybe<Scalars['String']>,
};

export type Gds_Option = {
   __typename?: 'GDS_Option',
  id: Scalars['String'],
  text?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  createdAt: Scalars['String'],
  updatedAt: Scalars['String'],
};

export type Gds_Person = {
   __typename?: 'GDS_Person',
  id: Scalars['String'],
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  isLeader?: Maybe<Scalars['Boolean']>,
  phone?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  invitations: Array<Gds_Invitation>,
  answers?: Maybe<Array<Gds_Answer>>,
  preferences?: Maybe<Gds_Preferences>,
  createdAt: Scalars['String'],
  updatedAt: Scalars['String'],
};

export type Gds_Preferences = {
   __typename?: 'GDS_Preferences',
  emailOptOut?: Maybe<Scalars['Boolean']>,
  smsOptOut?: Maybe<Scalars['Boolean']>,
};

export type Gds_Question = {
   __typename?: 'GDS_Question',
  id: Scalars['String'],
  text?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  answerType?: Maybe<Scalars['String']>,
  answerDestination?: Maybe<Scalars['String']>,
  isRequired?: Maybe<Scalars['Boolean']>,
  options?: Maybe<Array<Gds_Option>>,
  createdAt: Scalars['String'],
  updatedAt: Scalars['String'],
};

export type Gds_QuestionResponseData = {
   __typename?: 'GDS_QuestionResponseData',
  questionId: Scalars['String'],
  text: Scalars['String'],
  answerType: Scalars['String'],
  type: Scalars['String'],
  optionCount?: Maybe<Scalars['Int']>,
  answersData?: Maybe<Array<Maybe<Gds_AnswerData>>>,
};

export type Gds_Responder = {
   __typename?: 'GDS_Responder',
  personId: Scalars['String'],
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
};

export type Gds_SubEvent = {
   __typename?: 'GDS_SubEvent',
  id: Scalars['String'],
  name?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  notes?: Maybe<Scalars['String']>,
  attire?: Maybe<Scalars['String']>,
  location?: Maybe<Gds_Location>,
  visible?: Maybe<Scalars['Boolean']>,
  time?: Maybe<Scalars['String']>,
  endTime?: Maybe<Scalars['String']>,
  createdAt: Scalars['String'],
  updatedAt: Scalars['String'],
};

export type Gds_UpdateGuestWeddingInput = {
  isPrivateRsvp?: Maybe<Scalars['Boolean']>,
  sendRsvpReminder?: Maybe<Scalars['Boolean']>,
  rsvpDeadline?: Maybe<Scalars['String']>,
  rsvpMedium?: Maybe<Scalars['String']>,
  rsvpPageHidden?: Maybe<Scalars['Boolean']>,
  allowGuestPreview?: Maybe<Scalars['Boolean']>,
  questions?: Maybe<Array<Gds_UpdateQuestionInput>>,
};

export type Gds_UpdateGuestWeddingRsvpPropsInput = {
  isPrivateRsvp?: Maybe<Scalars['Boolean']>,
  rsvpDeadline?: Maybe<Scalars['String']>,
  rsvpMedium?: Maybe<Scalars['String']>,
};

export type Gds_UpdateInvitationPatchInput = {
  rsvp?: Maybe<Scalars['Boolean']>,
  gift?: Maybe<Scalars['String']>,
  invitationSent?: Maybe<Scalars['Boolean']>,
  thankYouSent?: Maybe<Scalars['Boolean']>,
  answers?: Maybe<Array<Gds_CreateAnswerInput>>,
};

export type Gds_UpdateOptionInput = {
  id?: Maybe<Scalars['String']>,
  text?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
};

export type Gds_UpdateQuestionInput = {
  text?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  answerType?: Maybe<Scalars['String']>,
  answerDestination?: Maybe<Scalars['String']>,
  isRequired?: Maybe<Scalars['Boolean']>,
  options?: Maybe<Array<Gds_UpdateOptionInput>>,
};

export type GiftBucket = {
   __typename?: 'GiftBucket',
  rangeLabel?: Maybe<Scalars['String']>,
  min?: Maybe<Scalars['Int']>,
  available?: Maybe<Scalars['String']>,
  received?: Maybe<Scalars['Int']>,
};

export type GooglePlace = {
   __typename?: 'GooglePlace',
  administrative_area_level_1?: Maybe<Scalars['String']>,
  administrative_area_level_2?: Maybe<Scalars['String']>,
  administrative_area_level_3?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  locality?: Maybe<Scalars['String']>,
  neighborhood?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  place_id?: Maybe<Scalars['String']>,
  postal_code_suffix?: Maybe<Scalars['String']>,
  postal_code?: Maybe<Scalars['String']>,
  route?: Maybe<Scalars['String']>,
  street_number?: Maybe<Scalars['String']>,
  sublocality?: Maybe<Scalars['String']>,
  website?: Maybe<Scalars['String']>,
};

export type GooglePlaceInput = {
  administrative_area_level_1?: Maybe<Scalars['String']>,
  administrative_area_level_2?: Maybe<Scalars['String']>,
  administrative_area_level_3?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  locality?: Maybe<Scalars['String']>,
  neighborhood?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  place_id?: Maybe<Scalars['String']>,
  postal_code_suffix?: Maybe<Scalars['String']>,
  postal_code?: Maybe<Scalars['String']>,
  route?: Maybe<Scalars['String']>,
  street_number?: Maybe<Scalars['String']>,
  sublocality?: Maybe<Scalars['String']>,
  website?: Maybe<Scalars['String']>,
};

export type GuestMessagingGuests = {
   __typename?: 'GuestMessagingGuests',
  id: Scalars['String'],
  status: Scalars['String'],
  reply?: Maybe<Scalars['String']>,
  person?: Maybe<Gds_Person>,
};

export type GuestMessagingStatuses = {
   __typename?: 'GuestMessagingStatuses',
  batchId: Scalars['String'],
  sequenceDisplayName: Scalars['String'],
  type: Scalars['String'],
  guestsAttempted: Scalars['Int'],
  guestsReceived: Scalars['Int'],
  replyCount: Scalars['Int'],
  sequenceId: Scalars['String'],
  guests: Array<GuestMessagingGuests>,
  sentDate: Scalars['String'],
  sequence: Sequence,
};

export type LinkEmailArgs = {
  subject: Scalars['String'],
  body: Scalars['String'],
  linkButtonText: Scalars['String'],
  guestIds: Array<Scalars['String']>,
  token?: Maybe<Scalars['String']>,
};

export type LocalVendor = {
   __typename?: 'LocalVendor',
  address1?: Maybe<Scalars['String']>,
  address2?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  isPublic?: Maybe<Scalars['Boolean']>,
  latitude?: Maybe<Scalars['Float']>,
  longitude?: Maybe<Scalars['Float']>,
  postalCode?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
};

export type LocalVendorInput = {
  address1?: Maybe<Scalars['String']>,
  address2?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  isPublic?: Maybe<Scalars['Boolean']>,
  latitude?: Maybe<Scalars['Float']>,
  longitude?: Maybe<Scalars['Float']>,
  postalCode?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
};

export type Market = {
   __typename?: 'Market',
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  zip?: Maybe<Scalars['String']>,
  code?: Maybe<Scalars['String']>,
};

export type MarketInput = {
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  zip?: Maybe<Scalars['String']>,
  code?: Maybe<Scalars['String']>,
};

export type Member = {
   __typename?: 'Member',
  id: Scalars['ID'],
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  fianceFirstName?: Maybe<Scalars['String']>,
  fianceLastName?: Maybe<Scalars['String']>,
  email: Scalars['String'],
  isEmailVerified?: Maybe<Scalars['Boolean']>,
  legacyUserId?: Maybe<Scalars['String']>,
  couplePhotoUrl?: Maybe<Scalars['String']>,
  username?: Maybe<Scalars['String']>,
  createdAt?: Maybe<Scalars['String']>,
  inRewardsProgram?: Maybe<Scalars['Boolean']>,
  aiSettings?: Maybe<AiSettings>,
};

export type MemberArgs = {
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  fianceFirstName?: Maybe<Scalars['String']>,
  fianceLastName?: Maybe<Scalars['String']>,
};

export type MemberResearchDetails = {
   __typename?: 'MemberResearchDetails',
  quote?: Maybe<Scalars['String']>,
  isAvailable?: Maybe<Scalars['Boolean']>,
  availableOn?: Maybe<Array<Maybe<Scalars['String']>>>,
  overallRank?: Maybe<Scalars['Float']>,
  notes?: Maybe<Scalars['String']>,
  url?: Maybe<Scalars['String']>,
};

export type Mutation = {
   __typename?: 'Mutation',
  createAnnouncement: Wws_Announcement,
  updateAnnouncement: Wws_Announcement,
  createPage: Wws_Page,
  updatePage: Wws_Page,
  deletePage: Wws_Page,
  updatePages: Array<Wws_Page>,
  deletePageItem: Scalars['Int'],
  reorderPageItems: Array<Wws_PageItem>,
  createAccommodationItem: Wws_AccommodationItem,
  updateAccommodationItem: Wws_AccommodationItem,
  createActivityItem: Wws_ActivityItem,
  updateActivityItem: Wws_ActivityItem,
  createBasicItem: Wws_BasicItem,
  updateBasicItem: Wws_BasicItem,
  createDressCodeItem: Wws_DressCodeItem,
  updateDressCodeItem: Wws_DressCodeItem,
  createCoverPhotoItem: Wws_CoverPhotoItem,
  updateCoverPhotoItem: Wws_CoverPhotoItem,
  createEmbedItem: Wws_EmbedItem,
  updateEmbedItem: Wws_EmbedItem,
  createGifItem: Wws_GifItem,
  updateGifItem: Wws_GifItem,
  createHeadlineItem: Wws_HeadlineItem,
  updateHeadlineItem: Wws_HeadlineItem,
  createLivestreamItem: Wws_LivestreamItem,
  updateLivestreamItem: Wws_LivestreamItem,
  createParagraphItem: Wws_ParagraphItem,
  updateParagraphItem: Wws_ParagraphItem,
  createPersonItem: Wws_PersonItem,
  updatePersonItem: Wws_PersonItem,
  createPhotoItem: Wws_PhotoItem,
  updatePhotoItem: Wws_PhotoItem,
  createPhotoGalleryItem: Wws_PhotoGalleryItem,
  updatePhotoGalleryItem: Wws_PhotoGalleryItem,
  createQuestionItem: Wws_QuestionItem,
  updateQuestionItem: Wws_QuestionItem,
  createPhotoTimelineItem: Wws_PhotoTimelineItem,
  updatePhotoTimelineItem: Wws_PhotoTimelineItem,
  createStoryItem: Wws_StoryItem,
  updateStoryItem: Wws_StoryItem,
  createTransportationItem: Wws_TransportationItem,
  updateTransportationItem: Wws_TransportationItem,
  updateSelectedTheme: Wws_Theme,
  addFavoriteTheme: Wws_ThemeSummary,
  removeFavoriteTheme: Scalars['Boolean'],
  /** Updates a wedding website. */
  updateWeddingWebsite: Wws_WeddingWebsite,
  /** Creates a new wedding website with an UNPUBLISHED state. */
  createWeddingWebsite: Wws_WeddingWebsite,
  /** Creates a new wedding website with an UNINITIALIZED state. */
  createUninitializedWeddingWebsite: Wws_WeddingWebsite,
  /** Disables a PUBLISHED wedding website and sets it to guest list only, state will become DISABLED */
  disableWeddingWebsite: Wws_WeddingWebsite,
  /** Reactivates a DISABLED wedding website, and sets it to PUBLISHED state */
  reactivateWeddingWebsite: Wws_WeddingWebsite,
  /** 
 * Sets a wedding website to PUBLISHED state, if a user has a verified email. A
   * client side check is recommended, and incorporate a email verification flow
   * before calling this endpoint.
 */
  publishWeddingWebsite: Wws_WeddingWebsite,
  createPurchaseDomain: Wws_PurchaseDomain,
  updatePurchaseDomain: Wws_PurchaseDomain,
  createCoverPhotoOnWebsite: Wws_WeddingWebsite,
  updateCoverPhoto: Wws_CoverPhoto,
  deleteCoverPhotoOnWebsite: Wws_WeddingWebsite,
  printPromotion?: Maybe<Wws_WeddingWebsitePromotion>,
  dismissPromotion: Wws_WeddingWebsitePromotion,
  createThemeOverride: Wws_ThemeOverride,
  updateThemeOverride: Wws_ThemeOverride,
  resetFontClassInThemeOverride: Wws_ThemeOverride,
  resetAllFontClassInThemeOverride: Wws_ThemeOverride,
  createCondensedThemeOverride: Wws_CondensedThemeOverride,
  updateCondensedThemeOverride: Wws_CondensedThemeOverride,
  resetAllFontClassInCondensedThemeOverride: Wws_CondensedThemeOverride,
  bucketRSVPWorkflow: Gds_GuestWedding,
  createHouseholds: Array<Gds_Household>,
  updateGuestWedding: Gds_GuestWedding,
  updateGuestWeddingRsvpProps: Gds_GuestWedding,
  insertInvitation?: Maybe<Gds_Invitation>,
  updateInvitation?: Maybe<Gds_Invitation>,
  deleteInvitation?: Maybe<Gds_DeleteInvitationPayload>,
  updateGuestWeddingQuestion: Gds_Question,
  addGuestWeddingQuestion: Gds_Question,
  deleteGuestWeddingQuestion: Scalars['String'],
  updateWeddingDate?: Maybe<Wedding>,
  updateMember?: Maybe<Member>,
  createMember: Member,
  sendShareWebsiteEmail?: Maybe<Scalars['Boolean']>,
  sendShareDayOfDetailsEmail?: Maybe<Scalars['Boolean']>,
  sendUpdatesEmail?: Maybe<Scalars['Boolean']>,
  sendSaveTheDateEmail?: Maybe<Scalars['Boolean']>,
  sendShareWebsiteSms?: Maybe<Scalars['Boolean']>,
  sendCovidEmail?: Maybe<Scalars['Boolean']>,
  sendCovidSms?: Maybe<Scalars['Boolean']>,
  sendCustomEmail?: Maybe<Scalars['Boolean']>,
  sendCustomSms?: Maybe<Scalars['Boolean']>,
  sendAddressCollectionEmail?: Maybe<Scalars['Boolean']>,
  sendAddressCollectionSms?: Maybe<Scalars['Boolean']>,
  sendLivestreamEmail?: Maybe<Scalars['Boolean']>,
  sendRsvpReminderEmail?: Maybe<Scalars['Boolean']>,
  sendRsvpReminderSms?: Maybe<Scalars['Boolean']>,
  sendLocalHotelEmail?: Maybe<Scalars['Boolean']>,
  sendLocalHotelSms?: Maybe<Scalars['Boolean']>,
  sendShareDayOfDetailsSms?: Maybe<Scalars['Boolean']>,
  sendUpdatesSms?: Maybe<Scalars['Boolean']>,
  signup?: Maybe<Onboarding>,
  signupUninitialized?: Maybe<Onboarding>,
  updateConversationalAiSettings?: Maybe<Scalars['Boolean']>,
  upsertRsvpDeadlineProps?: Maybe<Scalars['Boolean']>,
  upsertDecisions?: Maybe<Array<Maybe<Decision>>>,
  upsertBooking?: Maybe<Booking>,
  upsertWeddingData?: Maybe<Wedding>,
  updateWeddingDatePreferences?: Maybe<WeddingDatePreferences>,
};


export type MutationCreateAnnouncementArgs = {
  attributes: Wws_CreateAnnouncementAttrs
};


export type MutationUpdateAnnouncementArgs = {
  attributes: Wws_UpdateAnnouncementAttributes
};


export type MutationCreatePageArgs = {
  attributes: Wws_PageAttributes
};


export type MutationUpdatePageArgs = {
  id: Scalars['Int'],
  attributes: Wws_PageAttributes
};


export type MutationDeletePageArgs = {
  id: Scalars['Int']
};


export type MutationUpdatePagesArgs = {
  pages: Array<Wws_UpdatePageAttributes>
};


export type MutationDeletePageItemArgs = {
  attributes: Wws_DeletePageItemAttributes
};


export type MutationReorderPageItemsArgs = {
  attributes: Wws_ReorderPageItemAttrs
};


export type MutationCreateAccommodationItemArgs = {
  attributes: Wws_CreateAccommodationItemAttrs
};


export type MutationUpdateAccommodationItemArgs = {
  attributes: Wws_UpdateAccommodationItemAttrs
};


export type MutationCreateActivityItemArgs = {
  attributes: Wws_CreateBusinessItemAttrs
};


export type MutationUpdateActivityItemArgs = {
  attributes: Wws_UpdateBusinessItemAttrs
};


export type MutationCreateBasicItemArgs = {
  attributes: Wws_CreateBasicItemAttrs
};


export type MutationUpdateBasicItemArgs = {
  attributes: Wws_UpdateBasicItemAttrs
};


export type MutationCreateDressCodeItemArgs = {
  attributes: Wws_CreateDressCodeItemAttrs
};


export type MutationUpdateDressCodeItemArgs = {
  attributes: Wws_UpdateDressCodeItemAttrs
};


export type MutationCreateCoverPhotoItemArgs = {
  attributes: Wws_CreatePhotoItemAttrs
};


export type MutationUpdateCoverPhotoItemArgs = {
  attributes: Wws_UpdatePhotoItemAttrs
};


export type MutationCreateEmbedItemArgs = {
  attributes: Wws_CreateEmbedItemAttrs
};


export type MutationUpdateEmbedItemArgs = {
  attributes: Wws_UpdateEmbedItemAttrs
};


export type MutationCreateGifItemArgs = {
  attributes: Wws_CreateGifItemAttrs
};


export type MutationUpdateGifItemArgs = {
  attributes: Wws_UpdateGifItemAttrs
};


export type MutationCreateHeadlineItemArgs = {
  attributes: Wws_CreateHeadlineItemAttrs
};


export type MutationUpdateHeadlineItemArgs = {
  attributes: Wws_UpdateHeadlineItemAttrs
};


export type MutationCreateLivestreamItemArgs = {
  attributes: Wws_CreateLivestreamItemAttrs
};


export type MutationUpdateLivestreamItemArgs = {
  attributes: Wws_UpdateLivestreamItemAttrs
};


export type MutationCreateParagraphItemArgs = {
  attributes: Wws_CreateParagraphItemAttrs
};


export type MutationUpdateParagraphItemArgs = {
  attributes: Wws_UpdateParagraphItemAttrs
};


export type MutationCreatePersonItemArgs = {
  attributes: Wws_CreatePersonItemAttrs
};


export type MutationUpdatePersonItemArgs = {
  attributes: Wws_UpdatePersonItemAttrs
};


export type MutationCreatePhotoItemArgs = {
  attributes: Wws_CreatePhotoItemAttrs
};


export type MutationUpdatePhotoItemArgs = {
  attributes: Wws_UpdatePhotoItemAttrs
};


export type MutationCreatePhotoGalleryItemArgs = {
  attributes: Wws_CreatePhotoGalleryItemAttrs
};


export type MutationUpdatePhotoGalleryItemArgs = {
  attributes: Wws_UpdatePhotoGalleryItemAttrs
};


export type MutationCreateQuestionItemArgs = {
  attributes: Wws_CreateQuestionItemAttrs
};


export type MutationUpdateQuestionItemArgs = {
  attributes: Wws_UpdateQuestionItemAttrs
};


export type MutationCreatePhotoTimelineItemArgs = {
  attributes: Wws_CreatePhotoTimelineItemAttrs
};


export type MutationUpdatePhotoTimelineItemArgs = {
  attributes: Wws_UpdatePhotoTimelineItemAttrs
};


export type MutationCreateStoryItemArgs = {
  attributes: Wws_CreateStoryItemAttrs
};


export type MutationUpdateStoryItemArgs = {
  attributes: Wws_UpdateStoryItemAttrs
};


export type MutationCreateTransportationItemArgs = {
  attributes: Wws_CreateBusinessItemAttrs
};


export type MutationUpdateTransportationItemArgs = {
  attributes: Wws_UpdateBusinessItemAttrs
};


export type MutationUpdateSelectedThemeArgs = {
  id: Scalars['Int']
};


export type MutationAddFavoriteThemeArgs = {
  themeId: Scalars['Int']
};


export type MutationRemoveFavoriteThemeArgs = {
  favoriteId: Scalars['String']
};


export type MutationUpdateWeddingWebsiteArgs = {
  attributes: Wws_WeddingWebsiteAttributes
};


export type MutationCreateWeddingWebsiteArgs = {
  attributes: Wws_OnboardingAttributes
};


export type MutationCreateUninitializedWeddingWebsiteArgs = {
  attributes: Wws_OnboardingAttributes
};


export type MutationCreatePurchaseDomainArgs = {
  attributes: Wws_CreatePurchaseDomainAttrs,
  path?: Maybe<Scalars['String']>
};


export type MutationUpdatePurchaseDomainArgs = {
  attributes: Wws_UpdatePurchaseDomainAttrs
};


export type MutationCreateCoverPhotoOnWebsiteArgs = {
  attributes: Wws_PhotoAttributes
};


export type MutationUpdateCoverPhotoArgs = {
  attributes: Wws_CoverPhotoAttributes
};


export type MutationDismissPromotionArgs = {
  id: Scalars['Int']
};


export type MutationCreateThemeOverrideArgs = {
  attributes: Wws_ThemeOverrideAttributes
};


export type MutationUpdateThemeOverrideArgs = {
  id: Scalars['Int'],
  attributes: Wws_ThemeOverrideAttributes
};


export type MutationResetFontClassInThemeOverrideArgs = {
  id: Scalars['Int'],
  fontClass: Scalars['String']
};


export type MutationResetAllFontClassInThemeOverrideArgs = {
  id: Scalars['Int']
};


export type MutationCreateCondensedThemeOverrideArgs = {
  attributes: Wws_CondensedThemeOverrideAttributes
};


export type MutationUpdateCondensedThemeOverrideArgs = {
  id: Scalars['Int'],
  attributes: Wws_CondensedThemeOverrideAttributes
};


export type MutationResetAllFontClassInCondensedThemeOverrideArgs = {
  id: Scalars['Int']
};


export type MutationCreateHouseholdsArgs = {
  input: Array<Gds_CreateHouseholdInput>
};


export type MutationUpdateGuestWeddingArgs = {
  input: Gds_UpdateGuestWeddingInput
};


export type MutationUpdateGuestWeddingRsvpPropsArgs = {
  input: Gds_UpdateGuestWeddingRsvpPropsInput
};


export type MutationInsertInvitationArgs = {
  personId: Scalars['String'],
  householdId: Scalars['String'],
  input: Gds_CreateInvitationInput
};


export type MutationUpdateInvitationArgs = {
  invitationId: Scalars['String'],
  personId: Scalars['String'],
  householdId: Scalars['String'],
  input: Gds_UpdateInvitationPatchInput
};


export type MutationDeleteInvitationArgs = {
  input: Gds_DeleteInvitationInput
};


export type MutationUpdateGuestWeddingQuestionArgs = {
  id: Scalars['String'],
  input: Gds_UpdateQuestionInput
};


export type MutationAddGuestWeddingQuestionArgs = {
  input: Gds_UpdateQuestionInput
};


export type MutationDeleteGuestWeddingQuestionArgs = {
  id: Scalars['String']
};


export type MutationUpdateWeddingDateArgs = {
  date: Scalars['String']
};


export type MutationUpdateMemberArgs = {
  args?: Maybe<MemberArgs>
};


export type MutationCreateMemberArgs = {
  args: CreateMemberArgs
};


export type MutationSendShareWebsiteEmailArgs = {
  args: ShareWebsiteArgs
};


export type MutationSendShareDayOfDetailsEmailArgs = {
  args: ShareDayOfDetailsEmailArgs
};


export type MutationSendUpdatesEmailArgs = {
  args: SendUpdatesEmailArgs
};


export type MutationSendSaveTheDateEmailArgs = {
  args: SaveTheDateArgs
};


export type MutationSendShareWebsiteSmsArgs = {
  args: SmsArgs
};


export type MutationSendCovidEmailArgs = {
  args: NoLinkEmailArgs
};


export type MutationSendCovidSmsArgs = {
  args: SmsArgs
};


export type MutationSendCustomEmailArgs = {
  args: NoLinkEmailArgs
};


export type MutationSendCustomSmsArgs = {
  args: SmsArgs
};


export type MutationSendAddressCollectionEmailArgs = {
  args: LinkEmailArgs
};


export type MutationSendAddressCollectionSmsArgs = {
  args: SmsArgs
};


export type MutationSendLivestreamEmailArgs = {
  args: CustomLinkEmailArgs
};


export type MutationSendRsvpReminderEmailArgs = {
  args: LinkEmailArgs
};


export type MutationSendRsvpReminderSmsArgs = {
  args: SmsArgs
};


export type MutationSendLocalHotelEmailArgs = {
  args: LinkEmailArgs
};


export type MutationSendLocalHotelSmsArgs = {
  args: SmsArgs
};


export type MutationSendShareDayOfDetailsSmsArgs = {
  args: SmsArgs
};


export type MutationSendUpdatesSmsArgs = {
  args: SmsArgs
};


export type MutationSignupArgs = {
  args?: Maybe<SignupArgs>
};


export type MutationSignupUninitializedArgs = {
  args?: Maybe<SignupArgs>
};


export type MutationUpdateConversationalAiSettingsArgs = {
  args?: Maybe<AiSettingsArgs>
};


export type MutationUpsertRsvpDeadlinePropsArgs = {
  args: RsvpPropsArgs
};


export type MutationUpsertDecisionsArgs = {
  args?: Maybe<UpsertDecisionsArgs>
};


export type MutationUpsertBookingArgs = {
  args?: Maybe<UpsertBookingsArgs>
};


export type MutationUpsertWeddingDataArgs = {
  args?: Maybe<UpsertWeddingDataArgs>,
  allowUnconfirmed?: Maybe<Scalars['Boolean']>
};


export type MutationUpdateWeddingDatePreferencesArgs = {
  args?: Maybe<UpdateWeddingDatePreferencesArgs>
};

export type NoLinkEmailArgs = {
  subject: Scalars['String'],
  body: Scalars['String'],
  guestIds: Array<Scalars['String']>,
  token?: Maybe<Scalars['String']>,
};

export type Onboarding = {
   __typename?: 'Onboarding',
  session?: Maybe<Session>,
  member?: Maybe<Member>,
  wedding?: Maybe<Wedding>,
  weddingWebsite?: Maybe<Wws_WeddingWebsite>,
};

export type Query = {
   __typename?: 'Query',
  getVersion: Wws_Version,
  page: Wws_Page,
  pages: Array<Wws_Page>,
  themes: Array<Wws_Theme>,
  /** Find single theme by id, else selected theme. */
  theme?: Maybe<Wws_Theme>,
  familyThemes: Array<Wws_FamilyThemeType>,
  /** Get featured family themes based on user's favorites and top favorited themes. */
  recommendFamilyThemes: Array<Wws_FamilyThemeSummaryType>,
  favoritedFamilyThemes: Wws_FamilyThemesPaginatedType,
  paginateFamilyThemes: Wws_FamilyThemesPaginatedType,
  weddingWebsite: Wws_WeddingWebsite,
  searchDomains: Array<Wws_SearchDomain>,
  mediaApiJwt: Wws_MediaApiJwt,
  braintreeToken: Wws_BraintreeToken,
  themeFilterOptions: Wws_ThemeFilterOptions,
  themeOverride: Wws_ThemeOverride,
  condensedThemeOverride: Wws_CondensedThemeOverride,
  fontSetOptions: Wws_FontSetOptionsData,
  fontColorOptions: Wws_FontColorOptions,
  event?: Maybe<Gds_Event>,
  events: Array<Gds_Event>,
  household?: Maybe<Gds_Household>,
  households: Array<Gds_Household>,
  householdsWithoutRsvp: Array<Gds_Household>,
  person?: Maybe<Gds_Person>,
  guestWedding?: Maybe<Gds_GuestWedding>,
  group?: Maybe<Gds_Group>,
  groups: Array<Gds_Group>,
  eventRsvpData?: Maybe<Array<Gds_EventRsvpData>>,
  eventQuestionResponseData?: Maybe<Array<Gds_EventQuestionResponseData>>,
  guestWeddingQuestionResponseData: Gds_GuestWeddingQuestionResponseData,
  wedding?: Maybe<Wedding>,
  member?: Maybe<Member>,
  registrySummary?: Maybe<RegistrySummary>,
  bookings?: Maybe<Array<Maybe<Booking>>>,
  messagingSequence?: Maybe<Sequence>,
  messagingSequences: Array<SequenceList>,
  guestMessagingStatuses?: Maybe<Array<Maybe<GuestMessagingStatuses>>>,
  rsvpDeadlineProperties?: Maybe<RsvpDeadlineProperties>,
  weddingDecisions?: Maybe<Array<Maybe<Decision>>>,
  flipperExperiment?: Maybe<Experiment>,
  flipperExperimentBucket?: Maybe<ExperimentBucket>,
  flipperExperimentBucketAssignment?: Maybe<ExperimentBucket>,
  unleashFeatureToggles?: Maybe<Array<Maybe<UnleashFeatureToggle>>>,
  savedVendors?: Maybe<Array<Maybe<SavedVendorType>>>,
  weddingDatePreferences?: Maybe<WeddingDatePreferences>,
  wwsViewCount?: Maybe<WwsViewCount>,
  attireCategories?: Maybe<Array<Maybe<AttireCategory>>>,
};


export type QueryPageArgs = {
  id: Scalars['Int']
};


export type QueryThemeArgs = {
  id?: Maybe<Scalars['Int']>
};


export type QueryFamilyThemesArgs = {
  variant?: Maybe<Wws_FamilyThemeVariant>
};


export type QueryRecommendFamilyThemesArgs = {
  take?: Maybe<Scalars['Int']>
};


export type QueryFavoritedFamilyThemesArgs = {
  take?: Maybe<Scalars['Int']>,
  cursor?: Maybe<Scalars['Int']>
};


export type QueryPaginateFamilyThemesArgs = {
  nextCursor?: Maybe<Scalars['Int']>,
  previousCursor?: Maybe<Scalars['Int']>,
  take?: Maybe<Scalars['Int']>,
  order?: Maybe<Wws_ThemeOrder>,
  colors?: Maybe<Array<Scalars['String']>>,
  styles?: Maybe<Array<Scalars['String']>>,
  seasons?: Maybe<Array<Scalars['String']>>
};


export type QuerySearchDomainsArgs = {
  domainName: Scalars['String']
};


export type QueryEventArgs = {
  id: Scalars['String']
};


export type QueryHouseholdArgs = {
  id: Scalars['String']
};


export type QueryHouseholdsWithoutRsvpArgs = {
  eventId: Scalars['String']
};


export type QueryPersonArgs = {
  id: Scalars['String']
};


export type QueryGroupArgs = {
  id: Scalars['String']
};


export type QueryWeddingArgs = {
  allowUnconfirmed?: Maybe<Scalars['Boolean']>
};


export type QueryMessagingSequenceArgs = {
  id: Scalars['String']
};


export type QueryRsvpDeadlinePropertiesArgs = {
  type: Scalars['String']
};


export type QueryFlipperExperimentArgs = {
  experimentId: Scalars['String']
};


export type QueryFlipperExperimentBucketArgs = {
  experimentId: Scalars['String'],
  bucketId: Scalars['String'],
  variantId?: Maybe<Scalars['String']>,
  force?: Maybe<Scalars['String']>
};


export type QueryFlipperExperimentBucketAssignmentArgs = {
  experimentId: Scalars['String'],
  bucketId: Scalars['String']
};

export type Registry = {
   __typename?: 'Registry',
  isDeleted?: Maybe<Scalars['Boolean']>,
  hiddenWws?: Maybe<Scalars['Boolean']>,
  registryType?: Maybe<Scalars['Int']>,
};

export type RegistryStore = {
   __typename?: 'RegistryStore',
  name?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  received?: Maybe<Scalars['Int']>,
  available?: Maybe<Scalars['String']>,
};

export type RegistrySummary = {
   __typename?: 'RegistrySummary',
  totalActiveGiftsRequested?: Maybe<Scalars['String']>,
  totalGiftsReceived?: Maybe<Scalars['Int']>,
  totalGiftsAvailable?: Maybe<Scalars['String']>,
  totalCashCentsReceived?: Maybe<Scalars['Int']>,
  totalCashFunds?: Maybe<Scalars['Int']>,
  giftBuckets?: Maybe<Array<Maybe<GiftBucket>>>,
  cashFunds?: Maybe<Array<Maybe<CashFund>>>,
  giftsByStore?: Maybe<Array<Maybe<RegistryStore>>>,
  hasTransactionalRegistry?: Maybe<Scalars['Boolean']>,
  registries?: Maybe<Array<Maybe<Registry>>>,
};

export type RsvpDeadlineProperties = {
   __typename?: 'RsvpDeadlineProperties',
  id: Scalars['String'],
  type: Scalars['String'],
  weddingId: Scalars['String'],
  memberId: Scalars['String'],
  subject?: Maybe<Scalars['String']>,
  body: Scalars['String'],
  emailButtonText?: Maybe<Scalars['String']>,
};

export type RsvpPropsArgs = {
  type: Scalars['String'],
  subject?: Maybe<Scalars['String']>,
  body: Scalars['String'],
  emailButtonText?: Maybe<Scalars['String']>,
};

export type SavedLocalVendor = {
   __typename?: 'SavedLocalVendor',
  id?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
};

export type SavedVendorAddress = {
   __typename?: 'SavedVendorAddress',
  address1?: Maybe<Scalars['String']>,
  address2?: Maybe<Scalars['String']>,
  city?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  postalCode?: Maybe<Scalars['String']>,
};

export type SavedVendorContactInfo = {
   __typename?: 'SavedVendorContactInfo',
  name?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  phoneNumber?: Maybe<Scalars['String']>,
};

export type SavedVendorType = {
   __typename?: 'SavedVendorType',
  id?: Maybe<Scalars['String']>,
  weddingId?: Maybe<Scalars['String']>,
  categoryCode?: Maybe<Scalars['String']>,
  localVendor?: Maybe<SavedLocalVendor>,
  address?: Maybe<SavedVendorAddress>,
  contactInfo?: Maybe<SavedVendorContactInfo>,
  memberResearchDetails?: Maybe<MemberResearchDetails>,
};

export type SaveTheDateArgs = {
  subject: Scalars['String'],
  body: Scalars['String'],
  linkButtonText: Scalars['String'],
  guestIds: Array<Scalars['String']>,
  showLinkButton?: Maybe<Scalars['Boolean']>,
  token?: Maybe<Scalars['String']>,
  themeEmail?: Maybe<Scalars['Boolean']>,
};

export type Season = {
   __typename?: 'Season',
  name?: Maybe<SeasonName>,
  year?: Maybe<Scalars['Int']>,
};

export type SeasonInput = {
  name?: Maybe<SeasonName>,
  year?: Maybe<Scalars['Int']>,
};

export enum SeasonName {
  Fall = 'Fall',
  Winter = 'Winter',
  Spring = 'Spring',
  Summer = 'Summer'
}

export type SendUpdatesEmailArgs = {
  subject: Scalars['String'],
  body: Scalars['String'],
  linkButtonText: Scalars['String'],
  guestIds: Array<Scalars['String']>,
  token?: Maybe<Scalars['String']>,
  themeEmail?: Maybe<Scalars['Boolean']>,
};

export type Sequence = {
   __typename?: 'Sequence',
  id: Scalars['String'],
  defaultEmailSubject?: Maybe<Scalars['String']>,
  defaultEmailBody?: Maybe<Scalars['String']>,
  defaultLinkText?: Maybe<Scalars['String']>,
  defaultSmsBody?: Maybe<Scalars['String']>,
  displayName: Scalars['String'],
  description: Scalars['String'],
  shortDescription: Scalars['String'],
  type: Scalars['String'],
  mediaId: Scalars['String'],
};

export type SequenceList = {
   __typename?: 'SequenceList',
  sequenceType: Scalars['String'],
  displayName: Scalars['String'],
  description: Scalars['String'],
  shortDescription: Scalars['String'],
  mediaId: Scalars['String'],
  supportedTypes: Array<SupportedType>,
};

export type Session = {
   __typename?: 'Session',
  token?: Maybe<Scalars['String']>,
};

export type ShareDayOfDetailsEmailArgs = {
  subject: Scalars['String'],
  body: Scalars['String'],
  linkButtonText: Scalars['String'],
  guestIds: Array<Scalars['String']>,
  token?: Maybe<Scalars['String']>,
  themeEmail?: Maybe<Scalars['Boolean']>,
};

export type ShareWebsiteArgs = {
  subject: Scalars['String'],
  body: Scalars['String'],
  linkButtonText: Scalars['String'],
  guestIds: Array<Scalars['String']>,
  token?: Maybe<Scalars['String']>,
  themeEmail?: Maybe<Scalars['Boolean']>,
};

export type SignupArgs = {
  email?: Maybe<Scalars['String']>,
  password?: Maybe<Scalars['String']>,
  firstName: Scalars['String'],
  lastName: Scalars['String'],
  fianceFirstName: Scalars['String'],
  fianceLastName: Scalars['String'],
  themeId?: Maybe<Scalars['Int']>,
  createLiteSite?: Maybe<Scalars['Boolean']>,
  brand_version?: Maybe<Scalars['String']>,
};

export type SmsArgs = {
  body: Scalars['String'],
  guestIds: Array<Scalars['String']>,
  token?: Maybe<Scalars['String']>,
};

export type SupportedType = {
   __typename?: 'SupportedType',
  id: Scalars['String'],
  type: Scalars['String'],
};

export type UnleashFeatureToggle = {
   __typename?: 'UnleashFeatureToggle',
  name: Scalars['String'],
  enabled: Scalars['Boolean'],
};

export type UpdateWeddingDatePreferencesArgs = {
  preference: DatePreference,
  /** Use preference instead */
  hideDate?: Maybe<Scalars['Boolean']>,
  hideCountdown?: Maybe<Scalars['Boolean']>,
  season?: Maybe<SeasonName>,
  year?: Maybe<Scalars['Int']>,
  date?: Maybe<Scalars['String']>,
  format?: Maybe<Scalars['String']>,
  rangeStart?: Maybe<Scalars['String']>,
  rangeEnd?: Maybe<Scalars['String']>,
};

export type UpsertBookingsArgs = {
  booking?: Maybe<BookingInput>,
};

export type UpsertDecisionsArgs = {
  decisions?: Maybe<Array<Maybe<DecisionInput>>>,
};

export type UpsertWeddingDataArgs = {
  wedding?: Maybe<WeddingInput>,
};

export type UserEntry = {
   __typename?: 'UserEntry',
  city?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  postal_code?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  street?: Maybe<Scalars['String']>,
};

export type UserEntryInput = {
  city?: Maybe<Scalars['String']>,
  country?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  postal_code?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  street?: Maybe<Scalars['String']>,
};

export type Variant = {
   __typename?: 'Variant',
  variant_id: Scalars['String'],
  variant_name: Scalars['String'],
  experiment_id: Scalars['String'],
  allocation?: Maybe<Scalars['Int']>,
  created_at: Scalars['String'],
  updated_at: Scalars['String'],
};

export type Wedding = {
   __typename?: 'Wedding',
  id: Scalars['ID'],
  weddingDate: Scalars['String'],
  unconfirmedAttributes: Array<Maybe<Scalars['String']>>,
  budgetRange: Scalars['String'],
  guestRange: Scalars['String'],
  engagementDate?: Maybe<Scalars['String']>,
  budgetValue?: Maybe<Scalars['Int']>,
  market?: Maybe<Market>,
  season?: Maybe<Season>,
};

export type WeddingDatePreferences = {
   __typename?: 'WeddingDatePreferences',
  year?: Maybe<Scalars['Int']>,
  season?: Maybe<SeasonName>,
  hideDate?: Maybe<Scalars['Boolean']>,
  hideCountdown?: Maybe<Scalars['Boolean']>,
  weddingDate?: Maybe<Scalars['String']>,
  weddingDateFormat?: Maybe<Scalars['String']>,
  weddingDateRangeStart?: Maybe<Scalars['String']>,
  weddingDateRangeEnd?: Maybe<Scalars['String']>,
  datePreference?: Maybe<DatePreference>,
  weddingEventTime?: Maybe<Scalars['String']>,
};

export type WeddingInput = {
  guestRange?: Maybe<Scalars['String']>,
  budgetRange?: Maybe<Scalars['String']>,
  engagementDate?: Maybe<Scalars['String']>,
  unconfirmedAttributes?: Maybe<Array<Maybe<AllowedAttributes>>>,
  budgetValue?: Maybe<Scalars['Int']>,
  weddingDate?: Maybe<Scalars['String']>,
  market?: Maybe<MarketInput>,
  season?: Maybe<SeasonInput>,
};

export type Wws_AccommodationItem = Wws_PageItem & {
   __typename?: 'WWS_AccommodationItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  address?: Maybe<Scalars['String']>,
  aspectRatio?: Maybe<Wws_AspectRatio>,
  checkInDate?: Maybe<Scalars['String']>,
  checkOutDate?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  guestCode?: Maybe<Scalars['String']>,
  guidance?: Maybe<Wws_PageItemGuidance>,
  hotelPlannerId?: Maybe<Scalars['Int']>,
  hotelId?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  photo?: Maybe<Wws_Photo>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  /** The provider of the AccommodationItem, like 'engine'. */
  provider?: Maybe<Scalars['String']>,
  rate?: Maybe<Scalars['String']>,
  website?: Maybe<Scalars['String']>,
  mediaApiId?: Maybe<Scalars['String']>,
  height: Scalars['Int'],
  width: Scalars['Int'],
};

export type Wws_ActivityItem = Wws_PageItem & {
   __typename?: 'WWS_ActivityItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  address?: Maybe<Scalars['String']>,
  aspectRatio?: Maybe<Wws_AspectRatio>,
  description?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  guidance?: Maybe<Wws_PageItemGuidance>,
  name?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  photo?: Maybe<Wws_Photo>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  website?: Maybe<Scalars['String']>,
  mediaApiId?: Maybe<Scalars['String']>,
  height: Scalars['Int'],
  width: Scalars['Int'],
};

export type Wws_AlbumPhoto = {
   __typename?: 'WWS_AlbumPhoto',
  aspectRatio?: Maybe<Wws_AspectRatio>,
  height?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Int']>,
  mediaApiId?: Maybe<Scalars['String']>,
  mediaUrl: Scalars['String'],
  photoAlbumId?: Maybe<Scalars['Int']>,
  rank?: Maybe<Scalars['Int']>,
  width?: Maybe<Scalars['Int']>,
};

/** Allowed page types for create/update. Only DressCodePage and CustomPage are supported. */
export enum Wws_AllowedCreatePageType {
  DressCodePage = 'DressCodePage',
  CustomPage = 'CustomPage'
}

export type Wws_Announcement = {
   __typename?: 'WWS_Announcement',
  icon?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Int']>,
  message: Scalars['String'],
  show: Scalars['Boolean'],
  title?: Maybe<Scalars['String']>,
};

export type Wws_AspectRatio = {
   __typename?: 'WWS_AspectRatio',
  id: Scalars['String'],
  name: Scalars['String'],
  value: Scalars['Float'],
  width: Scalars['Int'],
  height: Scalars['Int'],
};

export type Wws_BasicItem = Wws_PageItem & {
   __typename?: 'WWS_BasicItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  aspectRatio?: Maybe<Wws_AspectRatio>,
  description?: Maybe<Scalars['String']>,
  guidance?: Maybe<Wws_PageItemGuidance>,
  originalPhoto?: Maybe<Scalars['String']>,
  photo?: Maybe<Wws_Photo>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  mediaApiId?: Maybe<Scalars['String']>,
  height: Scalars['Int'],
  width: Scalars['Int'],
};

export type Wws_BraintreeToken = {
   __typename?: 'WWS_BraintreeToken',
  token: Scalars['String'],
  vendorId: Scalars['String'],
};

export type Wws_ColorOverrides = {
   __typename?: 'WWS_ColorOverrides',
  background?: Maybe<Scalars['String']>,
  primary?: Maybe<Scalars['String']>,
  primaryHover?: Maybe<Scalars['String']>,
  s1FontColor?: Maybe<Scalars['String']>,
  s2FontColor?: Maybe<Scalars['String']>,
  s3FontColor?: Maybe<Scalars['String']>,
  s4FontColor?: Maybe<Scalars['String']>,
  s5FontColor?: Maybe<Scalars['String']>,
  s6FontColor?: Maybe<Scalars['String']>,
  tinyFontColor?: Maybe<Scalars['String']>,
  buttonColor?: Maybe<Scalars['String']>,
  buttonFontColor?: Maybe<Scalars['String']>,
  buttonHoverColor?: Maybe<Scalars['String']>,
  buttonHoverFontColor?: Maybe<Scalars['String']>,
};

export type Wws_ColorOverridesInput = {
  background?: Maybe<Scalars['String']>,
  primary?: Maybe<Scalars['String']>,
  primaryHover?: Maybe<Scalars['String']>,
  s1FontColor?: Maybe<Scalars['String']>,
  s2FontColor?: Maybe<Scalars['String']>,
  s3FontColor?: Maybe<Scalars['String']>,
  s4FontColor?: Maybe<Scalars['String']>,
  s5FontColor?: Maybe<Scalars['String']>,
  s6FontColor?: Maybe<Scalars['String']>,
  tinyFontColor?: Maybe<Scalars['String']>,
  buttonColor?: Maybe<Scalars['String']>,
  buttonFontColor?: Maybe<Scalars['String']>,
  buttonHoverColor?: Maybe<Scalars['String']>,
  buttonHoverFontColor?: Maybe<Scalars['String']>,
};

export type Wws_CondensedThemeOverride = {
   __typename?: 'WWS_CondensedThemeOverride',
  id?: Maybe<Scalars['Int']>,
  memberWeddingId?: Maybe<Scalars['Int']>,
  themeFamilySlug?: Maybe<Scalars['String']>,
  themeId?: Maybe<Scalars['Int']>,
  yourNames?: Maybe<Wws_CondensedThemeOverrideFont>,
  headline?: Maybe<Wws_CondensedThemeOverrideFont>,
  paragraph?: Maybe<Wws_CondensedThemeOverrideFont>,
};

export type Wws_CondensedThemeOverrideAttributes = {
  yourNames?: Maybe<Wws_CondensedThemeOverrideFontInput>,
  headline?: Maybe<Wws_CondensedThemeOverrideFontInput>,
  paragraph?: Maybe<Wws_CondensedThemeOverrideFontInput>,
};

export type Wws_CondensedThemeOverrideFont = {
   __typename?: 'WWS_CondensedThemeOverrideFont',
  fontFamily?: Maybe<Scalars['String']>,
  fontWeight?: Maybe<Scalars['String']>,
  letterSpacing?: Maybe<Scalars['String']>,
  textTransform?: Maybe<Scalars['String']>,
  color?: Maybe<Scalars['String']>,
  fontStyle?: Maybe<Scalars['String']>,
};

export type Wws_CondensedThemeOverrideFontInput = {
  fontFamily?: Maybe<Scalars['String']>,
  fontSize?: Maybe<Scalars['String']>,
  fontWeight?: Maybe<Scalars['String']>,
  letterSpacing?: Maybe<Scalars['String']>,
  textTransform?: Maybe<Scalars['String']>,
  color?: Maybe<Scalars['String']>,
};

export type Wws_ContentItem = {
   __typename?: 'WWS_ContentItem',
  aspectRatio?: Maybe<Wws_AspectRatio>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Int']>,
  name?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['Int']>,
  originalPhoto?: Maybe<Scalars['String']>,
  partnerFlg?: Maybe<Scalars['Boolean']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  visible?: Maybe<Scalars['Boolean']>,
};

export type Wws_CoverPhoto = {
   __typename?: 'WWS_CoverPhoto',
  mediaApiId: Scalars['String'],
  mediaUrl: Scalars['String'],
  originalMediaUrl: Scalars['String'],
  aspectRatio?: Maybe<Wws_AspectRatio>,
  caption?: Maybe<Scalars['String']>,
  cropX?: Maybe<Scalars['Int']>,
  cropY?: Maybe<Scalars['Int']>,
  height?: Maybe<Scalars['Int']>,
  rotation?: Maybe<Scalars['Int']>,
  timestamp?: Maybe<Scalars['String']>,
  width?: Maybe<Scalars['Int']>,
  id: Scalars['Int'],
  cropBox?: Maybe<Scalars['String']>,
  mobileCropBox?: Maybe<Scalars['String']>,
  rotationAngle?: Maybe<Scalars['String']>,
};

export type Wws_CoverPhotoAttributes = {
  id: Scalars['Int'],
  mediaApiId?: Maybe<Scalars['String']>,
  rotationAngle?: Maybe<Scalars['String']>,
  cropBox?: Maybe<Scalars['String']>,
};

export type Wws_CoverPhotoItem = Wws_PageItem & {
   __typename?: 'WWS_CoverPhotoItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  height: Scalars['Int'],
  mediaApiId: Scalars['String'],
  mediaUrl: Scalars['String'],
  width: Scalars['Int'],
  aspectRatio?: Maybe<Wws_AspectRatio>,
  caption?: Maybe<Scalars['String']>,
  cropX?: Maybe<Scalars['Int']>,
  cropY?: Maybe<Scalars['Int']>,
  date?: Maybe<Scalars['String']>,
  focalPoint?: Maybe<Array<Scalars['String']>>,
  guidance?: Maybe<Wws_PageItemGuidance>,
  originalPhoto?: Maybe<Scalars['String']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rotation?: Maybe<Scalars['Int']>,
};

export type Wws_CreateAccommodationItemAttrs = {
  pageId: Scalars['Int'],
  rank?: Maybe<Scalars['Float']>,
  address?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  photo?: Maybe<Wws_PhotoAttributes>,
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  website?: Maybe<Scalars['String']>,
  checkInDate?: Maybe<Scalars['String']>,
  checkOutDate?: Maybe<Scalars['String']>,
  guestCode?: Maybe<Scalars['String']>,
  hotelPlannerId?: Maybe<Scalars['Int']>,
  hotelId?: Maybe<Scalars['String']>,
  provider?: Maybe<Scalars['String']>,
  rate?: Maybe<Scalars['String']>,
};

export type Wws_CreateAnnouncementAttrs = {
  /** The icon must be a stringified number */
  icon?: Maybe<Scalars['String']>,
  message: Scalars['String'],
  show?: Maybe<Scalars['Boolean']>,
  title?: Maybe<Scalars['String']>,
};

export type Wws_CreateBasicItemAttrs = {
  rank?: Maybe<Scalars['Float']>,
  description?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  photo?: Maybe<Wws_PhotoAttributes>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
};

export type Wws_CreateBusinessItemAttrs = {
  pageId: Scalars['Int'],
  rank?: Maybe<Scalars['Float']>,
  address?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  photo?: Maybe<Wws_PhotoAttributes>,
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  website?: Maybe<Scalars['String']>,
  name: Scalars['String'],
};

export type Wws_CreateDressCodeItemAttrs = {
  pageId: Scalars['Int'],
  rank?: Maybe<Scalars['Float']>,
  /** Sanitized HTML (em,strong,a,p) */
  description?: Maybe<Scalars['String']>,
  /** Related event id */
  eventId?: Maybe<Scalars['String']>,
  /** Attire category code */
  attireCategoryId?: Maybe<Scalars['String']>,
  /** Plain text attire guidance */
  attireDescription?: Maybe<Scalars['String']>,
  /** Defaults true */
  showArticles?: Maybe<Scalars['Boolean']>,
  /** Defaults true */
  showAffiliates?: Maybe<Scalars['Boolean']>,
};

export type Wws_CreateEmbedItemAttrs = {
  description?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
  title?: Maybe<Scalars['String']>,
  embededCode: Scalars['String'],
};

export type Wws_CreateGifItemAttrs = {
  originalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  parentItemId?: Maybe<Scalars['Int']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
  mediaApiId: Scalars['String'],
};

export type Wws_CreateHeadlineItemAttrs = {
  orignalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
  style?: Maybe<Scalars['String']>,
  title: Scalars['String'],
};

export type Wws_CreateLivestreamItemAttrs = {
  buttonText?: Maybe<Scalars['String']>,
  buttonUrl?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
  title: Scalars['String'],
};

export type Wws_CreateParagraphItemAttrs = {
  originalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
  content: Scalars['String'],
};

export type Wws_CreatePersonItemAttrs = {
  description?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  photo?: Maybe<Wws_PhotoAttributes>,
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
  role?: Maybe<Scalars['String']>,
  name: Scalars['String'],
};

export type Wws_CreatePhotoGalleryItemAttrs = {
  layout?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
  photoItems?: Maybe<Array<Wws_CreatePhotoItemAttrs>>,
};

export type Wws_CreatePhotoItemAttrs = {
  caption?: Maybe<Scalars['String']>,
  cropX?: Maybe<Scalars['Int']>,
  cropY?: Maybe<Scalars['Int']>,
  date?: Maybe<Scalars['String']>,
  focalPoint?: Maybe<Array<Scalars['String']>>,
  mediaApiId?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  parentItemId?: Maybe<Scalars['Int']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
  rotation?: Maybe<Scalars['Int']>,
  height: Scalars['Int'],
  width: Scalars['Int'],
};

export type Wws_CreatePhotoTimelineItemAttrs = {
  layout?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
  photoItems?: Maybe<Array<Wws_CreatePhotoItemAttrs>>,
};

/** Attributes for creating a custom domain */
export type Wws_CreatePurchaseDomainAttrs = {
  /** Braintree nonce token */
  paymentMethodNonce: Scalars['String'],
  /** The domain name to be purchased */
  domainName: Scalars['String'],
  /** The duration of the registry in years */
  years: Scalars['Float'],
};

export type Wws_CreateQuestionItemAttrs = {
  originalPhoto?: Maybe<Scalars['String']>,
  photoHeight?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
  answer: Scalars['String'],
  question: Scalars['String'],
};

export type Wws_CreateStoryItemAttrs = {
  rank?: Maybe<Scalars['Float']>,
  description?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  photo?: Maybe<Wws_PhotoAttributes>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
};


export type Wws_DeletePageItemAttributes = {
  id: Scalars['Int'],
  pageId: Scalars['Int'],
};

export type Wws_DressCodeArticle = {
   __typename?: 'WWS_DressCodeArticle',
  /** The full URL for the article. */
  url: Scalars['String'],
  /** The full URL for the main article image. */
  imageUrl: Scalars['String'],
  /** The title of the article. */
  title: Scalars['String'],
};

export type Wws_DressCodeItem = Wws_PageItem & {
   __typename?: 'WWS_DressCodeItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  /** Sanitized HTML (em,strong,a,p) */
  description?: Maybe<Scalars['String']>,
  /** Related event id */
  eventId?: Maybe<Scalars['String']>,
  /** Attire category code */
  attireCategoryId?: Maybe<Scalars['String']>,
  /** Plain text attire guidance */
  attireDescription?: Maybe<Scalars['String']>,
  /** Defaults true */
  showArticles?: Maybe<Scalars['Boolean']>,
  articles?: Maybe<Array<Wws_DressCodeArticle>>,
  /** Defaults true */
  showAffiliates?: Maybe<Scalars['Boolean']>,
};

export type Wws_EmbedItem = Wws_PageItem & {
   __typename?: 'WWS_EmbedItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  embededCode: Scalars['String'],
  mediaService: Scalars['String'],
  aspectRatio?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  guidance?: Maybe<Wws_PageItemGuidance>,
  originalPhoto?: Maybe<Scalars['String']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
};

export type Wws_EventGroupItem = Wws_PageItem & {
   __typename?: 'WWS_EventGroupItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  aspectRatio?: Maybe<Wws_AspectRatio>,
  guidance?: Maybe<Wws_PageItemGuidance>,
  originalPhoto?: Maybe<Scalars['String']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
};

export type Wws_FamilyThemesPaginatedType = {
   __typename?: 'WWS_FamilyThemesPaginatedType',
  results?: Maybe<Array<Wws_FamilyThemeSummaryType>>,
  nextCursor?: Maybe<Scalars['Int']>,
  previousCursor?: Maybe<Scalars['Int']>,
  hasMore: Scalars['Boolean'],
  hasPrevious: Scalars['Boolean'],
};

export type Wws_FamilyThemeSummaryType = {
   __typename?: 'WWS_FamilyThemeSummaryType',
  family?: Maybe<Scalars['String']>,
  themes?: Maybe<Array<Wws_ThemeSummary>>,
};

export type Wws_FamilyThemeType = {
   __typename?: 'WWS_FamilyThemeType',
  family?: Maybe<Scalars['String']>,
  themes?: Maybe<Array<Wws_Theme>>,
};

/** Family theme variant options, these have been depracted, please remove them as an argument. */
export enum Wws_FamilyThemeVariant {
  /** Data Training */
  Training = 'TRAINING',
  /** Control */
  Random = 'RANDOM',
  /** Lite Site */
  Lite = 'LITE',
  /** Lite Site Control */
  Control = 'CONTROL'
}

export type Wws_FontColorOptionGroup = {
   __typename?: 'WWS_FontColorOptionGroup',
  label?: Maybe<Scalars['String']>,
  values?: Maybe<Array<Wws_ThemeOverrideOptionValue>>,
};

export type Wws_FontColorOptions = {
   __typename?: 'WWS_FontColorOptions',
  recommendedColors?: Maybe<Array<Wws_FontColorOptionGroup>>,
  recentlyUsedColors?: Maybe<Array<Wws_FontColorOptionGroup>>,
};

export type Wws_FontOverrides = {
   __typename?: 'WWS_FontOverrides',
  s1?: Maybe<Wws_ThemeOverrideFont>,
  s2?: Maybe<Wws_ThemeOverrideFont>,
  s3?: Maybe<Wws_ThemeOverrideFont>,
  s4?: Maybe<Wws_ThemeOverrideFont>,
  s5?: Maybe<Wws_ThemeOverrideFont>,
  s6?: Maybe<Wws_ThemeOverrideFont>,
  tiny?: Maybe<Wws_ThemeOverrideFont>,
  buttonFont?: Maybe<Wws_ThemeOverrideFont>,
  buttonHoverFont?: Maybe<Wws_ThemeOverrideFont>,
};

export type Wws_FontOverridesInput = {
  s1?: Maybe<Wws_ThemeOverrideFontInput>,
  s2?: Maybe<Wws_ThemeOverrideFontInput>,
  s3?: Maybe<Wws_ThemeOverrideFontInput>,
  s4?: Maybe<Wws_ThemeOverrideFontInput>,
  s5?: Maybe<Wws_ThemeOverrideFontInput>,
  s6?: Maybe<Wws_ThemeOverrideFontInput>,
  tiny?: Maybe<Wws_ThemeOverrideFontInput>,
  buttonFont?: Maybe<Wws_ThemeOverrideFontInput>,
  buttonHoverFont?: Maybe<Wws_ThemeOverrideFontInput>,
};

export type Wws_FontSetFont = {
   __typename?: 'WWS_FontSetFont',
  fontFamily?: Maybe<Scalars['String']>,
  fontWeight?: Maybe<Scalars['String']>,
  letterSpacing?: Maybe<Scalars['String']>,
  lineSpacing?: Maybe<Scalars['String']>,
  textTransform?: Maybe<Scalars['String']>,
  fontStyle?: Maybe<Scalars['String']>,
};

export type Wws_FontSetOption = {
   __typename?: 'WWS_FontSetOption',
  id?: Maybe<Scalars['String']>,
  yourNames?: Maybe<Wws_FontSetFont>,
  headline?: Maybe<Wws_FontSetFont>,
  paragraph?: Maybe<Wws_FontSetFont>,
};

export type Wws_FontSetOptionsData = {
   __typename?: 'WWS_FontSetOptionsData',
  currentFontSetId?: Maybe<Scalars['String']>,
  options?: Maybe<Array<Wws_FontSetOption>>,
};

export type Wws_GifItem = Wws_PageItem & {
   __typename?: 'WWS_GifItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  mediaApiId: Scalars['String'],
  mediaUrl: Scalars['String'],
  aspectRatio?: Maybe<Wws_AspectRatio>,
  guidance?: Maybe<Wws_PageItemGuidance>,
  originalPhoto?: Maybe<Scalars['String']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  height: Scalars['Int'],
  width: Scalars['Int'],
};

export type Wws_GroupItem = Wws_PageItem & {
   __typename?: 'WWS_GroupItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  childItems?: Maybe<Array<Wws_PageItem>>,
  aspectRatio?: Maybe<Wws_AspectRatio>,
  description?: Maybe<Scalars['String']>,
  guidance?: Maybe<Wws_PageItemGuidance>,
  originalPhoto?: Maybe<Scalars['String']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
};

export type Wws_HeadlineItem = Wws_PageItem & {
   __typename?: 'WWS_HeadlineItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  aspectRatio?: Maybe<Wws_AspectRatio>,
  guidance?: Maybe<Wws_PageItemGuidance>,
  originalPhoto?: Maybe<Scalars['String']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  style?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  mediaApiId?: Maybe<Scalars['String']>,
  height: Scalars['Int'],
  width: Scalars['Int'],
};

export type Wws_Image = {
   __typename?: 'WWS_Image',
  aspectRatio?: Maybe<Wws_AspectRatio>,
  caption?: Maybe<Scalars['String']>,
  columnNumber?: Maybe<Scalars['Int']>,
  galleryPath?: Maybe<Scalars['String']>,
  height?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Int']>,
  mediaApiId?: Maybe<Scalars['String']>,
  mediaUrl: Scalars['String'],
  path?: Maybe<Scalars['String']>,
  photoAlbumId?: Maybe<Scalars['Int']>,
  rank?: Maybe<Scalars['Int']>,
  rankedOrder?: Maybe<Scalars['Int']>,
  type?: Maybe<Scalars['String']>,
  width?: Maybe<Scalars['Int']>,
};

export type Wws_ImageOverrides = {
   __typename?: 'WWS_ImageOverrides',
  topImage?: Maybe<Wws_ThemeOverrideImage>,
  bottomImage?: Maybe<Wws_ThemeOverrideImage>,
};

export type Wws_ImageOverridesInput = {
  topImage?: Maybe<Wws_ThemeOverrideImageInput>,
  bottomImage?: Maybe<Wws_ThemeOverrideImageInput>,
};

export type Wws_ImageType = {
   __typename?: 'WWS_ImageType',
  aspectRatios: Array<Wws_AspectRatio>,
  defaultAspectRatio: Wws_AspectRatio,
  name: Scalars['String'],
};


export type Wws_LivestreamItem = Wws_PageItem & {
   __typename?: 'WWS_LivestreamItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  aspectRatio?: Maybe<Wws_AspectRatio>,
  buttonText?: Maybe<Scalars['String']>,
  buttonUrl?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  guidance?: Maybe<Wws_PageItemGuidance>,
  originalPhoto?: Maybe<Scalars['String']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  mediaApiId?: Maybe<Scalars['String']>,
  height: Scalars['Int'],
  width: Scalars['Int'],
};

export type Wws_Location = {
   __typename?: 'WWS_Location',
  addressComponents?: Maybe<Scalars['WWS_JSON']>,
  fullAddress?: Maybe<Scalars['String']>,
  googlePlaceId?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Int']>,
  venueName?: Maybe<Scalars['String']>,
};

export type Wws_LocationContent = {
   __typename?: 'WWS_LocationContent',
  aspectRatio?: Maybe<Wws_AspectRatio>,
  checkInDate?: Maybe<Scalars['String']>,
  checkOutDate?: Maybe<Scalars['String']>,
  confirmationState?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  expediaId?: Maybe<Scalars['String']>,
  guestCode?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Int']>,
  location?: Maybe<Wws_Location>,
  memberWeddingId?: Maybe<Scalars['Int']>,
  name?: Maybe<Scalars['String']>,
  notes?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['Int']>,
  originalPhoto?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rate?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  website?: Maybe<Scalars['String']>,
};

export type Wws_MediaApiImage = {
   __typename?: 'WWS_MediaApiImage',
  mediaApiId: Scalars['String'],
  path?: Maybe<Scalars['String']>,
};

export type Wws_MediaApiJwt = {
   __typename?: 'WWS_MediaApiJwt',
  token: Scalars['String'],
  expiration: Scalars['Float'],
};

export type Wws_OnboardingAttributes = {
  email?: Maybe<Scalars['String']>,
  fianceFirstName: Scalars['String'],
  fianceLastName?: Maybe<Scalars['String']>,
  firstDashboardInteraction?: Maybe<Scalars['String']>,
  firstName: Scalars['String'],
  hideCountdown?: Maybe<Scalars['Boolean']>,
  hideDate?: Maybe<Scalars['Boolean']>,
  lastName?: Maybe<Scalars['String']>,
  layout?: Maybe<Scalars['String']>,
  pin?: Maybe<Scalars['String']>,
  pinProtect?: Maybe<Scalars['Boolean']>,
  registryNote?: Maybe<Scalars['String']>,
  searchable?: Maybe<Scalars['Boolean']>,
  source?: Maybe<Scalars['String']>,
  /** DEPRECATED: Use the state specific mutation instead */
  state?: Maybe<Scalars['String']>,
  themeId?: Maybe<Scalars['Int']>,
  vanityUrl?: Maybe<Scalars['String']>,
  weddingLocation?: Maybe<Scalars['String']>,
  reverseCoupleNameOrder?: Maybe<Scalars['Boolean']>,
};

export type Wws_Page = {
   __typename?: 'WWS_Page',
  id: Scalars['Int'],
  rank?: Maybe<Scalars['Int']>,
  description?: Maybe<Scalars['String']>,
  routeName?: Maybe<Scalars['String']>,
  show?: Maybe<Scalars['Boolean']>,
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  items: Array<Wws_PageItem>,
  title?: Maybe<Scalars['String']>,
  type: Scalars['String'],
  pageItemGuidances?: Maybe<Array<Wws_PageItemGuidance>>,
  supportedImageTypes: Array<Wws_ImageType>,
  pageGuidance?: Maybe<Wws_PageGuidance>,
  pageItemTypes?: Maybe<Array<Scalars['String']>>,
  pageItems?: Maybe<Array<Wws_PageItem>>,
  sections?: Maybe<Array<Wws_Section>>,
  accommodationItems: Array<Wws_AccommodationItem>,
  accommodationItem?: Maybe<Wws_AccommodationItem>,
  activityItem?: Maybe<Wws_ActivityItem>,
  basicItem?: Maybe<Wws_BasicItem>,
  coverPhotoItem?: Maybe<Wws_CoverPhotoItem>,
  embedItem?: Maybe<Wws_EmbedItem>,
  gifItem?: Maybe<Wws_GifItem>,
  headlineItem?: Maybe<Wws_HeadlineItem>,
  livestreamItem?: Maybe<Wws_LivestreamItem>,
  paragraphItem?: Maybe<Wws_ParagraphItem>,
  personItem?: Maybe<Wws_PersonItem>,
  photoGalleryItem?: Maybe<Wws_PhotoGalleryItem>,
  photoItem?: Maybe<Wws_PhotoItem>,
  photoTimelineItem?: Maybe<Wws_PhotoTimelineItem>,
  questionItem?: Maybe<Wws_QuestionItem>,
  storyItem?: Maybe<Wws_StoryItem>,
  transportationItem?: Maybe<Wws_TransportationItem>,
};


export type Wws_PageAccommodationItemArgs = {
  id: Scalars['Int']
};


export type Wws_PageActivityItemArgs = {
  id: Scalars['Int']
};


export type Wws_PageBasicItemArgs = {
  id: Scalars['Int']
};


export type Wws_PageCoverPhotoItemArgs = {
  id: Scalars['Int']
};


export type Wws_PageEmbedItemArgs = {
  id: Scalars['Int']
};


export type Wws_PageGifItemArgs = {
  id: Scalars['Int']
};


export type Wws_PageHeadlineItemArgs = {
  id: Scalars['Int']
};


export type Wws_PageLivestreamItemArgs = {
  id: Scalars['Int']
};


export type Wws_PageParagraphItemArgs = {
  id: Scalars['Int']
};


export type Wws_PagePersonItemArgs = {
  id: Scalars['Int']
};


export type Wws_PagePhotoGalleryItemArgs = {
  id: Scalars['Int']
};


export type Wws_PagePhotoItemArgs = {
  id: Scalars['Int']
};


export type Wws_PagePhotoTimelineItemArgs = {
  id: Scalars['Int']
};


export type Wws_PageQuestionItemArgs = {
  id: Scalars['Int']
};


export type Wws_PageStoryItemArgs = {
  id: Scalars['Int']
};


export type Wws_PageTransportationItemArgs = {
  id: Scalars['Int']
};

export type Wws_PageAttributes = {
  title?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  show?: Maybe<Scalars['Boolean']>,
  rank?: Maybe<Scalars['Float']>,
  type?: Maybe<Wws_AllowedCreatePageType>,
};

export type Wws_PageGuidance = {
   __typename?: 'WWS_PageGuidance',
  hiddenPageDescription?: Maybe<Scalars['String']>,
  visiblePageDescription?: Maybe<Scalars['String']>,
};

export type Wws_PageItem = {
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
};

export type Wws_PageItemGuidance = {
   __typename?: 'WWS_PageItemGuidance',
  ctaText?: Maybe<Scalars['String']>,
  icon?: Maybe<Scalars['String']>,
  image?: Maybe<Wws_MediaApiImage>,
  type?: Maybe<Scalars['String']>,
};

export type Wws_ParagraphItem = Wws_PageItem & {
   __typename?: 'WWS_ParagraphItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  content: Scalars['String'],
  textContent: Scalars['String'],
  aspectRatio?: Maybe<Wws_AspectRatio>,
  guidance?: Maybe<Wws_PageItemGuidance>,
  originalPhoto?: Maybe<Scalars['String']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
};

export type Wws_PersonItem = Wws_PageItem & {
   __typename?: 'WWS_PersonItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  aspectRatio?: Maybe<Wws_AspectRatio>,
  description?: Maybe<Scalars['String']>,
  guidance?: Maybe<Wws_PageItemGuidance>,
  name?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  photo?: Maybe<Wws_Photo>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  role?: Maybe<Scalars['String']>,
  mediaApiId?: Maybe<Scalars['String']>,
  height: Scalars['Int'],
  width: Scalars['Int'],
};

export type Wws_Photo = {
   __typename?: 'WWS_Photo',
  mediaApiId: Scalars['String'],
  mediaUrl: Scalars['String'],
  originalMediaUrl: Scalars['String'],
  aspectRatio?: Maybe<Wws_AspectRatio>,
  caption?: Maybe<Scalars['String']>,
  cropX?: Maybe<Scalars['Int']>,
  cropY?: Maybe<Scalars['Int']>,
  height?: Maybe<Scalars['Int']>,
  rotation?: Maybe<Scalars['Int']>,
  timestamp?: Maybe<Scalars['String']>,
  width?: Maybe<Scalars['Int']>,
};

export type Wws_PhotoAlbum = {
   __typename?: 'WWS_PhotoAlbum',
  coverPhoto?: Maybe<Wws_Image>,
  fbAlbumId?: Maybe<Scalars['String']>,
  fbSync?: Maybe<Scalars['Boolean']>,
  id?: Maybe<Scalars['Int']>,
  images?: Maybe<Array<Wws_Image>>,
  importing?: Maybe<Scalars['Boolean']>,
  instagramAlbum?: Maybe<Scalars['Boolean']>,
  memberWeddingId?: Maybe<Scalars['Int']>,
  order?: Maybe<Scalars['Int']>,
  photos: Array<Wws_AlbumPhoto>,
  rank?: Maybe<Scalars['Int']>,
  title?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  updatedAt?: Maybe<Scalars['String']>,
};

export type Wws_PhotoAttributes = {
  mediaApiId?: Maybe<Scalars['String']>,
  cropX?: Maybe<Scalars['Int']>,
  cropY?: Maybe<Scalars['Int']>,
  height?: Maybe<Scalars['Int']>,
  rotation?: Maybe<Scalars['Int']>,
  width?: Maybe<Scalars['Int']>,
};

export type Wws_PhotoGalleryItem = Wws_PageItem & {
   __typename?: 'WWS_PhotoGalleryItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  photoItems: Array<Wws_PhotoItem>,
  layout: Scalars['String'],
  aspectRatio?: Maybe<Wws_AspectRatio>,
  guidance?: Maybe<Wws_PageItemGuidance>,
  originalPhoto?: Maybe<Scalars['String']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
};

export type Wws_PhotoItem = Wws_PageItem & {
   __typename?: 'WWS_PhotoItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  mediaApiId: Scalars['String'],
  mediaUrl: Scalars['String'],
  height: Scalars['Int'],
  width: Scalars['Int'],
  aspectRatio?: Maybe<Wws_AspectRatio>,
  caption?: Maybe<Scalars['String']>,
  cropX?: Maybe<Scalars['Int']>,
  cropY?: Maybe<Scalars['Int']>,
  date?: Maybe<Scalars['String']>,
  focalPoint?: Maybe<Array<Scalars['String']>>,
  guidance?: Maybe<Wws_PageItemGuidance>,
  originalPhoto?: Maybe<Scalars['String']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rotation?: Maybe<Scalars['Int']>,
};

export type Wws_PhotoTimelineItem = Wws_PageItem & {
   __typename?: 'WWS_PhotoTimelineItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  layout: Scalars['String'],
  photoItems: Array<Wws_PhotoItem>,
  aspectRatio?: Maybe<Wws_AspectRatio>,
  guidance?: Maybe<Wws_PageItemGuidance>,
  originalPhoto?: Maybe<Scalars['String']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  width?: Maybe<Scalars['String']>,
  height?: Maybe<Scalars['String']>,
  cropX?: Maybe<Scalars['String']>,
  cropY?: Maybe<Scalars['String']>,
};

export type Wws_PurchaseDomain = {
   __typename?: 'WWS_PurchaseDomain',
  createdAt: Scalars['String'],
  dateOfLastRenewal?: Maybe<Scalars['String']>,
  expirationDate?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Int']>,
  isExpired?: Maybe<Scalars['Boolean']>,
  isInRedemptionPeriod: Scalars['Boolean'],
  isRenewable?: Maybe<Scalars['Boolean']>,
  name?: Maybe<Scalars['String']>,
  renewalPrice: Scalars['Float'],
  showRenewal?: Maybe<Scalars['Boolean']>,
};

export type Wws_QuestionItem = Wws_PageItem & {
   __typename?: 'WWS_QuestionItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  answer: Scalars['String'],
  question: Scalars['String'],
  aspectRatio?: Maybe<Wws_AspectRatio>,
  guidance?: Maybe<Wws_PageItemGuidance>,
  originalPhoto?: Maybe<Scalars['String']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  mediaApiId?: Maybe<Scalars['String']>,
  height: Scalars['Int'],
  width: Scalars['Int'],
};

export type Wws_ReorderPageItemAttributes = {
  id: Scalars['Int'],
  rank: Scalars['Int'],
};

export type Wws_ReorderPageItemAttrs = {
  pageId: Scalars['Int'],
  pageItems: Array<Wws_ReorderPageItemAttributes>,
};

export type Wws_SearchDomain = {
   __typename?: 'WWS_SearchDomain',
  available: Scalars['Boolean'],
  isPremiumName: Scalars['Boolean'],
  name: Scalars['String'],
  price: Scalars['Float'],
};

export type Wws_Section = {
   __typename?: 'WWS_Section',
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Int']>,
  items?: Maybe<Array<Wws_SectionContent>>,
  rank?: Maybe<Scalars['Int']>,
  show?: Maybe<Scalars['Boolean']>,
  showTitle?: Maybe<Scalars['Boolean']>,
  title?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
};

export type Wws_SectionContent = Wws_SectionItem | Wws_Story | Wws_ContentItem | Wws_LocationContent | Wws_PhotoAlbum;

export type Wws_SectionItem = {
   __typename?: 'WWS_SectionItem',
  aspectRatio?: Maybe<Wws_AspectRatio>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Int']>,
  order?: Maybe<Scalars['Int']>,
  originalPhoto?: Maybe<Scalars['String']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
};

export type Wws_Story = {
   __typename?: 'WWS_Story',
  aspectRatio?: Maybe<Wws_AspectRatio>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Int']>,
  order?: Maybe<Scalars['Int']>,
  originalPhoto?: Maybe<Scalars['String']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
};

export type Wws_StoryItem = Wws_PageItem & {
   __typename?: 'WWS_StoryItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  aspectRatio?: Maybe<Wws_AspectRatio>,
  description?: Maybe<Scalars['String']>,
  guidances?: Maybe<Wws_PageItemGuidance>,
  originalPhoto?: Maybe<Scalars['String']>,
  photo?: Maybe<Wws_Photo>,
  photoHeight?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  mediaApiId?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  height: Scalars['Int'],
  width: Scalars['Int'],
  guidance?: Maybe<Wws_PageItemGuidance>,
};

export type Wws_Theme = {
   __typename?: 'WWS_Theme',
  active?: Maybe<Scalars['Boolean']>,
  batch?: Maybe<Scalars['Int']>,
  carouselImages?: Maybe<Scalars['WWS_JSON']>,
  categoryData?: Maybe<Scalars['WWS_JSON']>,
  cssFile?: Maybe<Scalars['String']>,
  designerUrl?: Maybe<Scalars['String']>,
  family?: Maybe<Scalars['String']>,
  folderPrefix?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Int']>,
  layoutCoverPhotoRatio?: Maybe<Scalars['String']>,
  layoutId?: Maybe<Scalars['Int']>,
  liteSite?: Maybe<Scalars['Boolean']>,
  mobilePreviewImage?: Maybe<Wws_Photo>,
  mobilePreviewUrl?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  previewImage?: Maybe<Wws_Photo>,
  previewUrl?: Maybe<Scalars['String']>,
  stationaryPreviewImage?: Maybe<Wws_Photo>,
  stationaryPreviewUrl?: Maybe<Scalars['String']>,
  styles?: Maybe<Array<Wws_ThemeStyle>>,
  swatchImage?: Maybe<Wws_Photo>,
  swatchUrl?: Maybe<Scalars['String']>,
  templateVersion: Scalars['Int'],
  testRank?: Maybe<Scalars['Int']>,
  thankYouUrl?: Maybe<Scalars['String']>,
  themeDesigner?: Maybe<Wws_ThemeDesigner>,
  themeStyles?: Maybe<Scalars['WWS_JSON']>,
  version?: Maybe<Scalars['Int']>,
  familyThemes: Array<Wws_Theme>,
};

export type Wws_ThemeDesigner = {
   __typename?: 'WWS_ThemeDesigner',
  companyName?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Int']>,
  logo?: Maybe<Scalars['String']>,
  logoHeight?: Maybe<Scalars['Int']>,
  logoWidth?: Maybe<Scalars['Int']>,
  name?: Maybe<Scalars['String']>,
  url?: Maybe<Scalars['String']>,
};

export type Wws_ThemeFilterOption = {
   __typename?: 'WWS_ThemeFilterOption',
  /** The display name of the theme filter option. Ex. "Classic and Elegant" */
  label: Scalars['String'],
  /** The key identifier for the theme filter option. Ex. "classic" */
  key: Scalars['String'],
};

export type Wws_ThemeFilterOptions = {
   __typename?: 'WWS_ThemeFilterOptions',
  colors: Array<Scalars['String']>,
  styles: Array<Scalars['String']>,
  themeStyles: Array<Wws_ThemeFilterOption>,
  seasons: Array<Scalars['String']>,
};

/** Order options for themes pagination. */
export enum Wws_ThemeOrder {
  /** Order by family ranked ascending */
  RankedAsc = 'RANKED_ASC',
  /** Order randomly */
  Random = 'RANDOM'
}

export type Wws_ThemeOverride = {
   __typename?: 'WWS_ThemeOverride',
  id?: Maybe<Scalars['Int']>,
  memberWeddingId?: Maybe<Scalars['Int']>,
  themeFamilySlug?: Maybe<Scalars['String']>,
  themeId?: Maybe<Scalars['Int']>,
  fontOverrides?: Maybe<Wws_FontOverrides>,
  colorOverrides?: Maybe<Wws_ColorOverrides>,
  imageOverrides?: Maybe<Wws_ImageOverrides>,
};

export type Wws_ThemeOverrideAttributes = {
  fontOverrides?: Maybe<Wws_FontOverridesInput>,
  colorOverrides?: Maybe<Wws_ColorOverridesInput>,
  imageOverrides?: Maybe<Wws_ImageOverridesInput>,
};

export type Wws_ThemeOverrideFont = {
   __typename?: 'WWS_ThemeOverrideFont',
  fontFamily?: Maybe<Scalars['String']>,
  fontSize?: Maybe<Scalars['String']>,
  fontWeight?: Maybe<Scalars['String']>,
  letterSpacing?: Maybe<Scalars['String']>,
  textTransform?: Maybe<Scalars['String']>,
  fontStyle?: Maybe<Scalars['String']>,
};

export type Wws_ThemeOverrideFontInput = {
  fontFamily?: Maybe<Scalars['String']>,
  fontSize?: Maybe<Scalars['String']>,
  fontWeight?: Maybe<Scalars['String']>,
  letterSpacing?: Maybe<Scalars['String']>,
  textTransform?: Maybe<Scalars['String']>,
};

export type Wws_ThemeOverrideImage = {
   __typename?: 'WWS_ThemeOverrideImage',
  desktopSrc?: Maybe<Scalars['String']>,
  mobileSrc?: Maybe<Scalars['String']>,
};

export type Wws_ThemeOverrideImageInput = {
  desktopSrc?: Maybe<Scalars['String']>,
  mobileSrc?: Maybe<Scalars['String']>,
};

export type Wws_ThemeOverrideOptionValue = {
   __typename?: 'WWS_ThemeOverrideOptionValue',
  label: Scalars['String'],
  value: Scalars['String'],
};

export type Wws_ThemeStyle = {
   __typename?: 'WWS_ThemeStyle',
  color?: Maybe<Scalars['String']>,
  element?: Maybe<Scalars['String']>,
  fontFamily?: Maybe<Scalars['String']>,
  fontSize?: Maybe<Scalars['String']>,
  fontStyle?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Int']>,
  name?: Maybe<Scalars['String']>,
};

export type Wws_ThemeSummary = {
   __typename?: 'WWS_ThemeSummary',
  active?: Maybe<Scalars['Boolean']>,
  batch?: Maybe<Scalars['Int']>,
  carouselImages?: Maybe<Scalars['WWS_JSON']>,
  categoryData?: Maybe<Scalars['WWS_JSON']>,
  cssFile?: Maybe<Scalars['String']>,
  designerUrl?: Maybe<Scalars['String']>,
  family?: Maybe<Scalars['String']>,
  folderPrefix?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Int']>,
  layoutCoverPhotoRatio?: Maybe<Scalars['String']>,
  layoutId?: Maybe<Scalars['Int']>,
  liteSite?: Maybe<Scalars['Boolean']>,
  mobilePreviewImage?: Maybe<Wws_Photo>,
  mobilePreviewUrl?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  previewImage?: Maybe<Wws_Photo>,
  previewUrl?: Maybe<Scalars['String']>,
  stationaryPreviewImage?: Maybe<Wws_Photo>,
  stationaryPreviewUrl?: Maybe<Scalars['String']>,
  swatchImage?: Maybe<Wws_Photo>,
  swatchUrl?: Maybe<Scalars['String']>,
  templateVersion: Scalars['Int'],
  testRank?: Maybe<Scalars['Int']>,
  thankYouUrl?: Maybe<Scalars['String']>,
  themeDesigner?: Maybe<Wws_ThemeDesigner>,
  version?: Maybe<Scalars['Int']>,
  favoriteId?: Maybe<Scalars['String']>,
};

export type Wws_TransportationItem = Wws_PageItem & {
   __typename?: 'WWS_TransportationItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  address?: Maybe<Scalars['String']>,
  aspectRatio?: Maybe<Wws_AspectRatio>,
  description?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  guidance?: Maybe<Wws_PageItemGuidance>,
  name?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  photo?: Maybe<Wws_Photo>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  website?: Maybe<Scalars['String']>,
  mediaApiId?: Maybe<Scalars['String']>,
  height: Scalars['Int'],
  width: Scalars['Int'],
};

export type Wws_UpdateAccommodationItemAttrs = {
  id: Scalars['Int'],
  pageId: Scalars['Int'],
  rank?: Maybe<Scalars['Float']>,
  address?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  photo?: Maybe<Wws_PhotoAttributes>,
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  website?: Maybe<Scalars['String']>,
  checkInDate?: Maybe<Scalars['String']>,
  checkOutDate?: Maybe<Scalars['String']>,
  guestCode?: Maybe<Scalars['String']>,
  hotelId?: Maybe<Scalars['String']>,
  provider?: Maybe<Scalars['String']>,
  rate?: Maybe<Scalars['String']>,
};

export type Wws_UpdateAnnouncementAttributes = {
  /** The icon must be a stringified number */
  icon?: Maybe<Scalars['String']>,
  message: Scalars['String'],
  show?: Maybe<Scalars['Boolean']>,
  title?: Maybe<Scalars['String']>,
};

export type Wws_UpdateBasicItemAttrs = {
  id: Scalars['Int'],
  rank?: Maybe<Scalars['Float']>,
  description?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  photo?: Maybe<Wws_PhotoAttributes>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
};

export type Wws_UpdateBusinessItemAttrs = {
  id: Scalars['Int'],
  pageId: Scalars['Int'],
  rank?: Maybe<Scalars['Float']>,
  address?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  photo?: Maybe<Wws_PhotoAttributes>,
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  website?: Maybe<Scalars['String']>,
};

export type Wws_UpdateDressCodeItemAttrs = {
  id: Scalars['Int'],
  pageId: Scalars['Int'],
  rank?: Maybe<Scalars['Float']>,
  /** Sanitized HTML (em,strong,a,p) */
  description?: Maybe<Scalars['String']>,
  /** Related event id */
  eventId?: Maybe<Scalars['String']>,
  /** Attire category code */
  attireCategoryId?: Maybe<Scalars['String']>,
  /** Plain text attire guidance */
  attireDescription?: Maybe<Scalars['String']>,
  /** Defaults true */
  showArticles?: Maybe<Scalars['Boolean']>,
  /** Defaults true */
  showAffiliates?: Maybe<Scalars['Boolean']>,
};

export type Wws_UpdateEmbedItemAttrs = {
  description?: Maybe<Scalars['String']>,
  embededCode?: Maybe<Scalars['String']>,
  id: Scalars['Int'],
  originalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
  title?: Maybe<Scalars['String']>,
};

export type Wws_UpdateGifItemAttrs = {
  id: Scalars['Int'],
  mediaApiId?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  parentItemId?: Maybe<Scalars['Int']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
};

export type Wws_UpdateHeadlineItemAttrs = {
  id: Scalars['Int'],
  orignalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
  style?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
};

export type Wws_UpdateLivestreamItemAttrs = {
  buttonText?: Maybe<Scalars['String']>,
  buttonUrl?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  id: Scalars['Int'],
  originalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
  title?: Maybe<Scalars['String']>,
};

export type Wws_UpdatePageAttributes = {
  /** ID of the page. */
  id?: Maybe<Scalars['Int']>,
  title?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  show?: Maybe<Scalars['Boolean']>,
  rank?: Maybe<Scalars['Float']>,
};

export type Wws_UpdateParagraphItemAttrs = {
  content?: Maybe<Scalars['String']>,
  id: Scalars['Int'],
  originalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
};

export type Wws_UpdatePersonItemAttrs = {
  description?: Maybe<Scalars['String']>,
  id: Scalars['Int'],
  name?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  photo?: Maybe<Wws_PhotoAttributes>,
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
  role?: Maybe<Scalars['String']>,
};

export type Wws_UpdatePhotoGalleryItemAttrs = {
  id: Scalars['Int'],
  layout?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  photoHeight?: Maybe<Scalars['String']>,
  photoItems?: Maybe<Array<Wws_UpdatePhotoGalleryItemPhotoItemAttrs>>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
};

export type Wws_UpdatePhotoGalleryItemPhotoItemAttrs = {
  caption?: Maybe<Scalars['String']>,
  cropX?: Maybe<Scalars['Int']>,
  cropY?: Maybe<Scalars['Int']>,
  date?: Maybe<Scalars['String']>,
  focalPoint?: Maybe<Array<Scalars['String']>>,
  height?: Maybe<Scalars['Int']>,
  mediaApiId?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  parentItemId?: Maybe<Scalars['Int']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
  rotation?: Maybe<Scalars['Int']>,
  width?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Int']>,
};

export type Wws_UpdatePhotoItemAttrs = {
  caption?: Maybe<Scalars['String']>,
  cropX?: Maybe<Scalars['Int']>,
  cropY?: Maybe<Scalars['Int']>,
  date?: Maybe<Scalars['String']>,
  focalPoint?: Maybe<Array<Scalars['String']>>,
  height?: Maybe<Scalars['Int']>,
  id: Scalars['Int'],
  mediaApiId?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  parentItemId?: Maybe<Scalars['Int']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
  rotation?: Maybe<Scalars['Int']>,
  width?: Maybe<Scalars['Int']>,
};

export type Wws_UpdatePhotoTimelineItemAttrs = {
  id: Scalars['Int'],
  layout?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  photoHeight?: Maybe<Scalars['String']>,
  photoItems?: Maybe<Array<Wws_UpdatePhotoTimelineItemPhotoItemAttrs>>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
};

export type Wws_UpdatePhotoTimelineItemPhotoItemAttrs = {
  caption?: Maybe<Scalars['String']>,
  cropX?: Maybe<Scalars['Int']>,
  cropY?: Maybe<Scalars['Int']>,
  date?: Maybe<Scalars['String']>,
  focalPoint?: Maybe<Array<Scalars['String']>>,
  height?: Maybe<Scalars['Int']>,
  mediaApiId?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  parentItemId?: Maybe<Scalars['Int']>,
  photoHeight?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
  rotation?: Maybe<Scalars['Int']>,
  width?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Int']>,
};

/** Attributes for renewing a custom domain */
export type Wws_UpdatePurchaseDomainAttrs = {
  /** Braintree nonce token */
  paymentMethodNonce: Scalars['String'],
  /** The duration of the registry in years */
  years: Scalars['Float'],
};

export type Wws_UpdateQuestionItemAttrs = {
  answer?: Maybe<Scalars['String']>,
  id: Scalars['Int'],
  originalPhoto?: Maybe<Scalars['String']>,
  photoHeight?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Float']>,
  question?: Maybe<Scalars['String']>,
};

export type Wws_UpdateStoryItemAttrs = {
  id: Scalars['Int'],
  rank?: Maybe<Scalars['Float']>,
  description?: Maybe<Scalars['String']>,
  originalPhoto?: Maybe<Scalars['String']>,
  photo?: Maybe<Wws_PhotoAttributes>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  pageId: Scalars['Int'],
};

export type Wws_Version = {
   __typename?: 'WWS_Version',
  name: Scalars['String'],
};

export type Wws_WeddingPartyItem = Wws_PageItem & {
   __typename?: 'WWS_WeddingPartyItem',
  id: Scalars['Int'],
  rank: Scalars['Float'],
  type: Scalars['String'],
  updatedAt?: Maybe<Scalars['WWS_DateTime']>,
  aspectRatio?: Maybe<Wws_AspectRatio>,
  childItems?: Maybe<Array<Wws_PageItem>>,
  description?: Maybe<Scalars['String']>,
  guidance?: Maybe<Wws_PageItemGuidance>,
  originalPhoto?: Maybe<Scalars['String']>,
  people?: Maybe<Array<Wws_PageItem>>,
  photoHeight?: Maybe<Scalars['String']>,
  photoId?: Maybe<Scalars['String']>,
  photoPath?: Maybe<Scalars['String']>,
  photoWidth?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
};

export type Wws_WeddingWebsite = {
   __typename?: 'WWS_WeddingWebsite',
  id: Scalars['Int'],
  adminVersion: Scalars['String'],
  countdownDays?: Maybe<Scalars['Int']>,
  announcement?: Maybe<Wws_Announcement>,
  coverPhoto?: Maybe<Wws_Photo>,
  contentItems?: Maybe<Array<Wws_ContentItem>>,
  coverPhotoPathWithCropbox?: Maybe<Scalars['String']>,
  firstDashboardInteraction?: Maybe<Scalars['String']>,
  guestListOnly: Scalars['Boolean'],
  hideCountdown?: Maybe<Scalars['Boolean']>,
  hideDate?: Maybe<Scalars['Boolean']>,
  isNewAdmin: Scalars['Boolean'],
  isNewTemplate: Scalars['Boolean'],
  layout?: Maybe<Scalars['String']>,
  legacyMigrated?: Maybe<Scalars['Boolean']>,
  pages?: Maybe<Array<Wws_Page>>,
  pin?: Maybe<Scalars['String']>,
  pinProtect?: Maybe<Scalars['Boolean']>,
  privateRsvp?: Maybe<Scalars['Boolean']>,
  purchaseDomain?: Maybe<Wws_PurchaseDomain>,
  registryNote?: Maybe<Scalars['String']>,
  rsvpableEventCount?: Maybe<Scalars['Int']>,
  reverseCoupleNameOrder?: Maybe<Scalars['Boolean']>,
  searchEngineIndexable: Scalars['Boolean'],
  searchable?: Maybe<Scalars['Boolean']>,
  slug: Scalars['String'],
  source?: Maybe<Scalars['String']>,
  state: Scalars['String'],
  themeId?: Maybe<Scalars['Int']>,
  userUuid?: Maybe<Scalars['String']>,
  vanityRoot?: Maybe<Scalars['String']>,
  vanityUrl?: Maybe<Scalars['String']>,
  websiteCreatedAt?: Maybe<Scalars['WWS_DateTime']>,
  wwsInitializedAt?: Maybe<Scalars['WWS_DateTime']>,
  websiteDisabledAt?: Maybe<Scalars['WWS_DateTime']>,
  weddingDateFormat?: Maybe<Scalars['String']>,
  weddingDateRangeEnd?: Maybe<Scalars['WWS_DateTime']>,
  weddingDateRangeStart?: Maybe<Scalars['WWS_DateTime']>,
  weddingLocation?: Maybe<Scalars['String']>,
  weddingUuid?: Maybe<Scalars['String']>,
  wwsUrl: Scalars['String'],
  locationContents?: Maybe<Array<Wws_LocationContent>>,
  stories?: Maybe<Array<Wws_Story>>,
  theme?: Maybe<Wws_Theme>,
  photoAlbums?: Maybe<Array<Wws_PhotoAlbum>>,
};


export type Wws_WeddingWebsiteThemeArgs = {
  id?: Maybe<Scalars['Int']>
};

export type Wws_WeddingWebsiteAttributes = {
  firstDashboardInteraction?: Maybe<Scalars['String']>,
  hideCountdown?: Maybe<Scalars['Boolean']>,
  hideDate?: Maybe<Scalars['Boolean']>,
  layout?: Maybe<Scalars['String']>,
  pin?: Maybe<Scalars['String']>,
  pinProtect?: Maybe<Scalars['Boolean']>,
  registryNote?: Maybe<Scalars['String']>,
  searchable?: Maybe<Scalars['Boolean']>,
  source?: Maybe<Scalars['String']>,
  /** DEPRECATED: Use the state specific mutation instead */
  state?: Maybe<Scalars['String']>,
  themeId?: Maybe<Scalars['Int']>,
  vanityUrl?: Maybe<Scalars['String']>,
  weddingDateFormat?: Maybe<Scalars['String']>,
  weddingDateRangeEnd?: Maybe<Scalars['WWS_DateTime']>,
  weddingDateRangeStart?: Maybe<Scalars['WWS_DateTime']>,
  weddingLocation?: Maybe<Scalars['String']>,
  reverseCoupleNameOrder?: Maybe<Scalars['Boolean']>,
};

export type Wws_WeddingWebsitePromotion = {
   __typename?: 'WWS_WeddingWebsitePromotion',
  id: Scalars['Int'],
  dismissed: Scalars['Boolean'],
  description?: Maybe<Scalars['String']>,
  dismissedAt?: Maybe<Scalars['WWS_DateTime']>,
  imageUrl?: Maybe<Scalars['String']>,
  kind?: Maybe<Scalars['String']>,
  lastImpressionAt?: Maybe<Scalars['WWS_DateTime']>,
  mainCtaUrl?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
};

export type WwsViewCount = {
   __typename?: 'WWSViewCount',
  member_id?: Maybe<Scalars['ID']>,
  website_visitors_total?: Maybe<Scalars['Int']>,
  website_visitors_recent?: Maybe<Scalars['Int']>,
};

export type FlipperExperimentBucketAssignmentQueryVariables = {
  flipperExperimentBucketId: Scalars['String'],
  flipperExperimentBucketExperimentId: Scalars['String']
};


export type FlipperExperimentBucketAssignmentQuery = { __typename?: 'Query', flipperExperimentBucketAssignment: Maybe<{ __typename?: 'ExperimentBucket', bucketing_id: string, variant_name: string }> };

export type VariantContextMembershipQueryVariables = {};


export type VariantContextMembershipQuery = { __typename?: 'Query', member: Maybe<{ __typename?: 'Member', id: string, firstName: Maybe<string>, lastName: Maybe<string>, fianceFirstName: Maybe<string>, fianceLastName: Maybe<string>, email: string, legacyUserId: Maybe<string>, username: Maybe<string> }> };

export type VariantContextThemesQueryVariables = {
  variant?: Maybe<Wws_FamilyThemeVariant>
};


export type VariantContextThemesQuery = { __typename?: 'Query', familyThemes: Array<{ __typename?: 'WWS_FamilyThemeType', family: Maybe<string>, themes: Maybe<Array<{ __typename?: 'WWS_Theme', active: Maybe<boolean>, designerUrl: Maybe<string>, family: Maybe<string>, id: Maybe<number>, name: Maybe<string>, previewUrl: Maybe<string>, mobilePreviewImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string }>, previewImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string }>, swatchImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string }>, stationaryPreviewImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string }>, themeDesigner: Maybe<{ __typename?: 'WWS_ThemeDesigner', companyName: Maybe<string>, name: Maybe<string> }> }>> }> };

export type UpdateConversationalAiSettingsMutationVariables = {
  args?: Maybe<AiSettingsArgs>
};


export type UpdateConversationalAiSettingsMutation = { __typename?: 'Mutation', updateConversationalAiSettings: Maybe<boolean> };

export type UpdateDatePrefMutationBasicInfoRailMutationVariables = {
  weddingDatePrefAttrs: UpdateWeddingDatePreferencesArgs
};


export type UpdateDatePrefMutationBasicInfoRailMutation = { __typename?: 'Mutation', updateWeddingDatePreferences: Maybe<{ __typename?: 'WeddingDatePreferences', datePreference: Maybe<DatePreference>, year: Maybe<number>, season: Maybe<SeasonName>, hideDate: Maybe<boolean>, weddingDate: Maybe<string>, weddingDateFormat: Maybe<string>, weddingDateRangeStart: Maybe<string>, weddingDateRangeEnd: Maybe<string>, hideCountdown: Maybe<boolean> }> };

export type CreateAnnouncementMutationVariables = {
  attributes: Wws_CreateAnnouncementAttrs
};


export type CreateAnnouncementMutation = { __typename?: 'Mutation', createAnnouncement: { __typename?: 'WWS_Announcement', id: Maybe<number>, message: string, show: boolean } };

export type UpdateAnnouncementMutationVariables = {
  attributes: Wws_UpdateAnnouncementAttributes
};


export type UpdateAnnouncementMutation = { __typename?: 'Mutation', updateAnnouncement: { __typename?: 'WWS_Announcement', id: Maybe<number>, message: string, show: boolean } };

export type WeddingDatePreferencesQueryVariables = {};


export type WeddingDatePreferencesQuery = { __typename?: 'Query', weddingDatePreferences: Maybe<{ __typename?: 'WeddingDatePreferences', datePreference: Maybe<DatePreference>, hideDate: Maybe<boolean>, season: Maybe<SeasonName>, year: Maybe<number>, weddingDate: Maybe<string>, weddingDateFormat: Maybe<string>, weddingDateRangeStart: Maybe<string>, weddingDateRangeEnd: Maybe<string>, hideCountdown: Maybe<boolean> }> };

export type WeddingWebsiteQueryVariables = {};


export type WeddingWebsiteQuery = { __typename?: 'Query', weddingWebsite: { __typename?: 'WWS_WeddingWebsite', id: number, legacyMigrated: Maybe<boolean>, searchable: Maybe<boolean>, pin: Maybe<string>, pinProtect: Maybe<boolean>, state: string, websiteCreatedAt: Maybe<any>, source: Maybe<string>, vanityRoot: Maybe<string>, vanityUrl: Maybe<string>, slug: string, registryNote: Maybe<string>, hideCountdown: Maybe<boolean>, hideDate: Maybe<boolean>, weddingDateFormat: Maybe<string>, weddingDateRangeStart: Maybe<any>, weddingDateRangeEnd: Maybe<any>, weddingLocation: Maybe<string>, themeId: Maybe<number>, firstDashboardInteraction: Maybe<string>, adminVersion: string, isNewTemplate: boolean, wwsUrl: string, layout: Maybe<string>, announcement: Maybe<{ __typename?: 'WWS_Announcement', id: Maybe<number>, message: string, show: boolean }>, purchaseDomain: Maybe<{ __typename?: 'WWS_PurchaseDomain', id: Maybe<number>, name: Maybe<string>, showRenewal: Maybe<boolean>, isRenewable: Maybe<boolean>, isInRedemptionPeriod: boolean, isExpired: Maybe<boolean>, expirationDate: Maybe<string>, dateOfLastRenewal: Maybe<string>, renewalPrice: number, createdAt: string }>, coverPhoto: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string, mediaUrl: string, cropX: Maybe<number>, cropY: Maybe<number>, width: Maybe<number>, height: Maybe<number>, originalMediaUrl: string }> }, member: Maybe<{ __typename?: 'Member', id: string, firstName: Maybe<string>, lastName: Maybe<string>, fianceFirstName: Maybe<string>, fianceLastName: Maybe<string>, email: string, isEmailVerified: Maybe<boolean>, aiSettings: Maybe<{ __typename?: 'AISettings', useConversationalMemory: Maybe<boolean> }> }>, wedding: Maybe<{ __typename?: 'Wedding', id: string, weddingDate: string, guestRange: string, season: Maybe<{ __typename?: 'Season', name: Maybe<SeasonName>, year: Maybe<number> }> }>, guestWedding: Maybe<{ __typename?: 'GDS_GuestWedding', id: string, createdAt: string, updatedAt: string, isPrivateRsvp: Maybe<boolean>, sendRsvpReminder: Maybe<boolean>, allowGuestPreview: Maybe<boolean>, usesSubEvents: Maybe<boolean>, rsvpDeadline: Maybe<string>, rsvpMedium: Maybe<string>, rsvpPageHidden: Maybe<boolean>, rsvpWorkflow: Maybe<boolean>, questions: Maybe<Array<{ __typename?: 'GDS_Question', id: string, text: Maybe<string>, type: Maybe<string>, isRequired: Maybe<boolean>, answerType: Maybe<string>, answerDestination: Maybe<string>, options: Maybe<Array<{ __typename?: 'GDS_Option', id: string, text: Maybe<string>, description: Maybe<string> }>> }>> }> };

export type ReactivateWeddingWebsiteMutationVariables = {};


export type ReactivateWeddingWebsiteMutation = { __typename?: 'Mutation', reactivateWeddingWebsite: { __typename?: 'WWS_WeddingWebsite', id: number, state: string } };

export type UpdateFirstInteractionMutationVariables = {
  attributes: Wws_WeddingWebsiteAttributes
};


export type UpdateFirstInteractionMutation = { __typename?: 'Mutation', updateWeddingWebsite: { __typename?: 'WWS_WeddingWebsite', id: number, firstDashboardInteraction: Maybe<string> } };

export type WwsViewCountQueryVariables = {};


export type WwsViewCountQuery = { __typename?: 'Query', wwsViewCount: Maybe<{ __typename?: 'WWSViewCount', website_visitors_total: Maybe<number>, website_visitors_recent: Maybe<number> }> };

export type BucketRsvpWorkflowMutationVariables = {};


export type BucketRsvpWorkflowMutation = { __typename?: 'Mutation', bucketRSVPWorkflow: { __typename?: 'GDS_GuestWedding', id: string, rsvpWorkflow: Maybe<boolean>, rsvpPageHidden: Maybe<boolean> } };

export type PhotosFragment = { __typename?: 'WWS_Photo', mediaUrl: string, mediaApiId: string, width: Maybe<number>, height: Maybe<number>, cropX: Maybe<number>, cropY: Maybe<number>, rotation: Maybe<number>, aspectRatio: Maybe<{ __typename?: 'WWS_AspectRatio', name: string, value: number }> };

export type BasicItemsFragment = { __typename?: 'WWS_BasicItem', id: number, description: Maybe<string>, title: Maybe<string>, rank: number, type: string, photo: Maybe<(
    { __typename?: 'WWS_Photo' }
    & PhotosFragment
  )> };

export type StoryItemsFragment = { __typename?: 'WWS_StoryItem', id: number, description: Maybe<string>, title: Maybe<string>, rank: number, type: string, photo: Maybe<(
    { __typename?: 'WWS_Photo' }
    & PhotosFragment
  )> };

export type HeadlineItemsFragment = { __typename?: 'WWS_HeadlineItem', id: number, title: Maybe<string>, type: string, style: Maybe<string>, rank: number };

export type PhotoGalleryItemsFragment = { __typename?: 'WWS_PhotoGalleryItem', id: number, layout: string, rank: number, type: string, photoItems: Array<(
    { __typename?: 'WWS_PhotoItem' }
    & PhotoItemsFragment
  )> };

export type PhotoTimelineItemsFragment = { __typename?: 'WWS_PhotoTimelineItem', id: number, layout: string, rank: number, type: string, photoItems: Array<(
    { __typename?: 'WWS_PhotoItem' }
    & PhotoItemsFragment
  )> };

export type ParagraphItemsFragment = { __typename?: 'WWS_ParagraphItem', id: number, content: string, textContent: string, type: string, rank: number };

export type PersonItemsFragment = { __typename?: 'WWS_PersonItem', id: number, type: string, name: Maybe<string>, description: Maybe<string>, role: Maybe<string>, rank: number, photo: Maybe<(
    { __typename?: 'WWS_Photo' }
    & PhotosFragment
  )> };

export type AccommodationItemsFragment = { __typename?: 'WWS_AccommodationItem', id: number, email: Maybe<string>, rank: number, type: string, description: Maybe<string>, name: Maybe<string>, phone: Maybe<string>, website: Maybe<string>, address: Maybe<string>, guestCode: Maybe<string>, rate: Maybe<string>, checkInDate: Maybe<string>, checkOutDate: Maybe<string>, hotelPlannerId: Maybe<number>, hotelId: Maybe<string>, provider: Maybe<string>, photo: Maybe<(
    { __typename?: 'WWS_Photo' }
    & PhotosFragment
  )> };

export type ActivityItemsFragment = { __typename?: 'WWS_ActivityItem', id: number, rank: number, type: string, phone: Maybe<string>, description: Maybe<string>, email: Maybe<string>, website: Maybe<string>, address: Maybe<string>, name: Maybe<string>, photo: Maybe<(
    { __typename?: 'WWS_Photo' }
    & PhotosFragment
  )> };

export type TransportationItemsFragment = { __typename?: 'WWS_TransportationItem', id: number, rank: number, type: string, name: Maybe<string>, phone: Maybe<string>, address: Maybe<string>, website: Maybe<string>, description: Maybe<string>, email: Maybe<string>, photo: Maybe<(
    { __typename?: 'WWS_Photo' }
    & PhotosFragment
  )> };

export type PhotoItemsFragment = { __typename?: 'WWS_PhotoItem', id: number, cropX: Maybe<number>, cropY: Maybe<number>, height: number, mediaApiId: string, mediaUrl: string, rank: number, rotation: Maybe<number>, type: string, width: number, date: Maybe<string>, caption: Maybe<string>, aspectRatio: Maybe<{ __typename?: 'WWS_AspectRatio', name: string, value: number }> };

export type CoverPhotoItemsFragment = { __typename?: 'WWS_CoverPhotoItem', id: number, cropX: Maybe<number>, cropY: Maybe<number>, focalPoint: Maybe<Array<string>>, height: number, mediaApiId: string, mediaUrl: string, rank: number, rotation: Maybe<number>, type: string, width: number, date: Maybe<string>, caption: Maybe<string>, aspectRatio: Maybe<{ __typename?: 'WWS_AspectRatio', name: string, value: number }> };

export type EventGroupItemFragment = { __typename?: 'WWS_EventGroupItem', id: number, rank: number, type: string };

export type GifItemsFragment = { __typename?: 'WWS_GifItem', id: number, rank: number, type: string, mediaUrl: string };

export type EmbedItemsFragment = { __typename?: 'WWS_EmbedItem', id: number, rank: number, type: string, title: Maybe<string>, description: Maybe<string>, embededCode: string, mediaService: string };

export type QuestionItemsFragment = { __typename?: 'WWS_QuestionItem', id: number, rank: number, type: string, question: string, answer: string };

export type LivestreamItemsFragment = { __typename?: 'WWS_LivestreamItem', id: number, rank: number, type: string, title: Maybe<string>, description: Maybe<string>, buttonText: Maybe<string>, buttonUrl: Maybe<string> };

export type DressCodeItemsFragment = { __typename?: 'WWS_DressCodeItem', id: number, rank: number, type: string, description: Maybe<string>, attireCategoryId: Maybe<string>, attireDescription: Maybe<string>, eventId: Maybe<string>, showArticles: Maybe<boolean>, showAffiliates: Maybe<boolean>, articles: Maybe<Array<{ __typename?: 'WWS_DressCodeArticle', url: string, imageUrl: string, title: string }>> };

export type PagesFragment = { __typename?: 'WWS_Page', id: number, title: Maybe<string>, rank: Maybe<number>, show: Maybe<boolean>, type: string, pageItemTypes: Maybe<Array<string>>, routeName: Maybe<string>, pageGuidance: Maybe<{ __typename?: 'WWS_PageGuidance', visiblePageDescription: Maybe<string>, hiddenPageDescription: Maybe<string> }>, pageItemGuidances: Maybe<Array<{ __typename?: 'WWS_PageItemGuidance', type: Maybe<string>, icon: Maybe<string>, ctaText: Maybe<string>, image: Maybe<{ __typename?: 'WWS_MediaApiImage', mediaApiId: string }> }>>, supportedImageTypes: Array<{ __typename?: 'WWS_ImageType', name: string, defaultAspectRatio: { __typename?: 'WWS_AspectRatio', name: string, value: number }, aspectRatios: Array<{ __typename?: 'WWS_AspectRatio', name: string, value: number }> }>, items: Array<(
    { __typename?: 'WWS_AccommodationItem', id: number, rank: number, type: string }
    & AccommodationItemsFragment
  ) | (
    { __typename?: 'WWS_ActivityItem', id: number, rank: number, type: string }
    & ActivityItemsFragment
  ) | (
    { __typename?: 'WWS_BasicItem', id: number, rank: number, type: string }
    & BasicItemsFragment
  ) | (
    { __typename?: 'WWS_CoverPhotoItem', id: number, rank: number, type: string }
    & CoverPhotoItemsFragment
  ) | (
    { __typename?: 'WWS_EmbedItem', id: number, rank: number, type: string }
    & EmbedItemsFragment
  ) | (
    { __typename?: 'WWS_GifItem', id: number, rank: number, type: string }
    & GifItemsFragment
  ) | (
    { __typename?: 'WWS_HeadlineItem', id: number, rank: number, type: string }
    & HeadlineItemsFragment
  ) | (
    { __typename?: 'WWS_LivestreamItem', id: number, rank: number, type: string }
    & LivestreamItemsFragment
  ) | (
    { __typename?: 'WWS_ParagraphItem', id: number, rank: number, type: string }
    & ParagraphItemsFragment
  ) | (
    { __typename?: 'WWS_PersonItem', id: number, rank: number, type: string }
    & PersonItemsFragment
  ) | (
    { __typename?: 'WWS_PhotoGalleryItem', id: number, rank: number, type: string }
    & PhotoGalleryItemsFragment
  ) | (
    { __typename?: 'WWS_PhotoItem', id: number, rank: number, type: string }
    & PhotoItemsFragment
  ) | (
    { __typename?: 'WWS_PhotoTimelineItem', id: number, rank: number, type: string }
    & PhotoTimelineItemsFragment
  ) | (
    { __typename?: 'WWS_QuestionItem', id: number, rank: number, type: string }
    & QuestionItemsFragment
  ) | (
    { __typename?: 'WWS_StoryItem', id: number, rank: number, type: string }
    & StoryItemsFragment
  ) | (
    { __typename?: 'WWS_TransportationItem', id: number, rank: number, type: string }
    & TransportationItemsFragment
  ) | (
    { __typename?: 'WWS_DressCodeItem', id: number, rank: number, type: string }
    & DressCodeItemsFragment
  ) | (
    { __typename?: 'WWS_EventGroupItem', id: number, rank: number, type: string }
    & EventGroupItemFragment
  ) | { __typename?: 'WWS_GroupItem', id: number, rank: number, type: string } | { __typename?: 'WWS_WeddingPartyItem', id: number, rank: number, type: string }> };

export type PagesQueryVariables = {};


export type PagesQuery = { __typename?: 'Query', pages: Array<(
    { __typename?: 'WWS_Page' }
    & PagesFragment
  )> };

export type CreateCoverPhotoItemMutationVariables = {
  attributes: Wws_CreatePhotoItemAttrs
};


export type CreateCoverPhotoItemMutation = { __typename?: 'Mutation', coverPhotoItem: { __typename?: 'WWS_CoverPhotoItem', id: number, cropX: Maybe<number>, cropY: Maybe<number>, focalPoint: Maybe<Array<string>>, height: number, mediaApiId: string, mediaUrl: string, rank: number, rotation: Maybe<number>, type: string, width: number, date: Maybe<string>, caption: Maybe<string>, aspectRatio: Maybe<{ __typename?: 'WWS_AspectRatio', name: string, value: number }> } };

export type UpdateCoverPhotoItemMutationVariables = {
  attributes: Wws_UpdatePhotoItemAttrs
};


export type UpdateCoverPhotoItemMutation = { __typename?: 'Mutation', coverPhotoItem: (
    { __typename?: 'WWS_CoverPhotoItem', id: number }
    & CoverPhotoItemsFragment
  ) };

export type DeleteCoverPhotoItemMutationVariables = {
  attributes: Wws_DeletePageItemAttributes
};


export type DeleteCoverPhotoItemMutation = { __typename?: 'Mutation', deletePageItem: number };

export type CreatePageMutationVariables = {
  attributes: Wws_PageAttributes
};


export type CreatePageMutation = { __typename?: 'Mutation', createPage: (
    { __typename?: 'WWS_Page' }
    & PagesFragment
  ) };

export type UpdatePagesMutationVariables = {
  pages: Array<Wws_UpdatePageAttributes>
};


export type UpdatePagesMutation = { __typename?: 'Mutation', updatePages: Array<(
    { __typename?: 'WWS_Page' }
    & PagesFragment
  )> };

export type MessagingSequencesQueryVariables = {};


export type MessagingSequencesQuery = { __typename?: 'Query', messagingSequences: Array<{ __typename?: 'SequenceList', mediaId: string, displayName: string, sequenceType: string, description: string, shortDescription: string, supportedTypes: Array<{ __typename?: 'SupportedType', id: string, type: string }> }> };

export type WeddingInfoQueryVariables = {};


export type WeddingInfoQuery = { __typename?: 'Query', weddingWebsite: { __typename?: 'WWS_WeddingWebsite', weddingLocation: Maybe<string> }, member: Maybe<{ __typename?: 'Member', lastName: Maybe<string>, firstName: Maybe<string>, fianceLastName: Maybe<string>, fianceFirstName: Maybe<string> }>, wedding: Maybe<{ __typename?: 'Wedding', weddingDate: string }> };

export type GuestMessagingStatusesLiteQueryVariables = {};


export type GuestMessagingStatusesLiteQuery = { __typename?: 'Query', guestMessagingStatuses: Maybe<Array<Maybe<{ __typename?: 'GuestMessagingStatuses', batchId: string }>>> };

export type GuestMessagingStatusesQueryVariables = {};


export type GuestMessagingStatusesQuery = { __typename?: 'Query', guestMessagingStatuses: Maybe<Array<Maybe<{ __typename?: 'GuestMessagingStatuses', batchId: string, sentDate: string, sequenceDisplayName: string, type: string, guests: Array<{ __typename?: 'GuestMessagingGuests', id: string, status: string, reply: Maybe<string>, person: Maybe<{ __typename?: 'GDS_Person', firstName: Maybe<string>, lastName: Maybe<string>, email: Maybe<string>, phone: Maybe<string> }> }> }>>> };

export type SendCovidEmailMutationVariables = {
  args: NoLinkEmailArgs
};


export type SendCovidEmailMutation = { __typename?: 'Mutation', sendCovidEmail: Maybe<boolean> };

export type SendCovidSmsMutationVariables = {
  args: SmsArgs
};


export type SendCovidSmsMutation = { __typename?: 'Mutation', sendCovidSms: Maybe<boolean> };

export type SendCustomSmsMutationVariables = {
  args: SmsArgs
};


export type SendCustomSmsMutation = { __typename?: 'Mutation', sendCustomSms: Maybe<boolean> };

export type SendCustomEmailMutationVariables = {
  args: NoLinkEmailArgs
};


export type SendCustomEmailMutation = { __typename?: 'Mutation', sendCustomEmail: Maybe<boolean> };

export type SendAddressCollectionSmsMutationVariables = {
  args: SmsArgs
};


export type SendAddressCollectionSmsMutation = { __typename?: 'Mutation', sendAddressCollectionSms: Maybe<boolean> };

export type SendAddressCollectionEmailMutationVariables = {
  args: LinkEmailArgs
};


export type SendAddressCollectionEmailMutation = { __typename?: 'Mutation', sendAddressCollectionEmail: Maybe<boolean> };

export type SendLivestreamEmailMutationVariables = {
  args: CustomLinkEmailArgs
};


export type SendLivestreamEmailMutation = { __typename?: 'Mutation', sendLivestreamEmail: Maybe<boolean> };

export type SendRsvpReminderSmsMutationVariables = {
  args: SmsArgs
};


export type SendRsvpReminderSmsMutation = { __typename?: 'Mutation', sendRsvpReminderSms: Maybe<boolean> };

export type SendRsvpReminderEmailMutationVariables = {
  args: LinkEmailArgs
};


export type SendRsvpReminderEmailMutation = { __typename?: 'Mutation', sendRsvpReminderEmail: Maybe<boolean> };

export type UpdateRsvpDeadlinePropsMutationVariables = {
  guestWeddingArgs: Gds_UpdateGuestWeddingRsvpPropsInput
};


export type UpdateRsvpDeadlinePropsMutation = { __typename?: 'Mutation', updateGuestWeddingRsvpProps: { __typename?: 'GDS_GuestWedding', id: string, isPrivateRsvp: Maybe<boolean>, rsvpDeadline: Maybe<string>, rsvpMedium: Maybe<string> } };

export type UpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutationVariables = {
  rsvpArgs: RsvpPropsArgs,
  guestWeddingArgs: Gds_UpdateGuestWeddingRsvpPropsInput
};


export type UpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutation = { __typename?: 'Mutation', upsertRsvpDeadlineProps: Maybe<boolean>, updateGuestWeddingRsvpProps: { __typename?: 'GDS_GuestWedding', id: string, isPrivateRsvp: Maybe<boolean>, rsvpDeadline: Maybe<string>, rsvpMedium: Maybe<string> } };

export type RsvpDeadlinePropertiesQueryVariables = {
  type: Scalars['String']
};


export type RsvpDeadlinePropertiesQuery = { __typename?: 'Query', rsvpDeadlineProperties: Maybe<{ __typename?: 'RsvpDeadlineProperties', subject: Maybe<string>, body: string, emailButtonText: Maybe<string> }> };

export type NonRsvpedHouseholdsQueryVariables = {
  eventId: Scalars['String']
};


export type NonRsvpedHouseholdsQuery = { __typename?: 'Query', householdsWithoutRsvp: Array<{ __typename?: 'GDS_Household', id: string, description: Maybe<string>, rsvpNote: Maybe<string>, coupleNote: Maybe<string>, people: Array<(
      { __typename?: 'GDS_Person' }
      & PeopleFragment
    )>, address: Maybe<(
      { __typename?: 'GDS_Address' }
      & GdsAddressFragment
    )>, answers: Maybe<Array<(
      { __typename?: 'GDS_Answer' }
      & GdsAnswerFragment
    )>> }> };

export type UpdateMemberNamesMutationVariables = {
  membersArgs: MemberArgs
};


export type UpdateMemberNamesMutation = { __typename?: 'Mutation', updateMember: Maybe<{ __typename?: 'Member', id: string, firstName: Maybe<string>, lastName: Maybe<string>, fianceFirstName: Maybe<string>, fianceLastName: Maybe<string> }> };

export type UpdateWeddingInfoMutationVariables = {
  membersArgs: MemberArgs,
  weddingDateArgs: UpsertWeddingDataArgs,
  weddingWebsiteAttrs: Wws_WeddingWebsiteAttributes
};


export type UpdateWeddingInfoMutation = { __typename?: 'Mutation', updateMember: Maybe<{ __typename?: 'Member', id: string, firstName: Maybe<string>, lastName: Maybe<string>, fianceFirstName: Maybe<string>, fianceLastName: Maybe<string> }>, upsertWeddingData: Maybe<{ __typename?: 'Wedding', id: string, weddingDate: string }>, updateWeddingWebsite: { __typename?: 'WWS_WeddingWebsite', id: number, weddingLocation: Maybe<string> } };

export type ReorderPageItemsMutationVariables = {
  attributes: Wws_ReorderPageItemAttrs
};


export type ReorderPageItemsMutation = { __typename?: 'Mutation', reorderPageItems: Array<(
    { __typename?: 'WWS_AccommodationItem', id: number, rank: number, type: string }
    & AccommodationItemsFragment
  ) | (
    { __typename?: 'WWS_ActivityItem', id: number, rank: number, type: string }
    & ActivityItemsFragment
  ) | (
    { __typename?: 'WWS_BasicItem', id: number, rank: number, type: string }
    & BasicItemsFragment
  ) | (
    { __typename?: 'WWS_CoverPhotoItem', id: number, rank: number, type: string }
    & CoverPhotoItemsFragment
  ) | (
    { __typename?: 'WWS_EmbedItem', id: number, rank: number, type: string }
    & EmbedItemsFragment
  ) | (
    { __typename?: 'WWS_GifItem', id: number, rank: number, type: string }
    & GifItemsFragment
  ) | (
    { __typename?: 'WWS_HeadlineItem', id: number, rank: number, type: string }
    & HeadlineItemsFragment
  ) | (
    { __typename?: 'WWS_LivestreamItem', id: number, rank: number, type: string }
    & LivestreamItemsFragment
  ) | (
    { __typename?: 'WWS_ParagraphItem', id: number, rank: number, type: string }
    & ParagraphItemsFragment
  ) | (
    { __typename?: 'WWS_PersonItem', id: number, rank: number, type: string }
    & PersonItemsFragment
  ) | (
    { __typename?: 'WWS_PhotoGalleryItem', id: number, rank: number, type: string }
    & PhotoGalleryItemsFragment
  ) | (
    { __typename?: 'WWS_PhotoItem', id: number, rank: number, type: string }
    & PhotoItemsFragment
  ) | (
    { __typename?: 'WWS_PhotoTimelineItem', id: number, rank: number, type: string }
    & PhotoTimelineItemsFragment
  ) | (
    { __typename?: 'WWS_QuestionItem', id: number, rank: number, type: string }
    & QuestionItemsFragment
  ) | (
    { __typename?: 'WWS_StoryItem', id: number, rank: number, type: string }
    & StoryItemsFragment
  ) | (
    { __typename?: 'WWS_TransportationItem', id: number, rank: number, type: string }
    & TransportationItemsFragment
  ) | (
    { __typename?: 'WWS_DressCodeItem', id: number, rank: number, type: string }
    & DressCodeItemsFragment
  ) | { __typename?: 'WWS_EventGroupItem', id: number, rank: number, type: string } | { __typename?: 'WWS_GroupItem', id: number, rank: number, type: string } | { __typename?: 'WWS_WeddingPartyItem', id: number, rank: number, type: string }> };

export type CreateAccommodationItemMutationVariables = {
  attributes: Wws_CreateAccommodationItemAttrs
};


export type CreateAccommodationItemMutation = { __typename?: 'Mutation', item: { __typename?: 'WWS_AccommodationItem', id: number, email: Maybe<string>, rank: number, type: string, description: Maybe<string>, name: Maybe<string>, phone: Maybe<string>, website: Maybe<string>, address: Maybe<string>, guestCode: Maybe<string>, rate: Maybe<string>, checkInDate: Maybe<string>, checkOutDate: Maybe<string>, hotelPlannerId: Maybe<number>, hotelId: Maybe<string>, provider: Maybe<string>, photo: Maybe<{ __typename?: 'WWS_Photo', mediaUrl: string, mediaApiId: string, width: Maybe<number>, height: Maybe<number>, cropX: Maybe<number>, cropY: Maybe<number>, rotation: Maybe<number>, aspectRatio: Maybe<{ __typename?: 'WWS_AspectRatio', name: string, value: number }> }> } };

export type UpdateAccommodationItemMutationVariables = {
  attributes: Wws_UpdateAccommodationItemAttrs
};


export type UpdateAccommodationItemMutation = { __typename?: 'Mutation', updateAccommodationItem: { __typename?: 'WWS_AccommodationItem', id: number, email: Maybe<string>, rank: number, type: string, description: Maybe<string>, name: Maybe<string>, phone: Maybe<string>, website: Maybe<string>, address: Maybe<string>, guestCode: Maybe<string>, rate: Maybe<string>, checkInDate: Maybe<string>, checkOutDate: Maybe<string>, hotelPlannerId: Maybe<number>, hotelId: Maybe<string>, photo: Maybe<{ __typename?: 'WWS_Photo', mediaUrl: string, mediaApiId: string, width: Maybe<number>, height: Maybe<number>, cropX: Maybe<number>, cropY: Maybe<number>, rotation: Maybe<number>, aspectRatio: Maybe<{ __typename?: 'WWS_AspectRatio', name: string, value: number }> }> } };

export type AccommodationQueryVariables = {
  id: Scalars['Int'],
  pageId: Scalars['Int']
};


export type AccommodationQuery = { __typename?: 'Query', page: { __typename?: 'WWS_Page', accommodationItem: Maybe<{ __typename?: 'WWS_AccommodationItem', id: number, email: Maybe<string>, rank: number, type: string, description: Maybe<string>, name: Maybe<string>, phone: Maybe<string>, website: Maybe<string>, address: Maybe<string>, guestCode: Maybe<string>, rate: Maybe<string>, checkInDate: Maybe<string>, checkOutDate: Maybe<string>, hotelPlannerId: Maybe<number>, hotelId: Maybe<string>, provider: Maybe<string>, photo: Maybe<{ __typename?: 'WWS_Photo', mediaUrl: string, mediaApiId: string, width: Maybe<number>, height: Maybe<number>, cropX: Maybe<number>, cropY: Maybe<number>, rotation: Maybe<number>, aspectRatio: Maybe<{ __typename?: 'WWS_AspectRatio', name: string, value: number }> }> }> } };

export type DeleteAccommodationItemMutationVariables = {
  attributes: Wws_DeletePageItemAttributes
};


export type DeleteAccommodationItemMutation = { __typename?: 'Mutation', deletePageItem: number };

export type CreateActivityItemMutationVariables = {
  attributes: Wws_CreateBusinessItemAttrs
};


export type CreateActivityItemMutation = { __typename?: 'Mutation', item: (
    { __typename?: 'WWS_ActivityItem' }
    & ActivityItemsFragment
  ) };

export type UpdateActivityItemMutationVariables = {
  attributes: Wws_UpdateBusinessItemAttrs
};


export type UpdateActivityItemMutation = { __typename?: 'Mutation', updateActivityItem: (
    { __typename?: 'WWS_ActivityItem' }
    & ActivityItemsFragment
  ) };

export type ActivityQueryVariables = {
  id: Scalars['Int'],
  pageId: Scalars['Int']
};


export type ActivityQuery = { __typename?: 'Query', page: { __typename?: 'WWS_Page', activityItem: Maybe<(
      { __typename?: 'WWS_ActivityItem' }
      & ActivityItemsFragment
    )> } };

export type DeleteActivityItemMutationVariables = {
  attributes: Wws_DeletePageItemAttributes
};


export type DeleteActivityItemMutation = { __typename?: 'Mutation', deletePageItem: number };

export type UpdateBasicItemMutationVariables = {
  attributes: Wws_UpdateBasicItemAttrs
};


export type UpdateBasicItemMutation = { __typename?: 'Mutation', updateBasicItem: (
    { __typename?: 'WWS_BasicItem' }
    & BasicItemsFragment
  ) };

export type BasicQueryVariables = {
  id: Scalars['Int'],
  pageId: Scalars['Int']
};


export type BasicQuery = { __typename?: 'Query', page: { __typename?: 'WWS_Page', basicItem: Maybe<(
      { __typename?: 'WWS_BasicItem' }
      & BasicItemsFragment
    )> } };

export type DeleteBasicItemMutationVariables = {
  id: Scalars['Int'],
  pageId: Scalars['Int']
};


export type DeleteBasicItemMutation = { __typename?: 'Mutation', deletePageItem: number };

export type CreateDressCodeItemMutationVariables = {
  attributes: Wws_CreateDressCodeItemAttrs
};


export type CreateDressCodeItemMutation = { __typename?: 'Mutation', createDressCodeItem: (
    { __typename?: 'WWS_DressCodeItem' }
    & DressCodeItemsFragment
  ) };

export type UpdateDressCodeItemMutationVariables = {
  attributes: Wws_UpdateDressCodeItemAttrs
};


export type UpdateDressCodeItemMutation = { __typename?: 'Mutation', updateDressCodeItem: (
    { __typename?: 'WWS_DressCodeItem' }
    & DressCodeItemsFragment
  ) };

export type DeleteDressCodeItemMutationVariables = {
  attributes: Wws_DeletePageItemAttributes
};


export type DeleteDressCodeItemMutation = { __typename?: 'Mutation', deletePageItem: number };

export type DressCodeQueryVariables = {
  pageId: Scalars['Int'],
  id?: Maybe<Scalars['Int']>
};


export type DressCodeQuery = { __typename?: 'Query', page: { __typename?: 'WWS_Page', id: number, items: Array<{ __typename?: 'WWS_AccommodationItem' } | { __typename?: 'WWS_ActivityItem' } | { __typename?: 'WWS_BasicItem' } | { __typename?: 'WWS_CoverPhotoItem' } | { __typename?: 'WWS_EmbedItem' } | { __typename?: 'WWS_GifItem' } | { __typename?: 'WWS_HeadlineItem' } | { __typename?: 'WWS_LivestreamItem' } | { __typename?: 'WWS_ParagraphItem' } | { __typename?: 'WWS_PersonItem' } | { __typename?: 'WWS_PhotoGalleryItem' } | { __typename?: 'WWS_PhotoItem' } | { __typename?: 'WWS_PhotoTimelineItem' } | { __typename?: 'WWS_QuestionItem' } | { __typename?: 'WWS_StoryItem' } | { __typename?: 'WWS_TransportationItem' } | (
      { __typename?: 'WWS_DressCodeItem' }
      & DressCodeItemsFragment
    ) | { __typename?: 'WWS_EventGroupItem' } | { __typename?: 'WWS_GroupItem' } | { __typename?: 'WWS_WeddingPartyItem' }> } };

export type CreateEmbedItemMutationVariables = {
  attributes: Wws_CreateEmbedItemAttrs
};


export type CreateEmbedItemMutation = { __typename?: 'Mutation', createEmbedItem: (
    { __typename?: 'WWS_EmbedItem' }
    & EmbedItemsFragment
  ) };

export type UpdateEmbedItemMutationVariables = {
  attributes: Wws_UpdateEmbedItemAttrs
};


export type UpdateEmbedItemMutation = { __typename?: 'Mutation', updateEmbedItem: (
    { __typename?: 'WWS_EmbedItem' }
    & EmbedItemsFragment
  ) };

export type EmbedQueryVariables = {
  id: Scalars['Int'],
  pageId: Scalars['Int']
};


export type EmbedQuery = { __typename?: 'Query', page: { __typename?: 'WWS_Page', id: number, embedItem: Maybe<(
      { __typename?: 'WWS_EmbedItem' }
      & EmbedItemsFragment
    )> } };

export type DeleteEmbedItemMutationVariables = {
  id: Scalars['Int'],
  pageId: Scalars['Int']
};


export type DeleteEmbedItemMutation = { __typename?: 'Mutation', deletePageItem: number };

export type CreateGifItemMutationVariables = {
  attributes: Wws_CreateGifItemAttrs
};


export type CreateGifItemMutation = { __typename?: 'Mutation', createGifItem: (
    { __typename?: 'WWS_GifItem' }
    & GifItemsFragment
  ) };

export type DeleteGifItemMutationVariables = {
  attributes: Wws_DeletePageItemAttributes
};


export type DeleteGifItemMutation = { __typename?: 'Mutation', deletePageItem: number };

export type CreateHeadlineItemMutationVariables = {
  attributes: Wws_CreateHeadlineItemAttrs
};


export type CreateHeadlineItemMutation = { __typename?: 'Mutation', createHeadlineItem: (
    { __typename?: 'WWS_HeadlineItem' }
    & HeadlineItemsFragment
  ) };

export type UpdateHeadlineItemMutationVariables = {
  attributes: Wws_UpdateHeadlineItemAttrs
};


export type UpdateHeadlineItemMutation = { __typename?: 'Mutation', updateHeadlineItem: (
    { __typename?: 'WWS_HeadlineItem' }
    & HeadlineItemsFragment
  ) };

export type DeleteHeadlineItemMutationVariables = {
  attributes: Wws_DeletePageItemAttributes
};


export type DeleteHeadlineItemMutation = { __typename?: 'Mutation', deletePageItem: number };

export type HeadlineQueryVariables = {
  id: Scalars['Int'],
  pageId: Scalars['Int']
};


export type HeadlineQuery = { __typename?: 'Query', page: { __typename?: 'WWS_Page', id: number, headlineItem: Maybe<(
      { __typename?: 'WWS_HeadlineItem' }
      & HeadlineItemsFragment
    )> } };

export type CreateLivestreamItemMutationVariables = {
  attributes: Wws_CreateLivestreamItemAttrs
};


export type CreateLivestreamItemMutation = { __typename?: 'Mutation', createLivestreamItem: (
    { __typename?: 'WWS_LivestreamItem' }
    & LivestreamItemsFragment
  ) };

export type UpdateLivestreamItemMutationVariables = {
  attributes: Wws_UpdateLivestreamItemAttrs
};


export type UpdateLivestreamItemMutation = { __typename?: 'Mutation', updateLivestreamItem: (
    { __typename?: 'WWS_LivestreamItem' }
    & LivestreamItemsFragment
  ) };

export type LivestreamQueryVariables = {
  id: Scalars['Int'],
  pageId: Scalars['Int']
};


export type LivestreamQuery = { __typename?: 'Query', page: { __typename?: 'WWS_Page', id: number, livestreamItem: Maybe<(
      { __typename?: 'WWS_LivestreamItem' }
      & LivestreamItemsFragment
    )> } };

export type DeleteLivestreamItemMutationVariables = {
  id: Scalars['Int'],
  pageId: Scalars['Int']
};


export type DeleteLivestreamItemMutation = { __typename?: 'Mutation', deletePageItem: number };

export type CreateParagraphItemMutationVariables = {
  attributes: Wws_CreateParagraphItemAttrs
};


export type CreateParagraphItemMutation = { __typename?: 'Mutation', createParagraphItem: (
    { __typename?: 'WWS_ParagraphItem' }
    & ParagraphItemsFragment
  ) };

export type UpdateParagraphItemMutationVariables = {
  attributes: Wws_UpdateParagraphItemAttrs
};


export type UpdateParagraphItemMutation = { __typename?: 'Mutation', updateParagraphItem: (
    { __typename?: 'WWS_ParagraphItem' }
    & ParagraphItemsFragment
  ) };

export type ParagraphQueryVariables = {
  id: Scalars['Int'],
  pageId: Scalars['Int']
};


export type ParagraphQuery = { __typename?: 'Query', page: { __typename?: 'WWS_Page', paragraphItem: Maybe<(
      { __typename?: 'WWS_ParagraphItem' }
      & ParagraphItemsFragment
    )> } };

export type DeleteParagraphItemMutationVariables = {
  attributes: Wws_DeletePageItemAttributes
};


export type DeleteParagraphItemMutation = { __typename?: 'Mutation', deletePageItem: number };

export type CreatePersonItemMutationVariables = {
  attributes: Wws_CreatePersonItemAttrs
};


export type CreatePersonItemMutation = { __typename?: 'Mutation', createPersonItem: (
    { __typename?: 'WWS_PersonItem' }
    & PersonItemsFragment
  ) };

export type UpdatePersonItemMutationVariables = {
  attributes: Wws_UpdatePersonItemAttrs
};


export type UpdatePersonItemMutation = { __typename?: 'Mutation', updatePersonItem: (
    { __typename?: 'WWS_PersonItem' }
    & PersonItemsFragment
  ) };

export type PersonQueryVariables = {
  id: Scalars['Int'],
  pageId: Scalars['Int']
};


export type PersonQuery = { __typename?: 'Query', page: { __typename?: 'WWS_Page', id: number, personItem: Maybe<(
      { __typename?: 'WWS_PersonItem' }
      & PersonItemsFragment
    )> } };

export type DeletePersonItemMutationVariables = {
  id: Scalars['Int'],
  pageId: Scalars['Int']
};


export type DeletePersonItemMutation = { __typename?: 'Mutation', deletePageItem: number };

export type CreatePhotoGalleryItemMutationVariables = {
  attributes: Wws_CreatePhotoGalleryItemAttrs
};


export type CreatePhotoGalleryItemMutation = { __typename?: 'Mutation', item: { __typename?: 'WWS_PhotoGalleryItem', id: number, layout: string, rank: number, type: string, photoItems: Array<(
      { __typename?: 'WWS_PhotoItem' }
      & PhotoItemsFragment
    )> } };

export type UpdatePhotoGalleryItemMutationVariables = {
  attributes: Wws_UpdatePhotoGalleryItemAttrs
};


export type UpdatePhotoGalleryItemMutation = { __typename?: 'Mutation', item: { __typename?: 'WWS_PhotoGalleryItem', id: number, layout: string, rank: number, type: string, photoItems: Array<(
      { __typename?: 'WWS_PhotoItem' }
      & PhotoItemsFragment
    )> } };

export type DeletePhotoGalleryItemMutationVariables = {
  attributes: Wws_DeletePageItemAttributes
};


export type DeletePhotoGalleryItemMutation = { __typename?: 'Mutation', deletePageItem: number };

export type PhotoGalleryQueryVariables = {
  id: Scalars['Int'],
  pageId: Scalars['Int']
};


export type PhotoGalleryQuery = { __typename?: 'Query', page: { __typename?: 'WWS_Page', id: number, photoGalleryItem: Maybe<{ __typename?: 'WWS_PhotoGalleryItem', id: number, photoItems: Array<(
        { __typename?: 'WWS_PhotoItem' }
        & PhotoItemsFragment
      )> }> } };

export type CreatePhotoItemMutationVariables = {
  attributes: Wws_CreatePhotoItemAttrs
};


export type CreatePhotoItemMutation = { __typename?: 'Mutation', createPhotoItem: (
    { __typename?: 'WWS_PhotoItem' }
    & PhotoItemsFragment
  ) };

export type UpdatePhotoItemMutationVariables = {
  attributes: Wws_UpdatePhotoItemAttrs
};


export type UpdatePhotoItemMutation = { __typename?: 'Mutation', updatePhotoItem: (
    { __typename?: 'WWS_PhotoItem' }
    & PhotoItemsFragment
  ) };

export type DeletePhotoItemMutationVariables = {
  attributes: Wws_DeletePageItemAttributes
};


export type DeletePhotoItemMutation = { __typename?: 'Mutation', deletePageItem: number };

export type MediaApiJwtQueryVariables = {};


export type MediaApiJwtQuery = { __typename?: 'Query', mediaApiJwt: { __typename?: 'WWS_MediaApiJwt', token: string } };

export type CreatePhotoTimelineItemMutationVariables = {
  attributes: Wws_CreatePhotoTimelineItemAttrs
};


export type CreatePhotoTimelineItemMutation = { __typename?: 'Mutation', item: { __typename?: 'WWS_PhotoTimelineItem', id: number, layout: string, rank: number, type: string, photoItems: Array<(
      { __typename?: 'WWS_PhotoItem' }
      & PhotoItemsFragment
    )> } };

export type UpdatePhotoTimelineItemMutationVariables = {
  attributes: Wws_UpdatePhotoTimelineItemAttrs
};


export type UpdatePhotoTimelineItemMutation = { __typename?: 'Mutation', item: { __typename?: 'WWS_PhotoTimelineItem', id: number, layout: string, rank: number, type: string, photoItems: Array<(
      { __typename?: 'WWS_PhotoItem' }
      & PhotoItemsFragment
    )> } };

export type DeletePhotoTimelineItemMutationVariables = {
  attributes: Wws_DeletePageItemAttributes
};


export type DeletePhotoTimelineItemMutation = { __typename?: 'Mutation', deletePageItem: number };

export type PhotoTimelineQueryVariables = {
  id: Scalars['Int'],
  pageId: Scalars['Int']
};


export type PhotoTimelineQuery = { __typename?: 'Query', page: { __typename?: 'WWS_Page', id: number, photoTimelineItem: Maybe<{ __typename?: 'WWS_PhotoTimelineItem', id: number, photoItems: Array<(
        { __typename?: 'WWS_PhotoItem' }
        & PhotoItemsFragment
      )> }> } };

export type CreateQuestionItemMutationVariables = {
  attributes: Wws_CreateQuestionItemAttrs
};


export type CreateQuestionItemMutation = { __typename?: 'Mutation', createQuestionItem: (
    { __typename?: 'WWS_QuestionItem' }
    & QuestionItemsFragment
  ) };

export type UpdateQuestionItemMutationVariables = {
  attributes: Wws_UpdateQuestionItemAttrs
};


export type UpdateQuestionItemMutation = { __typename?: 'Mutation', updateQuestionItem: (
    { __typename?: 'WWS_QuestionItem' }
    & QuestionItemsFragment
  ) };

export type DeleteQuestionItemMutationVariables = {
  attributes: Wws_DeletePageItemAttributes
};


export type DeleteQuestionItemMutation = { __typename?: 'Mutation', deletePageItem: number };

export type QuestionQueryVariables = {
  id: Scalars['Int'],
  pageId: Scalars['Int']
};


export type QuestionQuery = { __typename?: 'Query', page: { __typename?: 'WWS_Page', id: number, questionItem: Maybe<(
      { __typename?: 'WWS_QuestionItem' }
      & QuestionItemsFragment
    )> } };

export type CreateStoryItemMutationVariables = {
  attributes: Wws_CreateStoryItemAttrs
};


export type CreateStoryItemMutation = { __typename?: 'Mutation', createStoryItem: (
    { __typename?: 'WWS_StoryItem' }
    & StoryItemsFragment
  ) };

export type UpdateStoryItemMutationVariables = {
  attributes: Wws_UpdateStoryItemAttrs
};


export type UpdateStoryItemMutation = { __typename?: 'Mutation', updateStoryItem: (
    { __typename?: 'WWS_StoryItem' }
    & StoryItemsFragment
  ) };

export type StoryQueryVariables = {
  id: Scalars['Int'],
  pageId: Scalars['Int']
};


export type StoryQuery = { __typename?: 'Query', page: { __typename?: 'WWS_Page', id: number, storyItem: Maybe<(
      { __typename?: 'WWS_StoryItem' }
      & StoryItemsFragment
    )> } };

export type DeleteStoryItemMutationVariables = {
  id: Scalars['Int'],
  pageId: Scalars['Int']
};


export type DeleteStoryItemMutation = { __typename?: 'Mutation', deletePageItem: number };

export type UpdateTransportationItemMutationVariables = {
  attributes: Wws_UpdateBusinessItemAttrs
};


export type UpdateTransportationItemMutation = { __typename?: 'Mutation', updateTransportationItem: (
    { __typename?: 'WWS_TransportationItem' }
    & TransportationItemsFragment
  ) };

export type CreateTransportationItemMutationVariables = {
  attributes: Wws_CreateBusinessItemAttrs
};


export type CreateTransportationItemMutation = { __typename?: 'Mutation', item: (
    { __typename?: 'WWS_TransportationItem' }
    & TransportationItemsFragment
  ) };

export type TransportationQueryVariables = {
  id: Scalars['Int'],
  pageId: Scalars['Int']
};


export type TransportationQuery = { __typename?: 'Query', page: { __typename?: 'WWS_Page', transportationItem: Maybe<(
      { __typename?: 'WWS_TransportationItem' }
      & TransportationItemsFragment
    )> } };

export type DeleteTransportationItemMutationVariables = {
  attributes: Wws_DeletePageItemAttributes
};


export type DeleteTransportationItemMutation = { __typename?: 'Mutation', deletePageItem: number };

export type PageQueryVariables = {
  id: Scalars['Int']
};


export type PageQuery = { __typename?: 'Query', page: (
    { __typename?: 'WWS_Page' }
    & PagesFragment
  ) };

export type UpdatePageMutationVariables = {
  id: Scalars['Int'],
  attributes: Wws_PageAttributes
};


export type UpdatePageMutation = { __typename?: 'Mutation', updatePage: (
    { __typename?: 'WWS_Page' }
    & PagesFragment
  ) };

export type UpdateRegistryPageMutationVariables = {
  id: Scalars['Int'],
  attributes: Wws_PageAttributes,
  weddingAttrs: Wws_WeddingWebsiteAttributes
};


export type UpdateRegistryPageMutation = { __typename?: 'Mutation', updatePage: (
    { __typename?: 'WWS_Page' }
    & PagesFragment
  ), updateWeddingWebsite: { __typename?: 'WWS_WeddingWebsite', id: number, registryNote: Maybe<string> } };

export type DeletePageMutationVariables = {
  id: Scalars['Int']
};


export type DeletePageMutation = { __typename?: 'Mutation', deletePage: { __typename?: 'WWS_Page', id: number, title: Maybe<string>, show: Maybe<boolean>, rank: Maybe<number>, type: string } };

export type UpdateThemeMutationVariables = {
  id: Scalars['Int']
};


export type UpdateThemeMutation = { __typename?: 'Mutation', updateSelectedTheme: { __typename?: 'WWS_Theme', id: Maybe<number>, previewUrl: Maybe<string>, name: Maybe<string>, family: Maybe<string>, designerUrl: Maybe<string>, previewImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string }>, mobilePreviewImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string }>, stationaryPreviewImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string }>, themeDesigner: Maybe<{ __typename?: 'WWS_ThemeDesigner', name: Maybe<string>, companyName: Maybe<string> }>, familyThemes: Array<{ __typename?: 'WWS_Theme', id: Maybe<number>, swatchUrl: Maybe<string>, name: Maybe<string> }> } };

export type PrintPromotionMutationVariables = {};


export type PrintPromotionMutation = { __typename?: 'Mutation', printPromotion: Maybe<{ __typename?: 'WWS_WeddingWebsitePromotion', id: number, imageUrl: Maybe<string>, title: Maybe<string>, description: Maybe<string>, mainCtaUrl: Maybe<string> }> };

export type DismissPromotionMutationVariables = {
  id: Scalars['Int']
};


export type DismissPromotionMutation = { __typename?: 'Mutation', dismissPromotion: { __typename?: 'WWS_WeddingWebsitePromotion', id: number } };

export type SearchDomainQueryVariables = {
  domainName: Scalars['String']
};


export type SearchDomainQuery = { __typename?: 'Query', searchDomains: Array<{ __typename?: 'WWS_SearchDomain', name: string, available: boolean, isPremiumName: boolean, price: number }> };

export type BraintreeTokenQueryVariables = {};


export type BraintreeTokenQuery = { __typename?: 'Query', braintreeToken: { __typename?: 'WWS_BraintreeToken', token: string, vendorId: string } };

export type CreatePurchaseDomainMutationVariables = {
  attributes: Wws_CreatePurchaseDomainAttrs
};


export type CreatePurchaseDomainMutation = { __typename?: 'Mutation', createPurchaseDomain: { __typename?: 'WWS_PurchaseDomain', id: Maybe<number>, name: Maybe<string>, showRenewal: Maybe<boolean>, isRenewable: Maybe<boolean>, isInRedemptionPeriod: boolean, isExpired: Maybe<boolean>, expirationDate: Maybe<string>, dateOfLastRenewal: Maybe<string>, renewalPrice: number, createdAt: string } };

export type UpdatePurchaseDomainMutationVariables = {
  attributes: Wws_UpdatePurchaseDomainAttrs
};


export type UpdatePurchaseDomainMutation = { __typename?: 'Mutation', updatePurchaseDomain: { __typename?: 'WWS_PurchaseDomain', id: Maybe<number>, name: Maybe<string>, showRenewal: Maybe<boolean>, isRenewable: Maybe<boolean>, isInRedemptionPeriod: boolean, isExpired: Maybe<boolean>, expirationDate: Maybe<string>, dateOfLastRenewal: Maybe<string>, renewalPrice: number, createdAt: string } };

export type RegistrySummaryQueryVariables = {};


export type RegistrySummaryQuery = { __typename?: 'Query', registrySummary: Maybe<{ __typename?: 'RegistrySummary', totalActiveGiftsRequested: Maybe<string>, totalCashFunds: Maybe<number>, totalGiftsReceived: Maybe<number>, totalCashCentsReceived: Maybe<number>, hasTransactionalRegistry: Maybe<boolean>, giftsByStore: Maybe<Array<Maybe<{ __typename?: 'RegistryStore', name: Maybe<string> }>>>, registries: Maybe<Array<Maybe<{ __typename?: 'Registry', isDeleted: Maybe<boolean>, hiddenWws: Maybe<boolean>, registryType: Maybe<number> }>>> }> };

export type EventRsvpDataQueryVariables = {};


export type EventRsvpDataQuery = { __typename?: 'Query', eventRsvpData: Maybe<Array<{ __typename?: 'GDS_EventRsvpData', eventId: string, guestCount: Maybe<number>, acceptCount: Maybe<number>, rejectCount: Maybe<number> }>> };

export type UpdateRsvpPageHiddenMutationVariables = {
  guestWeddingInput: Gds_UpdateGuestWeddingInput
};


export type UpdateRsvpPageHiddenMutation = { __typename?: 'Mutation', updateGuestWedding: { __typename?: 'GDS_GuestWedding', rsvpPageHidden: Maybe<boolean> } };

export type EventQuestionResponseQueryVariables = {};


export type EventQuestionResponseQuery = { __typename?: 'Query', eventQuestionResponseData: Maybe<Array<{ __typename?: 'GDS_EventQuestionResponseData', eventId: string, questionsData: Maybe<Array<Maybe<{ __typename?: 'GDS_QuestionResponseData', text: string, type: string, questionId: string, answerType: string, optionCount: Maybe<number>, answersData: Maybe<Array<Maybe<{ __typename?: 'GDS_AnswerData', optionId: Maybe<string>, text: string, responseCount: Maybe<number>, responses: Maybe<Array<Maybe<{ __typename?: 'GDS_Responder', personId: string, firstName: Maybe<string>, lastName: Maybe<string> }>>> }>>> }>>> }>> };

export type GuestWeddingQuestionResponseQueryVariables = {};


export type GuestWeddingQuestionResponseQuery = { __typename?: 'Query', guestWeddingQuestionResponseData: { __typename?: 'GDS_GuestWeddingQuestionResponseData', guestWeddingId: string, questionsData: Maybe<Array<Maybe<{ __typename?: 'GDS_QuestionResponseData', type: string, text: string, questionId: string, answerType: string, optionCount: Maybe<number>, answersData: Maybe<Array<Maybe<{ __typename?: 'GDS_AnswerData', optionId: Maybe<string>, text: string, responseCount: Maybe<number>, responses: Maybe<Array<Maybe<{ __typename?: 'GDS_Responder', personId: string, firstName: Maybe<string>, lastName: Maybe<string> }>>> }>>> }>>> } };

export type PasswordMutationVariables = {
  attributes: Wws_WeddingWebsiteAttributes
};


export type PasswordMutation = { __typename?: 'Mutation', updateWeddingWebsite: { __typename?: 'WWS_WeddingWebsite', id: number, pin: Maybe<string>, pinProtect: Maybe<boolean> } };

export type UrlMutationVariables = {
  attributes: Wws_WeddingWebsiteAttributes
};


export type UrlMutation = { __typename?: 'Mutation', updateWeddingWebsite: { __typename?: 'WWS_WeddingWebsite', id: number, vanityUrl: Maybe<string> } };

export type DeactivateWebsiteMutationVariables = {};


export type DeactivateWebsiteMutation = { __typename?: 'Mutation', disableWeddingWebsite: { __typename?: 'WWS_WeddingWebsite', id: number, state: string, websiteDisabledAt: Maybe<any> } };

export type CreateHouseholdsMutationVariables = {
  input: Array<Gds_CreateHouseholdInput>
};


export type CreateHouseholdsMutation = { __typename?: 'Mutation', createHouseholds: Array<{ __typename?: 'GDS_Household', id: string, description: Maybe<string>, rsvpNote: Maybe<string>, coupleNote: Maybe<string>, people: Array<(
      { __typename?: 'GDS_Person' }
      & PeopleFragment
    )>, address: Maybe<(
      { __typename?: 'GDS_Address' }
      & GdsAddressFragment
    )>, answers: Maybe<Array<(
      { __typename?: 'GDS_Answer' }
      & GdsAnswerFragment
    )>> }> };

export type SendSaveTheDateEmailMutationVariables = {
  args: SaveTheDateArgs
};


export type SendSaveTheDateEmailMutation = { __typename?: 'Mutation', sendSaveTheDateEmail: Maybe<boolean> };

export type SendShareWebsiteEmailMutationVariables = {
  args: ShareWebsiteArgs
};


export type SendShareWebsiteEmailMutation = { __typename?: 'Mutation', sendShareWebsiteEmail: Maybe<boolean> };

export type SendShareWebsiteSmsMutationVariables = {
  args: SmsArgs
};


export type SendShareWebsiteSmsMutation = { __typename?: 'Mutation', sendShareWebsiteSms: Maybe<boolean> };

export type SendUpdatesEmailMutationVariables = {
  args: SendUpdatesEmailArgs
};


export type SendUpdatesEmailMutation = { __typename?: 'Mutation', sendUpdatesEmail: Maybe<boolean> };

export type SendShareDayOfDetailsSmsMutationVariables = {
  args: SmsArgs
};


export type SendShareDayOfDetailsSmsMutation = { __typename?: 'Mutation', sendShareDayOfDetailsSms: Maybe<boolean> };

export type SendShareDayOfDetailsEmailMutationVariables = {
  args: ShareDayOfDetailsEmailArgs
};


export type SendShareDayOfDetailsEmailMutation = { __typename?: 'Mutation', sendShareDayOfDetailsEmail: Maybe<boolean> };

export type SendUpdatesSmsMutationVariables = {
  args: SmsArgs
};


export type SendUpdatesSmsMutation = { __typename?: 'Mutation', sendUpdatesSms: Maybe<boolean> };

export type SendLocalHotelEmailMutationVariables = {
  args: LinkEmailArgs
};


export type SendLocalHotelEmailMutation = { __typename?: 'Mutation', sendLocalHotelEmail: Maybe<boolean> };

export type SendLocalHotelSmsMutationVariables = {
  args: SmsArgs
};


export type SendLocalHotelSmsMutation = { __typename?: 'Mutation', sendLocalHotelSms: Maybe<boolean> };

export type MessagingSequenceQueryVariables = {
  id: Scalars['String']
};


export type MessagingSequenceQuery = { __typename?: 'Query', messagingSequence: Maybe<{ __typename?: 'Sequence', displayName: string, id: string, defaultEmailSubject: Maybe<string>, defaultEmailBody: Maybe<string>, defaultLinkText: Maybe<string>, defaultSmsBody: Maybe<string>, type: string }> };

export type SelectedThemeQueryVariables = {};


export type SelectedThemeQuery = { __typename?: 'Query', theme: Maybe<{ __typename?: 'WWS_Theme', id: Maybe<number>, name: Maybe<string>, designerUrl: Maybe<string>, family: Maybe<string>, previewImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string }>, themeDesigner: Maybe<{ __typename?: 'WWS_ThemeDesigner', name: Maybe<string>, companyName: Maybe<string> }>, stationaryPreviewImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string }> }> };

export type SelectedThemeMutationVariables = {
  id: Scalars['Int']
};


export type SelectedThemeMutation = { __typename?: 'Mutation', updateSelectedTheme: { __typename?: 'WWS_Theme', id: Maybe<number>, name: Maybe<string>, designerUrl: Maybe<string>, family: Maybe<string>, previewImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string }>, themeDesigner: Maybe<{ __typename?: 'WWS_ThemeDesigner', name: Maybe<string>, companyName: Maybe<string> }>, stationaryPreviewImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string }> } };

export type CreateCoverPhotoOnWebsiteMutationVariables = {
  attributes: Wws_PhotoAttributes
};


export type CreateCoverPhotoOnWebsiteMutation = { __typename?: 'Mutation', createCoverPhotoOnWebsite: { __typename?: 'WWS_WeddingWebsite', id: number, coverPhoto: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string, mediaUrl: string, cropX: Maybe<number>, cropY: Maybe<number>, width: Maybe<number>, height: Maybe<number>, originalMediaUrl: string }> } };

export type DeleteCoverPhotoOnWebsiteMutationVariables = {};


export type DeleteCoverPhotoOnWebsiteMutation = { __typename?: 'Mutation', deleteCoverPhotoOnWebsite: { __typename?: 'WWS_WeddingWebsite', id: number, coverPhoto: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string, mediaUrl: string, cropX: Maybe<number>, cropY: Maybe<number>, width: Maybe<number>, height: Maybe<number>, originalMediaUrl: string }> } };

export type HouseholdQueryVariables = {};


export type HouseholdQuery = { __typename?: 'Query', households: Array<{ __typename?: 'GDS_Household', id: string, description: Maybe<string>, rsvpNote: Maybe<string>, coupleNote: Maybe<string>, people: Array<(
      { __typename?: 'GDS_Person' }
      & PeopleFragment
    )>, address: Maybe<(
      { __typename?: 'GDS_Address' }
      & GdsAddressFragment
    )>, answers: Maybe<Array<(
      { __typename?: 'GDS_Answer' }
      & GdsAnswerFragment
    )>> }> };

export type GdsAnswerFragment = { __typename?: 'GDS_Answer', optionId: Maybe<string>, questionId: string, text: Maybe<string> };

export type GdsAddressFragment = { __typename?: 'GDS_Address', street1: Maybe<string>, street2: Maybe<string>, city: Maybe<string>, state: Maybe<string>, zip: Maybe<string>, country: Maybe<string>, fullAddress: Maybe<string> };

export type PeopleFragment = { __typename?: 'GDS_Person', id: string, firstName: Maybe<string>, lastName: Maybe<string>, isLeader: Maybe<boolean>, email: Maybe<string>, phone: Maybe<string>, preferences: Maybe<{ __typename?: 'GDS_Preferences', emailOptOut: Maybe<boolean>, smsOptOut: Maybe<boolean> }>, invitations: Array<{ __typename?: 'GDS_Invitation', id: string, eventId: string, rsvp: Maybe<boolean>, answers: Maybe<Array<(
      { __typename?: 'GDS_Answer' }
      & GdsAnswerFragment
    )>> }> };

export type EventsQueryVariables = {};


export type EventsQuery = { __typename?: 'Query', events: Array<{ __typename?: 'GDS_Event', id: string, weddingId: string, attire: Maybe<string>, requireRsvp: Maybe<boolean>, notes: Maybe<string>, name: Maybe<string>, type: Maybe<string>, date: Maybe<string>, time: Maybe<string>, endTime: Maybe<string>, visible: Maybe<boolean>, createdAt: string, location: Maybe<(
      { __typename?: 'GDS_Location' }
      & LocationsFragment
    )>, questions: Maybe<Array<(
      { __typename?: 'GDS_Question' }
      & QuestionsFragment
    )>>, subEvents: Maybe<Array<{ __typename?: 'GDS_SubEvent', id: string, name: Maybe<string>, time: Maybe<string>, endTime: Maybe<string>, type: Maybe<string>, attire: Maybe<string>, notes: Maybe<string>, visible: Maybe<boolean>, location: Maybe<(
        { __typename?: 'GDS_Location' }
        & LocationsFragment
      )> }>> }> };

export type LocationsFragment = { __typename?: 'GDS_Location', name: Maybe<string>, street1: Maybe<string>, city: Maybe<string>, state: Maybe<string>, zip: Maybe<string>, country: Maybe<string> };

export type QuestionsFragment = { __typename?: 'GDS_Question', id: string, text: Maybe<string>, type: Maybe<string>, answerDestination: Maybe<string>, answerType: Maybe<string>, isRequired: Maybe<boolean>, options: Maybe<Array<{ __typename?: 'GDS_Option', id: string, text: Maybe<string>, description: Maybe<string> }>> };

export type WeddingDateComponentWeddingDatePreferencesQueryVariables = {};


export type WeddingDateComponentWeddingDatePreferencesQuery = { __typename?: 'Query', weddingDatePreferences: Maybe<{ __typename?: 'WeddingDatePreferences', datePreference: Maybe<DatePreference>, hideDate: Maybe<boolean>, season: Maybe<SeasonName>, year: Maybe<number>, weddingDate: Maybe<string>, weddingDateFormat: Maybe<string>, weddingDateRangeStart: Maybe<string>, weddingDateRangeEnd: Maybe<string>, hideCountdown: Maybe<boolean> }> };

export type WeddingDateComponentEventsQueryVariables = {};


export type WeddingDateComponentEventsQuery = { __typename?: 'Query', events: Array<{ __typename?: 'GDS_Event', id: string, weddingId: string, name: Maybe<string>, type: Maybe<string>, date: Maybe<string>, time: Maybe<string>, endTime: Maybe<string> }> };

export type UnleashFeatureToggleQueryVariables = {};


export type UnleashFeatureToggleQuery = { __typename?: 'Query', unleashFeatureToggles: Maybe<Array<Maybe<{ __typename?: 'UnleashFeatureToggle', name: string, enabled: boolean }>>> };

export type VisibilityMutationVariables = {
  attributes: Wws_WeddingWebsiteAttributes
};


export type VisibilityMutation = { __typename?: 'Mutation', updateWeddingWebsite: { __typename?: 'WWS_WeddingWebsite', id: number, searchable: Maybe<boolean> } };

export type GetAttireCategoriesQueryVariables = {};


export type GetAttireCategoriesQuery = { __typename?: 'Query', attireCategories: Maybe<Array<Maybe<{ __typename?: 'AttireCategory', id: Maybe<AttireCategoryEnum>, label: Maybe<string>, description: Maybe<string> }>>> };

export type DeletePageItemMutationVariables = {
  attributes: Wws_DeletePageItemAttributes
};


export type DeletePageItemMutation = { __typename?: 'Mutation', deletePageItem: number };

export type GetThemeFilterOptionsQueryVariables = {};


export type GetThemeFilterOptionsQuery = { __typename?: 'Query', themeFilterOptions: { __typename?: 'WWS_ThemeFilterOptions', colors: Array<string>, seasons: Array<string>, themeStyles: Array<{ __typename?: 'WWS_ThemeFilterOption', label: string, key: string }> } };

export type PublishWeddingWebsiteMutationVariables = {};


export type PublishWeddingWebsiteMutation = { __typename?: 'Mutation', publishWeddingWebsite: { __typename?: 'WWS_WeddingWebsite', id: number, slug: string, state: string } };

export type SignupMutationVariables = {
  attributes: SignupArgs
};


export type SignupMutation = { __typename?: 'Mutation', signup: Maybe<{ __typename?: 'Onboarding', member: Maybe<{ __typename?: 'Member', id: string, firstName: Maybe<string>, lastName: Maybe<string>, fianceFirstName: Maybe<string>, fianceLastName: Maybe<string>, email: string, legacyUserId: Maybe<string>, username: Maybe<string> }>, wedding: Maybe<{ __typename?: 'Wedding', id: string, weddingDate: string, budgetRange: string, guestRange: string, market: Maybe<{ __typename?: 'Market', city: Maybe<string>, state: Maybe<string>, country: Maybe<string>, code: Maybe<string> }> }>, session: Maybe<{ __typename?: 'Session', token: Maybe<string> }>, weddingWebsite: Maybe<{ __typename?: 'WWS_WeddingWebsite', id: number, searchable: Maybe<boolean>, slug: string, source: Maybe<string>, state: string, userUuid: Maybe<string>, weddingUuid: Maybe<string>, vanityRoot: Maybe<string>, vanityUrl: Maybe<string>, themeId: Maybe<number> }> }> };

export type SignupUninitializedMutationVariables = {
  attributes: SignupArgs
};


export type SignupUninitializedMutation = { __typename?: 'Mutation', signupUninitialized: Maybe<{ __typename?: 'Onboarding', member: Maybe<{ __typename?: 'Member', id: string, firstName: Maybe<string>, lastName: Maybe<string>, fianceFirstName: Maybe<string>, fianceLastName: Maybe<string>, email: string, legacyUserId: Maybe<string>, username: Maybe<string> }>, wedding: Maybe<{ __typename?: 'Wedding', id: string, weddingDate: string, budgetRange: string, guestRange: string, market: Maybe<{ __typename?: 'Market', city: Maybe<string>, state: Maybe<string>, country: Maybe<string>, code: Maybe<string> }> }>, session: Maybe<{ __typename?: 'Session', token: Maybe<string> }>, weddingWebsite: Maybe<{ __typename?: 'WWS_WeddingWebsite', id: number, searchable: Maybe<boolean>, slug: string, source: Maybe<string>, state: string, userUuid: Maybe<string>, weddingUuid: Maybe<string>, vanityRoot: Maybe<string>, vanityUrl: Maybe<string>, themeId: Maybe<number> }> }> };

export type UpdateBasicInfoMutationVariables = {
  membersArgs: MemberArgs,
  weddingWebsiteAttrs: Wws_WeddingWebsiteAttributes
};


export type UpdateBasicInfoMutation = { __typename?: 'Mutation', updateMember: Maybe<{ __typename: 'Member', id: string, firstName: Maybe<string>, lastName: Maybe<string>, fianceFirstName: Maybe<string>, fianceLastName: Maybe<string> }>, updateWeddingWebsite: { __typename: 'WWS_WeddingWebsite', id: number, weddingLocation: Maybe<string> } };

export type WwsOnboardingWeddingDatePreferencesQueryVariables = {};


export type WwsOnboardingWeddingDatePreferencesQuery = { __typename?: 'Query', weddingDatePreferences: Maybe<{ __typename?: 'WeddingDatePreferences', datePreference: Maybe<DatePreference>, hideDate: Maybe<boolean>, season: Maybe<SeasonName>, year: Maybe<number>, weddingDate: Maybe<string>, weddingDateFormat: Maybe<string>, weddingDateRangeStart: Maybe<string>, weddingDateRangeEnd: Maybe<string>, hideCountdown: Maybe<boolean> }> };

export type WwsOnboardingUpdateDatePrefMutationVariables = {
  weddingDatePrefAttrs: UpdateWeddingDatePreferencesArgs
};


export type WwsOnboardingUpdateDatePrefMutation = { __typename?: 'Mutation', updateWeddingDatePreferences: Maybe<{ __typename?: 'WeddingDatePreferences', datePreference: Maybe<DatePreference>, year: Maybe<number>, season: Maybe<SeasonName>, hideDate: Maybe<boolean>, weddingDate: Maybe<string>, weddingDateFormat: Maybe<string>, weddingDateRangeStart: Maybe<string>, weddingDateRangeEnd: Maybe<string>, hideCountdown: Maybe<boolean> }> };

export type UpdateDatePrefMutationVariables = {
  weddingDatePrefAttrs: UpdateWeddingDatePreferencesArgs
};


export type UpdateDatePrefMutation = { __typename?: 'Mutation', updateWeddingDatePreferences: Maybe<{ __typename: 'WeddingDatePreferences', datePreference: Maybe<DatePreference>, year: Maybe<number>, season: Maybe<SeasonName>, hideDate: Maybe<boolean>, weddingDate: Maybe<string>, weddingDateFormat: Maybe<string>, weddingDateRangeStart: Maybe<string>, weddingDateRangeEnd: Maybe<string>, hideCountdown: Maybe<boolean> }> };

export type UpdateWeddingDateMutationVariables = {
  date: Scalars['String']
};


export type UpdateWeddingDateMutation = { __typename?: 'Mutation', updateWeddingDate: Maybe<{ __typename?: 'Wedding', id: string, weddingDate: string, budgetRange: string, guestRange: string, market: Maybe<{ __typename?: 'Market', city: Maybe<string>, state: Maybe<string>, country: Maybe<string>, code: Maybe<string> }> }> };

export type UpdateWeddingWebsiteMutationVariables = {
  attributes: Wws_WeddingWebsiteAttributes
};


export type UpdateWeddingWebsiteMutation = { __typename?: 'Mutation', updateWeddingWebsite: { __typename?: 'WWS_WeddingWebsite', id: number, searchable: Maybe<boolean>, slug: string, source: Maybe<string>, state: string, userUuid: Maybe<string>, weddingUuid: Maybe<string>, vanityRoot: Maybe<string>, vanityUrl: Maybe<string>, themeId: Maybe<number> } };

export type FlipperExperimentAssignmentQueryVariables = {
  flipperExperimentBucketId: Scalars['String'],
  flipperExperimentBucketExperimentId: Scalars['String']
};


export type FlipperExperimentAssignmentQuery = { __typename?: 'Query', flipperExperimentBucketAssignment: Maybe<{ __typename?: 'ExperimentBucket', experiment_id: string, variant_name: string, bucketing_id: string }>, flipperExperiment: Maybe<{ __typename?: 'Experiment', experiment_name: string }> };

export type FlipperExperimentBucketQueryVariables = {
  flipperExperimentBucketId: Scalars['String'],
  flipperExperimentBucketExperimentId: Scalars['String'],
  flipperVariantId?: Maybe<Scalars['String']>,
  flipperForce?: Maybe<Scalars['String']>
};


export type FlipperExperimentBucketQuery = { __typename?: 'Query', flipperExperimentBucket: Maybe<{ __typename?: 'ExperimentBucket', experiment_id: string, bucketing_id: string, variant_name: string }>, flipperExperiment: Maybe<{ __typename?: 'Experiment', experiment_name: string }> };

export type MembershipQueryVariables = {};


export type MembershipQuery = { __typename?: 'Query', member: Maybe<{ __typename?: 'Member', id: string, firstName: Maybe<string>, lastName: Maybe<string>, fianceFirstName: Maybe<string>, fianceLastName: Maybe<string>, email: string, legacyUserId: Maybe<string>, username: Maybe<string> }> };

export type PaginateFamilyThemesQueryVariables = {
  nextCursor?: Maybe<Scalars['Int']>,
  take?: Maybe<Scalars['Int']>,
  order?: Maybe<Wws_ThemeOrder>,
  colors?: Maybe<Array<Scalars['String']>>,
  seasons?: Maybe<Array<Scalars['String']>>,
  styles?: Maybe<Array<Scalars['String']>>
};


export type PaginateFamilyThemesQuery = { __typename?: 'Query', paginateFamilyThemes: { __typename?: 'WWS_FamilyThemesPaginatedType', nextCursor: Maybe<number>, hasMore: boolean, results: Maybe<Array<{ __typename?: 'WWS_FamilyThemeSummaryType', family: Maybe<string>, themes: Maybe<Array<{ __typename?: 'WWS_ThemeSummary', categoryData: Maybe<any>, designerUrl: Maybe<string>, family: Maybe<string>, id: Maybe<number>, name: Maybe<string>, mobilePreviewImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string, mediaUrl: string }>, previewImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string, mediaUrl: string }>, swatchImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string }> }>> }>> } };

export type ThemeQueryVariables = {
  id: Scalars['Int']
};


export type ThemeQuery = { __typename?: 'Query', theme: Maybe<{ __typename?: 'WWS_Theme', categoryData: Maybe<any>, designerUrl: Maybe<string>, family: Maybe<string>, id: Maybe<number>, name: Maybe<string>, carouselImages: Maybe<any>, batch: Maybe<number>, testRank: Maybe<number>, mobilePreviewImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string, mediaUrl: string }>, previewImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string, mediaUrl: string }>, swatchImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string }>, themeDesigner: Maybe<{ __typename?: 'WWS_ThemeDesigner', companyName: Maybe<string>, name: Maybe<string> }> }> };

export type ThemesQueryVariables = {
  variant?: Maybe<Wws_FamilyThemeVariant>
};


export type ThemesQuery = { __typename?: 'Query', familyThemes: Array<{ __typename?: 'WWS_FamilyThemeType', family: Maybe<string>, themes: Maybe<Array<{ __typename?: 'WWS_Theme', categoryData: Maybe<any>, designerUrl: Maybe<string>, family: Maybe<string>, id: Maybe<number>, name: Maybe<string>, carouselImages: Maybe<any>, batch: Maybe<number>, testRank: Maybe<number>, mobilePreviewImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string, mediaUrl: string }>, previewImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string, mediaUrl: string }>, swatchImage: Maybe<{ __typename?: 'WWS_Photo', mediaApiId: string }>, themeDesigner: Maybe<{ __typename?: 'WWS_ThemeDesigner', companyName: Maybe<string>, name: Maybe<string> }> }>> }> };

export type WeddingQueryVariables = {};


export type WeddingQuery = { __typename?: 'Query', wedding: Maybe<{ __typename?: 'Wedding', id: string, weddingDate: string, budgetRange: string, guestRange: string, market: Maybe<{ __typename?: 'Market', city: Maybe<string>, state: Maybe<string>, country: Maybe<string>, code: Maybe<string> }> }> };

export type WwsOnboardingWeddingWebsiteQueryVariables = {};


export type WwsOnboardingWeddingWebsiteQuery = { __typename?: 'Query', weddingWebsite: { __typename?: 'WWS_WeddingWebsite', id: number, searchable: Maybe<boolean>, slug: string, source: Maybe<string>, state: string, userUuid: Maybe<string>, weddingUuid: Maybe<string>, vanityRoot: Maybe<string>, vanityUrl: Maybe<string>, themeId: Maybe<number> } };

export const PhotosFragmentDoc = gql`
    fragment Photos on WWS_Photo {
  mediaUrl
  mediaApiId
  width
  height
  cropX
  cropY
  rotation
  aspectRatio {
    name
    value
  }
}
    `;
export const BasicItemsFragmentDoc = gql`
    fragment BasicItems on WWS_BasicItem {
  id
  description
  title
  rank
  type
  photo {
    ...Photos
  }
}
    ${PhotosFragmentDoc}`;
export const StoryItemsFragmentDoc = gql`
    fragment StoryItems on WWS_StoryItem {
  id
  description
  title
  rank
  type
  photo {
    ...Photos
  }
}
    ${PhotosFragmentDoc}`;
export const HeadlineItemsFragmentDoc = gql`
    fragment HeadlineItems on WWS_HeadlineItem {
  id
  title
  type
  style
  rank
}
    `;
export const AccommodationItemsFragmentDoc = gql`
    fragment AccommodationItems on WWS_AccommodationItem {
  id
  email
  rank
  type
  description
  name
  phone
  website
  address
  guestCode
  rate
  checkInDate
  checkOutDate
  hotelPlannerId
  hotelId
  provider
  photo {
    ...Photos
  }
}
    ${PhotosFragmentDoc}`;
export const ActivityItemsFragmentDoc = gql`
    fragment ActivityItems on WWS_ActivityItem {
  id
  rank
  type
  phone
  description
  email
  phone
  website
  address
  name
  photo {
    ...Photos
  }
}
    ${PhotosFragmentDoc}`;
export const TransportationItemsFragmentDoc = gql`
    fragment TransportationItems on WWS_TransportationItem {
  id
  rank
  type
  name
  phone
  address
  website
  description
  email
  photo {
    ...Photos
  }
}
    ${PhotosFragmentDoc}`;
export const ParagraphItemsFragmentDoc = gql`
    fragment ParagraphItems on WWS_ParagraphItem {
  id
  content
  textContent
  type
  rank
}
    `;
export const PersonItemsFragmentDoc = gql`
    fragment PersonItems on WWS_PersonItem {
  id
  type
  name
  description
  role
  rank
  photo {
    ...Photos
  }
}
    ${PhotosFragmentDoc}`;
export const PhotoItemsFragmentDoc = gql`
    fragment PhotoItems on WWS_PhotoItem {
  id
  cropX
  cropY
  height
  mediaApiId
  mediaUrl
  rank
  rotation
  type
  width
  date
  caption
  aspectRatio {
    name
    value
  }
}
    `;
export const PhotoGalleryItemsFragmentDoc = gql`
    fragment PhotoGalleryItems on WWS_PhotoGalleryItem {
  id
  layout
  photoItems {
    ...PhotoItems
  }
  rank
  type
}
    ${PhotoItemsFragmentDoc}`;
export const PhotoTimelineItemsFragmentDoc = gql`
    fragment PhotoTimelineItems on WWS_PhotoTimelineItem {
  id
  layout
  photoItems {
    ...PhotoItems
  }
  rank
  type
}
    ${PhotoItemsFragmentDoc}`;
export const EventGroupItemFragmentDoc = gql`
    fragment EventGroupItem on WWS_EventGroupItem {
  id
  rank
  type
}
    `;
export const GifItemsFragmentDoc = gql`
    fragment GifItems on WWS_GifItem {
  id
  rank
  type
  mediaUrl
}
    `;
export const EmbedItemsFragmentDoc = gql`
    fragment EmbedItems on WWS_EmbedItem {
  id
  rank
  type
  title
  description
  embededCode
  mediaService
}
    `;
export const QuestionItemsFragmentDoc = gql`
    fragment QuestionItems on WWS_QuestionItem {
  id
  rank
  type
  question
  answer
}
    `;
export const LivestreamItemsFragmentDoc = gql`
    fragment LivestreamItems on WWS_LivestreamItem {
  id
  rank
  type
  title
  description
  buttonText
  buttonUrl
}
    `;
export const DressCodeItemsFragmentDoc = gql`
    fragment DressCodeItems on WWS_DressCodeItem {
  id
  rank
  type
  description
  attireCategoryId
  attireDescription
  eventId
  showArticles
  showAffiliates
  articles {
    url
    imageUrl
    title
  }
}
    `;
export const CoverPhotoItemsFragmentDoc = gql`
    fragment CoverPhotoItems on WWS_CoverPhotoItem {
  id
  cropX
  cropY
  focalPoint
  height
  mediaApiId
  mediaUrl
  rank
  rotation
  type
  width
  date
  caption
  aspectRatio {
    name
    value
  }
}
    `;
export const PagesFragmentDoc = gql`
    fragment Pages on WWS_Page {
  id
  title
  rank
  show
  type
  pageGuidance {
    visiblePageDescription
    hiddenPageDescription
  }
  pageItemTypes
  pageItemGuidances {
    type
    icon
    ctaText
    image {
      mediaApiId
    }
  }
  routeName
  supportedImageTypes {
    name
    defaultAspectRatio {
      name
      value
    }
    aspectRatios {
      name
      value
    }
  }
  items {
    id
    rank
    type
    ...BasicItems
    ...StoryItems
    ...HeadlineItems
    ...AccommodationItems
    ...ActivityItems
    ...TransportationItems
    ...ParagraphItems
    ...PersonItems
    ...PhotoItems
    ...PhotoGalleryItems
    ...PhotoTimelineItems
    ...EventGroupItem
    ...GifItems
    ...EmbedItems
    ...QuestionItems
    ...LivestreamItems
    ...DressCodeItems
    ...CoverPhotoItems
  }
}
    ${BasicItemsFragmentDoc}
${StoryItemsFragmentDoc}
${HeadlineItemsFragmentDoc}
${AccommodationItemsFragmentDoc}
${ActivityItemsFragmentDoc}
${TransportationItemsFragmentDoc}
${ParagraphItemsFragmentDoc}
${PersonItemsFragmentDoc}
${PhotoItemsFragmentDoc}
${PhotoGalleryItemsFragmentDoc}
${PhotoTimelineItemsFragmentDoc}
${EventGroupItemFragmentDoc}
${GifItemsFragmentDoc}
${EmbedItemsFragmentDoc}
${QuestionItemsFragmentDoc}
${LivestreamItemsFragmentDoc}
${DressCodeItemsFragmentDoc}
${CoverPhotoItemsFragmentDoc}`;
export const GdsAddressFragmentDoc = gql`
    fragment GDSAddress on GDS_Address {
  street1
  street2
  city
  state
  zip
  country
  fullAddress
}
    `;
export const GdsAnswerFragmentDoc = gql`
    fragment GDSAnswer on GDS_Answer {
  optionId
  questionId
  text
}
    `;
export const PeopleFragmentDoc = gql`
    fragment People on GDS_Person {
  id
  firstName
  lastName
  isLeader
  email
  phone
  preferences {
    emailOptOut
    smsOptOut
  }
  invitations {
    id
    eventId
    rsvp
    answers {
      ...GDSAnswer
    }
  }
}
    ${GdsAnswerFragmentDoc}`;
export const LocationsFragmentDoc = gql`
    fragment Locations on GDS_Location {
  name
  street1
  city
  state
  zip
  country
}
    `;
export const QuestionsFragmentDoc = gql`
    fragment Questions on GDS_Question {
  id
  text
  type
  answerDestination
  answerType
  options {
    id
    text
    description
  }
  isRequired
}
    `;
export const FlipperExperimentBucketAssignmentQueryDocument = gql`
    query flipperExperimentBucketAssignmentQuery($flipperExperimentBucketId: String!, $flipperExperimentBucketExperimentId: String!) {
  flipperExperimentBucketAssignment(bucketId: $flipperExperimentBucketId, experimentId: $flipperExperimentBucketExperimentId) {
    bucketing_id
    variant_name
  }
}
    `;

/**
 * __useFlipperExperimentBucketAssignmentQuery__
 *
 * To run a query within a React component, call `useFlipperExperimentBucketAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlipperExperimentBucketAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlipperExperimentBucketAssignmentQuery({
 *   variables: {
 *      flipperExperimentBucketId: // value for 'flipperExperimentBucketId'
 *      flipperExperimentBucketExperimentId: // value for 'flipperExperimentBucketExperimentId'
 *   },
 * });
 */
export function useFlipperExperimentBucketAssignmentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FlipperExperimentBucketAssignmentQuery, FlipperExperimentBucketAssignmentQueryVariables>) {
        return ApolloReactHooks.useQuery<FlipperExperimentBucketAssignmentQuery, FlipperExperimentBucketAssignmentQueryVariables>(FlipperExperimentBucketAssignmentQueryDocument, baseOptions);
      }
export function useFlipperExperimentBucketAssignmentQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FlipperExperimentBucketAssignmentQuery, FlipperExperimentBucketAssignmentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FlipperExperimentBucketAssignmentQuery, FlipperExperimentBucketAssignmentQueryVariables>(FlipperExperimentBucketAssignmentQueryDocument, baseOptions);
        }
export type FlipperExperimentBucketAssignmentQueryHookResult = ReturnType<typeof useFlipperExperimentBucketAssignmentQuery>;
export type FlipperExperimentBucketAssignmentQueryLazyQueryHookResult = ReturnType<typeof useFlipperExperimentBucketAssignmentQueryLazyQuery>;
export type FlipperExperimentBucketAssignmentQueryQueryResult = ApolloReactCommon.QueryResult<FlipperExperimentBucketAssignmentQuery, FlipperExperimentBucketAssignmentQueryVariables>;
export const VariantContextMembershipQueryDocument = gql`
    query VariantContextMembershipQuery {
  member {
    id
    firstName
    lastName
    fianceFirstName
    fianceLastName
    email
    legacyUserId
    username
  }
}
    `;

/**
 * __useVariantContextMembershipQuery__
 *
 * To run a query within a React component, call `useVariantContextMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useVariantContextMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVariantContextMembershipQuery({
 *   variables: {
 *   },
 * });
 */
export function useVariantContextMembershipQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VariantContextMembershipQuery, VariantContextMembershipQueryVariables>) {
        return ApolloReactHooks.useQuery<VariantContextMembershipQuery, VariantContextMembershipQueryVariables>(VariantContextMembershipQueryDocument, baseOptions);
      }
export function useVariantContextMembershipQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VariantContextMembershipQuery, VariantContextMembershipQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<VariantContextMembershipQuery, VariantContextMembershipQueryVariables>(VariantContextMembershipQueryDocument, baseOptions);
        }
export type VariantContextMembershipQueryHookResult = ReturnType<typeof useVariantContextMembershipQuery>;
export type VariantContextMembershipQueryLazyQueryHookResult = ReturnType<typeof useVariantContextMembershipQueryLazyQuery>;
export type VariantContextMembershipQueryQueryResult = ApolloReactCommon.QueryResult<VariantContextMembershipQuery, VariantContextMembershipQueryVariables>;
export const VariantContextThemesQueryDocument = gql`
    query VariantContextThemesQuery($variant: WWS_FamilyThemeVariant) {
  familyThemes(variant: $variant) {
    family
    themes {
      active
      designerUrl
      family
      id
      mobilePreviewImage {
        mediaApiId
      }
      name
      previewImage {
        mediaApiId
      }
      swatchImage {
        mediaApiId
      }
      stationaryPreviewImage {
        mediaApiId
      }
      themeDesigner {
        companyName
        name
      }
      previewUrl
    }
  }
}
    `;

/**
 * __useVariantContextThemesQuery__
 *
 * To run a query within a React component, call `useVariantContextThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVariantContextThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVariantContextThemesQuery({
 *   variables: {
 *      variant: // value for 'variant'
 *   },
 * });
 */
export function useVariantContextThemesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VariantContextThemesQuery, VariantContextThemesQueryVariables>) {
        return ApolloReactHooks.useQuery<VariantContextThemesQuery, VariantContextThemesQueryVariables>(VariantContextThemesQueryDocument, baseOptions);
      }
export function useVariantContextThemesQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VariantContextThemesQuery, VariantContextThemesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<VariantContextThemesQuery, VariantContextThemesQueryVariables>(VariantContextThemesQueryDocument, baseOptions);
        }
export type VariantContextThemesQueryHookResult = ReturnType<typeof useVariantContextThemesQuery>;
export type VariantContextThemesQueryLazyQueryHookResult = ReturnType<typeof useVariantContextThemesQueryLazyQuery>;
export type VariantContextThemesQueryQueryResult = ApolloReactCommon.QueryResult<VariantContextThemesQuery, VariantContextThemesQueryVariables>;
export const UpdateConversationalAiSettingsDocument = gql`
    mutation UpdateConversationalAiSettings($args: AiSettingsArgs) {
  updateConversationalAiSettings(args: $args)
}
    `;
export type UpdateConversationalAiSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateConversationalAiSettingsMutation, UpdateConversationalAiSettingsMutationVariables>;

/**
 * __useUpdateConversationalAiSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateConversationalAiSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConversationalAiSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConversationalAiSettingsMutation, { data, loading, error }] = useUpdateConversationalAiSettingsMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useUpdateConversationalAiSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateConversationalAiSettingsMutation, UpdateConversationalAiSettingsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateConversationalAiSettingsMutation, UpdateConversationalAiSettingsMutationVariables>(UpdateConversationalAiSettingsDocument, baseOptions);
      }
export type UpdateConversationalAiSettingsMutationHookResult = ReturnType<typeof useUpdateConversationalAiSettingsMutation>;
export type UpdateConversationalAiSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateConversationalAiSettingsMutation>;
export type UpdateConversationalAiSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateConversationalAiSettingsMutation, UpdateConversationalAiSettingsMutationVariables>;
export const UpdateDatePrefMutationBasicInfoRailDocument = gql`
    mutation updateDatePrefMutationBasicInfoRail($weddingDatePrefAttrs: UpdateWeddingDatePreferencesArgs!) {
  updateWeddingDatePreferences(args: $weddingDatePrefAttrs) {
    datePreference
    year
    season
    hideDate
    weddingDate
    weddingDateFormat
    weddingDateRangeStart
    weddingDateRangeEnd
    hideCountdown
  }
}
    `;
export type UpdateDatePrefMutationBasicInfoRailMutationFn = ApolloReactCommon.MutationFunction<UpdateDatePrefMutationBasicInfoRailMutation, UpdateDatePrefMutationBasicInfoRailMutationVariables>;

/**
 * __useUpdateDatePrefMutationBasicInfoRail__
 *
 * To run a mutation, you first call `useUpdateDatePrefMutationBasicInfoRail` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDatePrefMutationBasicInfoRail` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDatePrefMutationBasicInfoRail, { data, loading, error }] = useUpdateDatePrefMutationBasicInfoRail({
 *   variables: {
 *      weddingDatePrefAttrs: // value for 'weddingDatePrefAttrs'
 *   },
 * });
 */
export function useUpdateDatePrefMutationBasicInfoRail(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDatePrefMutationBasicInfoRailMutation, UpdateDatePrefMutationBasicInfoRailMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateDatePrefMutationBasicInfoRailMutation, UpdateDatePrefMutationBasicInfoRailMutationVariables>(UpdateDatePrefMutationBasicInfoRailDocument, baseOptions);
      }
export type UpdateDatePrefMutationBasicInfoRailHookResult = ReturnType<typeof useUpdateDatePrefMutationBasicInfoRail>;
export type UpdateDatePrefMutationBasicInfoRailMutationResult = ApolloReactCommon.MutationResult<UpdateDatePrefMutationBasicInfoRailMutation>;
export type UpdateDatePrefMutationBasicInfoRailMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDatePrefMutationBasicInfoRailMutation, UpdateDatePrefMutationBasicInfoRailMutationVariables>;
export const CreateAnnouncementMutationDocument = gql`
    mutation createAnnouncementMutation($attributes: WWS_CreateAnnouncementAttrs!) {
  createAnnouncement(attributes: $attributes) {
    id
    message
    show
  }
}
    `;
export type CreateAnnouncementMutationMutationFn = ApolloReactCommon.MutationFunction<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;

/**
 * __useCreateAnnouncementMutation__
 *
 * To run a mutation, you first call `useCreateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnouncementMutation, { data, loading, error }] = useCreateAnnouncementMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateAnnouncementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>(CreateAnnouncementMutationDocument, baseOptions);
      }
export type CreateAnnouncementMutationHookResult = ReturnType<typeof useCreateAnnouncementMutation>;
export type CreateAnnouncementMutationMutationResult = ApolloReactCommon.MutationResult<CreateAnnouncementMutation>;
export type CreateAnnouncementMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;
export const UpdateAnnouncementMutationDocument = gql`
    mutation updateAnnouncementMutation($attributes: WWS_UpdateAnnouncementAttributes!) {
  updateAnnouncement(attributes: $attributes) {
    id
    message
    show
  }
}
    `;
export type UpdateAnnouncementMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>;

/**
 * __useUpdateAnnouncementMutation__
 *
 * To run a mutation, you first call `useUpdateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnnouncementMutation, { data, loading, error }] = useUpdateAnnouncementMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateAnnouncementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>(UpdateAnnouncementMutationDocument, baseOptions);
      }
export type UpdateAnnouncementMutationHookResult = ReturnType<typeof useUpdateAnnouncementMutation>;
export type UpdateAnnouncementMutationMutationResult = ApolloReactCommon.MutationResult<UpdateAnnouncementMutation>;
export type UpdateAnnouncementMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>;
export const WeddingDatePreferencesDocument = gql`
    query weddingDatePreferences {
  weddingDatePreferences {
    datePreference
    hideDate
    season
    year
    weddingDate
    weddingDateFormat
    weddingDateRangeStart
    weddingDateRangeEnd
    hideCountdown
  }
}
    `;

/**
 * __useWeddingDatePreferencesQuery__
 *
 * To run a query within a React component, call `useWeddingDatePreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeddingDatePreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeddingDatePreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useWeddingDatePreferencesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WeddingDatePreferencesQuery, WeddingDatePreferencesQueryVariables>) {
        return ApolloReactHooks.useQuery<WeddingDatePreferencesQuery, WeddingDatePreferencesQueryVariables>(WeddingDatePreferencesDocument, baseOptions);
      }
export function useWeddingDatePreferencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WeddingDatePreferencesQuery, WeddingDatePreferencesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<WeddingDatePreferencesQuery, WeddingDatePreferencesQueryVariables>(WeddingDatePreferencesDocument, baseOptions);
        }
export type WeddingDatePreferencesQueryHookResult = ReturnType<typeof useWeddingDatePreferencesQuery>;
export type WeddingDatePreferencesLazyQueryHookResult = ReturnType<typeof useWeddingDatePreferencesLazyQuery>;
export type WeddingDatePreferencesQueryResult = ApolloReactCommon.QueryResult<WeddingDatePreferencesQuery, WeddingDatePreferencesQueryVariables>;
export const WeddingWebsiteQueryDocument = gql`
    query weddingWebsiteQuery {
  weddingWebsite {
    id
    announcement {
      id
      message
      show
    }
    legacyMigrated
    searchable
    pin
    pinProtect
    state
    websiteCreatedAt
    source
    purchaseDomain {
      id
      name
      showRenewal
      isRenewable
      isInRedemptionPeriod
      isExpired
      expirationDate
      dateOfLastRenewal
      renewalPrice
      createdAt
    }
    vanityRoot
    vanityUrl
    slug
    registryNote
    coverPhoto {
      mediaApiId
      mediaUrl
      cropX
      cropY
      width
      height
      originalMediaUrl
    }
    state
    hideCountdown
    hideDate
    weddingDateFormat
    weddingDateRangeStart
    weddingDateRangeEnd
    weddingLocation
    themeId
    firstDashboardInteraction
    adminVersion
    isNewTemplate
    wwsUrl
    layout
  }
  member {
    id
    firstName
    lastName
    fianceFirstName
    fianceLastName
    email
    isEmailVerified
    aiSettings {
      useConversationalMemory
    }
  }
  wedding {
    id
    weddingDate
    guestRange
    season {
      name
      year
    }
  }
  guestWedding {
    id
    createdAt
    updatedAt
    isPrivateRsvp
    sendRsvpReminder
    allowGuestPreview
    usesSubEvents
    questions {
      id
      text
      type
      isRequired
      answerType
      answerDestination
      options {
        id
        text
        description
      }
    }
    rsvpDeadline
    rsvpMedium
    rsvpPageHidden
    rsvpWorkflow
  }
}
    `;

/**
 * __useWeddingWebsiteQuery__
 *
 * To run a query within a React component, call `useWeddingWebsiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeddingWebsiteQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeddingWebsiteQuery({
 *   variables: {
 *   },
 * });
 */
export function useWeddingWebsiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WeddingWebsiteQuery, WeddingWebsiteQueryVariables>) {
        return ApolloReactHooks.useQuery<WeddingWebsiteQuery, WeddingWebsiteQueryVariables>(WeddingWebsiteQueryDocument, baseOptions);
      }
export function useWeddingWebsiteQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WeddingWebsiteQuery, WeddingWebsiteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<WeddingWebsiteQuery, WeddingWebsiteQueryVariables>(WeddingWebsiteQueryDocument, baseOptions);
        }
export type WeddingWebsiteQueryHookResult = ReturnType<typeof useWeddingWebsiteQuery>;
export type WeddingWebsiteQueryLazyQueryHookResult = ReturnType<typeof useWeddingWebsiteQueryLazyQuery>;
export type WeddingWebsiteQueryQueryResult = ApolloReactCommon.QueryResult<WeddingWebsiteQuery, WeddingWebsiteQueryVariables>;
export const ReactivateWeddingWebsiteMutationDocument = gql`
    mutation reactivateWeddingWebsiteMutation {
  reactivateWeddingWebsite {
    id
    state
  }
}
    `;
export type ReactivateWeddingWebsiteMutationMutationFn = ApolloReactCommon.MutationFunction<ReactivateWeddingWebsiteMutation, ReactivateWeddingWebsiteMutationVariables>;

/**
 * __useReactivateWeddingWebsiteMutation__
 *
 * To run a mutation, you first call `useReactivateWeddingWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateWeddingWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateWeddingWebsiteMutation, { data, loading, error }] = useReactivateWeddingWebsiteMutation({
 *   variables: {
 *   },
 * });
 */
export function useReactivateWeddingWebsiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReactivateWeddingWebsiteMutation, ReactivateWeddingWebsiteMutationVariables>) {
        return ApolloReactHooks.useMutation<ReactivateWeddingWebsiteMutation, ReactivateWeddingWebsiteMutationVariables>(ReactivateWeddingWebsiteMutationDocument, baseOptions);
      }
export type ReactivateWeddingWebsiteMutationHookResult = ReturnType<typeof useReactivateWeddingWebsiteMutation>;
export type ReactivateWeddingWebsiteMutationMutationResult = ApolloReactCommon.MutationResult<ReactivateWeddingWebsiteMutation>;
export type ReactivateWeddingWebsiteMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ReactivateWeddingWebsiteMutation, ReactivateWeddingWebsiteMutationVariables>;
export const UpdateFirstInteractionDocument = gql`
    mutation updateFirstInteraction($attributes: WWS_WeddingWebsiteAttributes!) {
  updateWeddingWebsite(attributes: $attributes) {
    id
    firstDashboardInteraction
  }
}
    `;
export type UpdateFirstInteractionMutationFn = ApolloReactCommon.MutationFunction<UpdateFirstInteractionMutation, UpdateFirstInteractionMutationVariables>;

/**
 * __useUpdateFirstInteractionMutation__
 *
 * To run a mutation, you first call `useUpdateFirstInteractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFirstInteractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFirstInteractionMutation, { data, loading, error }] = useUpdateFirstInteractionMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateFirstInteractionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFirstInteractionMutation, UpdateFirstInteractionMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateFirstInteractionMutation, UpdateFirstInteractionMutationVariables>(UpdateFirstInteractionDocument, baseOptions);
      }
export type UpdateFirstInteractionMutationHookResult = ReturnType<typeof useUpdateFirstInteractionMutation>;
export type UpdateFirstInteractionMutationResult = ApolloReactCommon.MutationResult<UpdateFirstInteractionMutation>;
export type UpdateFirstInteractionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateFirstInteractionMutation, UpdateFirstInteractionMutationVariables>;
export const WwsViewCountQueryDocument = gql`
    query WWSViewCountQuery {
  wwsViewCount {
    website_visitors_total
    website_visitors_recent
  }
}
    `;

/**
 * __useWwsViewCountQuery__
 *
 * To run a query within a React component, call `useWwsViewCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useWwsViewCountQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWwsViewCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useWwsViewCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WwsViewCountQuery, WwsViewCountQueryVariables>) {
        return ApolloReactHooks.useQuery<WwsViewCountQuery, WwsViewCountQueryVariables>(WwsViewCountQueryDocument, baseOptions);
      }
export function useWwsViewCountQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WwsViewCountQuery, WwsViewCountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<WwsViewCountQuery, WwsViewCountQueryVariables>(WwsViewCountQueryDocument, baseOptions);
        }
export type WwsViewCountQueryHookResult = ReturnType<typeof useWwsViewCountQuery>;
export type WwsViewCountQueryLazyQueryHookResult = ReturnType<typeof useWwsViewCountQueryLazyQuery>;
export type WwsViewCountQueryQueryResult = ApolloReactCommon.QueryResult<WwsViewCountQuery, WwsViewCountQueryVariables>;
export const BucketRsvpWorkflowMutationDocument = gql`
    mutation bucketRSVPWorkflowMutation {
  bucketRSVPWorkflow {
    id
    rsvpWorkflow
    rsvpPageHidden
  }
}
    `;
export type BucketRsvpWorkflowMutationMutationFn = ApolloReactCommon.MutationFunction<BucketRsvpWorkflowMutation, BucketRsvpWorkflowMutationVariables>;

/**
 * __useBucketRsvpWorkflowMutation__
 *
 * To run a mutation, you first call `useBucketRsvpWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBucketRsvpWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bucketRsvpWorkflowMutation, { data, loading, error }] = useBucketRsvpWorkflowMutation({
 *   variables: {
 *   },
 * });
 */
export function useBucketRsvpWorkflowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BucketRsvpWorkflowMutation, BucketRsvpWorkflowMutationVariables>) {
        return ApolloReactHooks.useMutation<BucketRsvpWorkflowMutation, BucketRsvpWorkflowMutationVariables>(BucketRsvpWorkflowMutationDocument, baseOptions);
      }
export type BucketRsvpWorkflowMutationHookResult = ReturnType<typeof useBucketRsvpWorkflowMutation>;
export type BucketRsvpWorkflowMutationMutationResult = ApolloReactCommon.MutationResult<BucketRsvpWorkflowMutation>;
export type BucketRsvpWorkflowMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<BucketRsvpWorkflowMutation, BucketRsvpWorkflowMutationVariables>;
export const PagesQueryDocument = gql`
    query pagesQuery {
  pages {
    ...Pages
  }
}
    ${PagesFragmentDoc}`;

/**
 * __usePagesQuery__
 *
 * To run a query within a React component, call `usePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PagesQuery, PagesQueryVariables>) {
        return ApolloReactHooks.useQuery<PagesQuery, PagesQueryVariables>(PagesQueryDocument, baseOptions);
      }
export function usePagesQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PagesQuery, PagesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PagesQuery, PagesQueryVariables>(PagesQueryDocument, baseOptions);
        }
export type PagesQueryHookResult = ReturnType<typeof usePagesQuery>;
export type PagesQueryLazyQueryHookResult = ReturnType<typeof usePagesQueryLazyQuery>;
export type PagesQueryQueryResult = ApolloReactCommon.QueryResult<PagesQuery, PagesQueryVariables>;
export const CreateCoverPhotoItemMutationDocument = gql`
    mutation createCoverPhotoItemMutation($attributes: WWS_CreatePhotoItemAttrs!) {
  coverPhotoItem: createCoverPhotoItem(attributes: $attributes) {
    id
    cropX
    cropY
    focalPoint
    height
    mediaApiId
    mediaUrl
    rank
    rotation
    type
    width
    date
    caption
    aspectRatio {
      name
      value
    }
  }
}
    `;
export type CreateCoverPhotoItemMutationMutationFn = ApolloReactCommon.MutationFunction<CreateCoverPhotoItemMutation, CreateCoverPhotoItemMutationVariables>;

/**
 * __useCreateCoverPhotoItemMutation__
 *
 * To run a mutation, you first call `useCreateCoverPhotoItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoverPhotoItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoverPhotoItemMutation, { data, loading, error }] = useCreateCoverPhotoItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateCoverPhotoItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCoverPhotoItemMutation, CreateCoverPhotoItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCoverPhotoItemMutation, CreateCoverPhotoItemMutationVariables>(CreateCoverPhotoItemMutationDocument, baseOptions);
      }
export type CreateCoverPhotoItemMutationHookResult = ReturnType<typeof useCreateCoverPhotoItemMutation>;
export type CreateCoverPhotoItemMutationMutationResult = ApolloReactCommon.MutationResult<CreateCoverPhotoItemMutation>;
export type CreateCoverPhotoItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCoverPhotoItemMutation, CreateCoverPhotoItemMutationVariables>;
export const UpdateCoverPhotoItemMutationDocument = gql`
    mutation updateCoverPhotoItemMutation($attributes: WWS_UpdatePhotoItemAttrs!) {
  coverPhotoItem: updateCoverPhotoItem(attributes: $attributes) {
    id
    ...CoverPhotoItems
  }
}
    ${CoverPhotoItemsFragmentDoc}`;
export type UpdateCoverPhotoItemMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateCoverPhotoItemMutation, UpdateCoverPhotoItemMutationVariables>;

/**
 * __useUpdateCoverPhotoItemMutation__
 *
 * To run a mutation, you first call `useUpdateCoverPhotoItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoverPhotoItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoverPhotoItemMutation, { data, loading, error }] = useUpdateCoverPhotoItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateCoverPhotoItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCoverPhotoItemMutation, UpdateCoverPhotoItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCoverPhotoItemMutation, UpdateCoverPhotoItemMutationVariables>(UpdateCoverPhotoItemMutationDocument, baseOptions);
      }
export type UpdateCoverPhotoItemMutationHookResult = ReturnType<typeof useUpdateCoverPhotoItemMutation>;
export type UpdateCoverPhotoItemMutationMutationResult = ApolloReactCommon.MutationResult<UpdateCoverPhotoItemMutation>;
export type UpdateCoverPhotoItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCoverPhotoItemMutation, UpdateCoverPhotoItemMutationVariables>;
export const DeleteCoverPhotoItemMutationDocument = gql`
    mutation deleteCoverPhotoItemMutation($attributes: WWS_DeletePageItemAttributes!) {
  deletePageItem(attributes: $attributes)
}
    `;
export type DeleteCoverPhotoItemMutationMutationFn = ApolloReactCommon.MutationFunction<DeleteCoverPhotoItemMutation, DeleteCoverPhotoItemMutationVariables>;

/**
 * __useDeleteCoverPhotoItemMutation__
 *
 * To run a mutation, you first call `useDeleteCoverPhotoItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoverPhotoItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoverPhotoItemMutation, { data, loading, error }] = useDeleteCoverPhotoItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDeleteCoverPhotoItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCoverPhotoItemMutation, DeleteCoverPhotoItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteCoverPhotoItemMutation, DeleteCoverPhotoItemMutationVariables>(DeleteCoverPhotoItemMutationDocument, baseOptions);
      }
export type DeleteCoverPhotoItemMutationHookResult = ReturnType<typeof useDeleteCoverPhotoItemMutation>;
export type DeleteCoverPhotoItemMutationMutationResult = ApolloReactCommon.MutationResult<DeleteCoverPhotoItemMutation>;
export type DeleteCoverPhotoItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCoverPhotoItemMutation, DeleteCoverPhotoItemMutationVariables>;
export const CreatePageMutationDocument = gql`
    mutation createPageMutation($attributes: WWS_PageAttributes!) {
  createPage(attributes: $attributes) {
    ...Pages
  }
}
    ${PagesFragmentDoc}`;
export type CreatePageMutationMutationFn = ApolloReactCommon.MutationFunction<CreatePageMutation, CreatePageMutationVariables>;

/**
 * __useCreatePageMutation__
 *
 * To run a mutation, you first call `useCreatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageMutation, { data, loading, error }] = useCreatePageMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreatePageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePageMutation, CreatePageMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePageMutation, CreatePageMutationVariables>(CreatePageMutationDocument, baseOptions);
      }
export type CreatePageMutationHookResult = ReturnType<typeof useCreatePageMutation>;
export type CreatePageMutationMutationResult = ApolloReactCommon.MutationResult<CreatePageMutation>;
export type CreatePageMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePageMutation, CreatePageMutationVariables>;
export const UpdatePagesMutationDocument = gql`
    mutation updatePagesMutation($pages: [WWS_UpdatePageAttributes!]!) {
  updatePages(pages: $pages) {
    ...Pages
  }
}
    ${PagesFragmentDoc}`;
export type UpdatePagesMutationMutationFn = ApolloReactCommon.MutationFunction<UpdatePagesMutation, UpdatePagesMutationVariables>;

/**
 * __useUpdatePagesMutation__
 *
 * To run a mutation, you first call `useUpdatePagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePagesMutation, { data, loading, error }] = useUpdatePagesMutation({
 *   variables: {
 *      pages: // value for 'pages'
 *   },
 * });
 */
export function useUpdatePagesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePagesMutation, UpdatePagesMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePagesMutation, UpdatePagesMutationVariables>(UpdatePagesMutationDocument, baseOptions);
      }
export type UpdatePagesMutationHookResult = ReturnType<typeof useUpdatePagesMutation>;
export type UpdatePagesMutationMutationResult = ApolloReactCommon.MutationResult<UpdatePagesMutation>;
export type UpdatePagesMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePagesMutation, UpdatePagesMutationVariables>;
export const MessagingSequencesQueryDocument = gql`
    query messagingSequencesQuery {
  messagingSequences {
    mediaId
    displayName
    sequenceType
    description
    shortDescription
    supportedTypes {
      id
      type
    }
  }
}
    `;

/**
 * __useMessagingSequencesQuery__
 *
 * To run a query within a React component, call `useMessagingSequencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagingSequencesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagingSequencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMessagingSequencesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MessagingSequencesQuery, MessagingSequencesQueryVariables>) {
        return ApolloReactHooks.useQuery<MessagingSequencesQuery, MessagingSequencesQueryVariables>(MessagingSequencesQueryDocument, baseOptions);
      }
export function useMessagingSequencesQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MessagingSequencesQuery, MessagingSequencesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MessagingSequencesQuery, MessagingSequencesQueryVariables>(MessagingSequencesQueryDocument, baseOptions);
        }
export type MessagingSequencesQueryHookResult = ReturnType<typeof useMessagingSequencesQuery>;
export type MessagingSequencesQueryLazyQueryHookResult = ReturnType<typeof useMessagingSequencesQueryLazyQuery>;
export type MessagingSequencesQueryQueryResult = ApolloReactCommon.QueryResult<MessagingSequencesQuery, MessagingSequencesQueryVariables>;
export const WeddingInfoQueryDocument = gql`
    query weddingInfoQuery {
  weddingWebsite {
    weddingLocation
  }
  member {
    lastName
    firstName
    fianceLastName
    fianceFirstName
  }
  wedding {
    weddingDate
  }
}
    `;

/**
 * __useWeddingInfoQuery__
 *
 * To run a query within a React component, call `useWeddingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeddingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeddingInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useWeddingInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WeddingInfoQuery, WeddingInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<WeddingInfoQuery, WeddingInfoQueryVariables>(WeddingInfoQueryDocument, baseOptions);
      }
export function useWeddingInfoQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WeddingInfoQuery, WeddingInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<WeddingInfoQuery, WeddingInfoQueryVariables>(WeddingInfoQueryDocument, baseOptions);
        }
export type WeddingInfoQueryHookResult = ReturnType<typeof useWeddingInfoQuery>;
export type WeddingInfoQueryLazyQueryHookResult = ReturnType<typeof useWeddingInfoQueryLazyQuery>;
export type WeddingInfoQueryQueryResult = ApolloReactCommon.QueryResult<WeddingInfoQuery, WeddingInfoQueryVariables>;
export const GuestMessagingStatusesLiteQueryDocument = gql`
    query guestMessagingStatusesLiteQuery {
  guestMessagingStatuses {
    batchId
  }
}
    `;

/**
 * __useGuestMessagingStatusesLiteQuery__
 *
 * To run a query within a React component, call `useGuestMessagingStatusesLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestMessagingStatusesLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestMessagingStatusesLiteQuery({
 *   variables: {
 *   },
 * });
 */
export function useGuestMessagingStatusesLiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GuestMessagingStatusesLiteQuery, GuestMessagingStatusesLiteQueryVariables>) {
        return ApolloReactHooks.useQuery<GuestMessagingStatusesLiteQuery, GuestMessagingStatusesLiteQueryVariables>(GuestMessagingStatusesLiteQueryDocument, baseOptions);
      }
export function useGuestMessagingStatusesLiteQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestMessagingStatusesLiteQuery, GuestMessagingStatusesLiteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GuestMessagingStatusesLiteQuery, GuestMessagingStatusesLiteQueryVariables>(GuestMessagingStatusesLiteQueryDocument, baseOptions);
        }
export type GuestMessagingStatusesLiteQueryHookResult = ReturnType<typeof useGuestMessagingStatusesLiteQuery>;
export type GuestMessagingStatusesLiteQueryLazyQueryHookResult = ReturnType<typeof useGuestMessagingStatusesLiteQueryLazyQuery>;
export type GuestMessagingStatusesLiteQueryQueryResult = ApolloReactCommon.QueryResult<GuestMessagingStatusesLiteQuery, GuestMessagingStatusesLiteQueryVariables>;
export const GuestMessagingStatusesQueryDocument = gql`
    query guestMessagingStatusesQuery {
  guestMessagingStatuses {
    batchId
    sentDate
    sequenceDisplayName
    type
    guests {
      id
      status
      reply
      person {
        firstName
        lastName
        email
        phone
      }
    }
  }
}
    `;

/**
 * __useGuestMessagingStatusesQuery__
 *
 * To run a query within a React component, call `useGuestMessagingStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestMessagingStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestMessagingStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGuestMessagingStatusesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GuestMessagingStatusesQuery, GuestMessagingStatusesQueryVariables>) {
        return ApolloReactHooks.useQuery<GuestMessagingStatusesQuery, GuestMessagingStatusesQueryVariables>(GuestMessagingStatusesQueryDocument, baseOptions);
      }
export function useGuestMessagingStatusesQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestMessagingStatusesQuery, GuestMessagingStatusesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GuestMessagingStatusesQuery, GuestMessagingStatusesQueryVariables>(GuestMessagingStatusesQueryDocument, baseOptions);
        }
export type GuestMessagingStatusesQueryHookResult = ReturnType<typeof useGuestMessagingStatusesQuery>;
export type GuestMessagingStatusesQueryLazyQueryHookResult = ReturnType<typeof useGuestMessagingStatusesQueryLazyQuery>;
export type GuestMessagingStatusesQueryQueryResult = ApolloReactCommon.QueryResult<GuestMessagingStatusesQuery, GuestMessagingStatusesQueryVariables>;
export const SendCovidEmailMutationDocument = gql`
    mutation sendCovidEmailMutation($args: NoLinkEmailArgs!) {
  sendCovidEmail(args: $args)
}
    `;
export type SendCovidEmailMutationMutationFn = ApolloReactCommon.MutationFunction<SendCovidEmailMutation, SendCovidEmailMutationVariables>;

/**
 * __useSendCovidEmailMutation__
 *
 * To run a mutation, you first call `useSendCovidEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCovidEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCovidEmailMutation, { data, loading, error }] = useSendCovidEmailMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSendCovidEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendCovidEmailMutation, SendCovidEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendCovidEmailMutation, SendCovidEmailMutationVariables>(SendCovidEmailMutationDocument, baseOptions);
      }
export type SendCovidEmailMutationHookResult = ReturnType<typeof useSendCovidEmailMutation>;
export type SendCovidEmailMutationMutationResult = ApolloReactCommon.MutationResult<SendCovidEmailMutation>;
export type SendCovidEmailMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendCovidEmailMutation, SendCovidEmailMutationVariables>;
export const SendCovidSmsMutationDocument = gql`
    mutation sendCovidSmsMutation($args: SmsArgs!) {
  sendCovidSms(args: $args)
}
    `;
export type SendCovidSmsMutationMutationFn = ApolloReactCommon.MutationFunction<SendCovidSmsMutation, SendCovidSmsMutationVariables>;

/**
 * __useSendCovidSmsMutation__
 *
 * To run a mutation, you first call `useSendCovidSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCovidSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCovidSmsMutation, { data, loading, error }] = useSendCovidSmsMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSendCovidSmsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendCovidSmsMutation, SendCovidSmsMutationVariables>) {
        return ApolloReactHooks.useMutation<SendCovidSmsMutation, SendCovidSmsMutationVariables>(SendCovidSmsMutationDocument, baseOptions);
      }
export type SendCovidSmsMutationHookResult = ReturnType<typeof useSendCovidSmsMutation>;
export type SendCovidSmsMutationMutationResult = ApolloReactCommon.MutationResult<SendCovidSmsMutation>;
export type SendCovidSmsMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendCovidSmsMutation, SendCovidSmsMutationVariables>;
export const SendCustomSmsMutationDocument = gql`
    mutation sendCustomSmsMutation($args: SmsArgs!) {
  sendCustomSms(args: $args)
}
    `;
export type SendCustomSmsMutationMutationFn = ApolloReactCommon.MutationFunction<SendCustomSmsMutation, SendCustomSmsMutationVariables>;

/**
 * __useSendCustomSmsMutation__
 *
 * To run a mutation, you first call `useSendCustomSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCustomSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCustomSmsMutation, { data, loading, error }] = useSendCustomSmsMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSendCustomSmsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendCustomSmsMutation, SendCustomSmsMutationVariables>) {
        return ApolloReactHooks.useMutation<SendCustomSmsMutation, SendCustomSmsMutationVariables>(SendCustomSmsMutationDocument, baseOptions);
      }
export type SendCustomSmsMutationHookResult = ReturnType<typeof useSendCustomSmsMutation>;
export type SendCustomSmsMutationMutationResult = ApolloReactCommon.MutationResult<SendCustomSmsMutation>;
export type SendCustomSmsMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendCustomSmsMutation, SendCustomSmsMutationVariables>;
export const SendCustomEmailMutationDocument = gql`
    mutation sendCustomEmailMutation($args: NoLinkEmailArgs!) {
  sendCustomEmail(args: $args)
}
    `;
export type SendCustomEmailMutationMutationFn = ApolloReactCommon.MutationFunction<SendCustomEmailMutation, SendCustomEmailMutationVariables>;

/**
 * __useSendCustomEmailMutation__
 *
 * To run a mutation, you first call `useSendCustomEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCustomEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCustomEmailMutation, { data, loading, error }] = useSendCustomEmailMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSendCustomEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendCustomEmailMutation, SendCustomEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendCustomEmailMutation, SendCustomEmailMutationVariables>(SendCustomEmailMutationDocument, baseOptions);
      }
export type SendCustomEmailMutationHookResult = ReturnType<typeof useSendCustomEmailMutation>;
export type SendCustomEmailMutationMutationResult = ApolloReactCommon.MutationResult<SendCustomEmailMutation>;
export type SendCustomEmailMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendCustomEmailMutation, SendCustomEmailMutationVariables>;
export const SendAddressCollectionSmsMutationDocument = gql`
    mutation sendAddressCollectionSmsMutation($args: SmsArgs!) {
  sendAddressCollectionSms(args: $args)
}
    `;
export type SendAddressCollectionSmsMutationMutationFn = ApolloReactCommon.MutationFunction<SendAddressCollectionSmsMutation, SendAddressCollectionSmsMutationVariables>;

/**
 * __useSendAddressCollectionSmsMutation__
 *
 * To run a mutation, you first call `useSendAddressCollectionSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAddressCollectionSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAddressCollectionSmsMutation, { data, loading, error }] = useSendAddressCollectionSmsMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSendAddressCollectionSmsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendAddressCollectionSmsMutation, SendAddressCollectionSmsMutationVariables>) {
        return ApolloReactHooks.useMutation<SendAddressCollectionSmsMutation, SendAddressCollectionSmsMutationVariables>(SendAddressCollectionSmsMutationDocument, baseOptions);
      }
export type SendAddressCollectionSmsMutationHookResult = ReturnType<typeof useSendAddressCollectionSmsMutation>;
export type SendAddressCollectionSmsMutationMutationResult = ApolloReactCommon.MutationResult<SendAddressCollectionSmsMutation>;
export type SendAddressCollectionSmsMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendAddressCollectionSmsMutation, SendAddressCollectionSmsMutationVariables>;
export const SendAddressCollectionEmailMutationDocument = gql`
    mutation sendAddressCollectionEmailMutation($args: LinkEmailArgs!) {
  sendAddressCollectionEmail(args: $args)
}
    `;
export type SendAddressCollectionEmailMutationMutationFn = ApolloReactCommon.MutationFunction<SendAddressCollectionEmailMutation, SendAddressCollectionEmailMutationVariables>;

/**
 * __useSendAddressCollectionEmailMutation__
 *
 * To run a mutation, you first call `useSendAddressCollectionEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAddressCollectionEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAddressCollectionEmailMutation, { data, loading, error }] = useSendAddressCollectionEmailMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSendAddressCollectionEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendAddressCollectionEmailMutation, SendAddressCollectionEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendAddressCollectionEmailMutation, SendAddressCollectionEmailMutationVariables>(SendAddressCollectionEmailMutationDocument, baseOptions);
      }
export type SendAddressCollectionEmailMutationHookResult = ReturnType<typeof useSendAddressCollectionEmailMutation>;
export type SendAddressCollectionEmailMutationMutationResult = ApolloReactCommon.MutationResult<SendAddressCollectionEmailMutation>;
export type SendAddressCollectionEmailMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendAddressCollectionEmailMutation, SendAddressCollectionEmailMutationVariables>;
export const SendLivestreamEmailMutationDocument = gql`
    mutation sendLivestreamEmailMutation($args: CustomLinkEmailArgs!) {
  sendLivestreamEmail(args: $args)
}
    `;
export type SendLivestreamEmailMutationMutationFn = ApolloReactCommon.MutationFunction<SendLivestreamEmailMutation, SendLivestreamEmailMutationVariables>;

/**
 * __useSendLivestreamEmailMutation__
 *
 * To run a mutation, you first call `useSendLivestreamEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendLivestreamEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendLivestreamEmailMutation, { data, loading, error }] = useSendLivestreamEmailMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSendLivestreamEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendLivestreamEmailMutation, SendLivestreamEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendLivestreamEmailMutation, SendLivestreamEmailMutationVariables>(SendLivestreamEmailMutationDocument, baseOptions);
      }
export type SendLivestreamEmailMutationHookResult = ReturnType<typeof useSendLivestreamEmailMutation>;
export type SendLivestreamEmailMutationMutationResult = ApolloReactCommon.MutationResult<SendLivestreamEmailMutation>;
export type SendLivestreamEmailMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendLivestreamEmailMutation, SendLivestreamEmailMutationVariables>;
export const SendRsvpReminderSmsMutationDocument = gql`
    mutation sendRsvpReminderSmsMutation($args: SmsArgs!) {
  sendRsvpReminderSms(args: $args)
}
    `;
export type SendRsvpReminderSmsMutationMutationFn = ApolloReactCommon.MutationFunction<SendRsvpReminderSmsMutation, SendRsvpReminderSmsMutationVariables>;

/**
 * __useSendRsvpReminderSmsMutation__
 *
 * To run a mutation, you first call `useSendRsvpReminderSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRsvpReminderSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRsvpReminderSmsMutation, { data, loading, error }] = useSendRsvpReminderSmsMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSendRsvpReminderSmsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendRsvpReminderSmsMutation, SendRsvpReminderSmsMutationVariables>) {
        return ApolloReactHooks.useMutation<SendRsvpReminderSmsMutation, SendRsvpReminderSmsMutationVariables>(SendRsvpReminderSmsMutationDocument, baseOptions);
      }
export type SendRsvpReminderSmsMutationHookResult = ReturnType<typeof useSendRsvpReminderSmsMutation>;
export type SendRsvpReminderSmsMutationMutationResult = ApolloReactCommon.MutationResult<SendRsvpReminderSmsMutation>;
export type SendRsvpReminderSmsMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendRsvpReminderSmsMutation, SendRsvpReminderSmsMutationVariables>;
export const SendRsvpReminderEmailMutationDocument = gql`
    mutation sendRsvpReminderEmailMutation($args: LinkEmailArgs!) {
  sendRsvpReminderEmail(args: $args)
}
    `;
export type SendRsvpReminderEmailMutationMutationFn = ApolloReactCommon.MutationFunction<SendRsvpReminderEmailMutation, SendRsvpReminderEmailMutationVariables>;

/**
 * __useSendRsvpReminderEmailMutation__
 *
 * To run a mutation, you first call `useSendRsvpReminderEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRsvpReminderEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRsvpReminderEmailMutation, { data, loading, error }] = useSendRsvpReminderEmailMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSendRsvpReminderEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendRsvpReminderEmailMutation, SendRsvpReminderEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendRsvpReminderEmailMutation, SendRsvpReminderEmailMutationVariables>(SendRsvpReminderEmailMutationDocument, baseOptions);
      }
export type SendRsvpReminderEmailMutationHookResult = ReturnType<typeof useSendRsvpReminderEmailMutation>;
export type SendRsvpReminderEmailMutationMutationResult = ApolloReactCommon.MutationResult<SendRsvpReminderEmailMutation>;
export type SendRsvpReminderEmailMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendRsvpReminderEmailMutation, SendRsvpReminderEmailMutationVariables>;
export const UpdateRsvpDeadlinePropsMutationDocument = gql`
    mutation updateRsvpDeadlinePropsMutation($guestWeddingArgs: GDS_UpdateGuestWeddingRsvpPropsInput!) {
  updateGuestWeddingRsvpProps(input: $guestWeddingArgs) {
    id
    isPrivateRsvp
    rsvpDeadline
    rsvpMedium
  }
}
    `;
export type UpdateRsvpDeadlinePropsMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateRsvpDeadlinePropsMutation, UpdateRsvpDeadlinePropsMutationVariables>;

/**
 * __useUpdateRsvpDeadlinePropsMutation__
 *
 * To run a mutation, you first call `useUpdateRsvpDeadlinePropsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRsvpDeadlinePropsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRsvpDeadlinePropsMutation, { data, loading, error }] = useUpdateRsvpDeadlinePropsMutation({
 *   variables: {
 *      guestWeddingArgs: // value for 'guestWeddingArgs'
 *   },
 * });
 */
export function useUpdateRsvpDeadlinePropsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRsvpDeadlinePropsMutation, UpdateRsvpDeadlinePropsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateRsvpDeadlinePropsMutation, UpdateRsvpDeadlinePropsMutationVariables>(UpdateRsvpDeadlinePropsMutationDocument, baseOptions);
      }
export type UpdateRsvpDeadlinePropsMutationHookResult = ReturnType<typeof useUpdateRsvpDeadlinePropsMutation>;
export type UpdateRsvpDeadlinePropsMutationMutationResult = ApolloReactCommon.MutationResult<UpdateRsvpDeadlinePropsMutation>;
export type UpdateRsvpDeadlinePropsMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRsvpDeadlinePropsMutation, UpdateRsvpDeadlinePropsMutationVariables>;
export const UpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutationDocument = gql`
    mutation upsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutation($rsvpArgs: RsvpPropsArgs!, $guestWeddingArgs: GDS_UpdateGuestWeddingRsvpPropsInput!) {
  upsertRsvpDeadlineProps(args: $rsvpArgs)
  updateGuestWeddingRsvpProps(input: $guestWeddingArgs) {
    id
    isPrivateRsvp
    rsvpDeadline
    rsvpMedium
  }
}
    `;
export type UpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutationMutationFn = ApolloReactCommon.MutationFunction<UpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutation, UpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutationVariables>;

/**
 * __useUpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutation__
 *
 * To run a mutation, you first call `useUpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutation, { data, loading, error }] = useUpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutation({
 *   variables: {
 *      rsvpArgs: // value for 'rsvpArgs'
 *      guestWeddingArgs: // value for 'guestWeddingArgs'
 *   },
 * });
 */
export function useUpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutation, UpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutationVariables>) {
        return ApolloReactHooks.useMutation<UpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutation, UpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutationVariables>(UpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutationDocument, baseOptions);
      }
export type UpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutationHookResult = ReturnType<typeof useUpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutation>;
export type UpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutationMutationResult = ApolloReactCommon.MutationResult<UpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutation>;
export type UpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutation, UpsertRsvpDeadlinePropsAndUpdateRsvpDeadlineMutationVariables>;
export const RsvpDeadlinePropertiesQueryDocument = gql`
    query rsvpDeadlinePropertiesQuery($type: String!) {
  rsvpDeadlineProperties(type: $type) {
    subject
    body
    emailButtonText
  }
}
    `;

/**
 * __useRsvpDeadlinePropertiesQuery__
 *
 * To run a query within a React component, call `useRsvpDeadlinePropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRsvpDeadlinePropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRsvpDeadlinePropertiesQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useRsvpDeadlinePropertiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RsvpDeadlinePropertiesQuery, RsvpDeadlinePropertiesQueryVariables>) {
        return ApolloReactHooks.useQuery<RsvpDeadlinePropertiesQuery, RsvpDeadlinePropertiesQueryVariables>(RsvpDeadlinePropertiesQueryDocument, baseOptions);
      }
export function useRsvpDeadlinePropertiesQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RsvpDeadlinePropertiesQuery, RsvpDeadlinePropertiesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RsvpDeadlinePropertiesQuery, RsvpDeadlinePropertiesQueryVariables>(RsvpDeadlinePropertiesQueryDocument, baseOptions);
        }
export type RsvpDeadlinePropertiesQueryHookResult = ReturnType<typeof useRsvpDeadlinePropertiesQuery>;
export type RsvpDeadlinePropertiesQueryLazyQueryHookResult = ReturnType<typeof useRsvpDeadlinePropertiesQueryLazyQuery>;
export type RsvpDeadlinePropertiesQueryQueryResult = ApolloReactCommon.QueryResult<RsvpDeadlinePropertiesQuery, RsvpDeadlinePropertiesQueryVariables>;
export const NonRsvpedHouseholdsQueryDocument = gql`
    query nonRsvpedHouseholdsQuery($eventId: String!) {
  householdsWithoutRsvp(eventId: $eventId) {
    id
    description
    rsvpNote
    coupleNote
    people {
      ...People
    }
    address {
      ...GDSAddress
    }
    answers {
      ...GDSAnswer
    }
  }
}
    ${PeopleFragmentDoc}
${GdsAddressFragmentDoc}
${GdsAnswerFragmentDoc}`;

/**
 * __useNonRsvpedHouseholdsQuery__
 *
 * To run a query within a React component, call `useNonRsvpedHouseholdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonRsvpedHouseholdsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonRsvpedHouseholdsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useNonRsvpedHouseholdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NonRsvpedHouseholdsQuery, NonRsvpedHouseholdsQueryVariables>) {
        return ApolloReactHooks.useQuery<NonRsvpedHouseholdsQuery, NonRsvpedHouseholdsQueryVariables>(NonRsvpedHouseholdsQueryDocument, baseOptions);
      }
export function useNonRsvpedHouseholdsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NonRsvpedHouseholdsQuery, NonRsvpedHouseholdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<NonRsvpedHouseholdsQuery, NonRsvpedHouseholdsQueryVariables>(NonRsvpedHouseholdsQueryDocument, baseOptions);
        }
export type NonRsvpedHouseholdsQueryHookResult = ReturnType<typeof useNonRsvpedHouseholdsQuery>;
export type NonRsvpedHouseholdsQueryLazyQueryHookResult = ReturnType<typeof useNonRsvpedHouseholdsQueryLazyQuery>;
export type NonRsvpedHouseholdsQueryQueryResult = ApolloReactCommon.QueryResult<NonRsvpedHouseholdsQuery, NonRsvpedHouseholdsQueryVariables>;
export const UpdateMemberNamesMutationDocument = gql`
    mutation updateMemberNamesMutation($membersArgs: MemberArgs!) {
  updateMember(args: $membersArgs) {
    id
    firstName
    lastName
    fianceFirstName
    fianceLastName
  }
}
    `;
export type UpdateMemberNamesMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateMemberNamesMutation, UpdateMemberNamesMutationVariables>;

/**
 * __useUpdateMemberNamesMutation__
 *
 * To run a mutation, you first call `useUpdateMemberNamesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberNamesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberNamesMutation, { data, loading, error }] = useUpdateMemberNamesMutation({
 *   variables: {
 *      membersArgs: // value for 'membersArgs'
 *   },
 * });
 */
export function useUpdateMemberNamesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMemberNamesMutation, UpdateMemberNamesMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateMemberNamesMutation, UpdateMemberNamesMutationVariables>(UpdateMemberNamesMutationDocument, baseOptions);
      }
export type UpdateMemberNamesMutationHookResult = ReturnType<typeof useUpdateMemberNamesMutation>;
export type UpdateMemberNamesMutationMutationResult = ApolloReactCommon.MutationResult<UpdateMemberNamesMutation>;
export type UpdateMemberNamesMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMemberNamesMutation, UpdateMemberNamesMutationVariables>;
export const UpdateWeddingInfoMutationDocument = gql`
    mutation updateWeddingInfoMutation($membersArgs: MemberArgs!, $weddingDateArgs: UpsertWeddingDataArgs!, $weddingWebsiteAttrs: WWS_WeddingWebsiteAttributes!) {
  updateMember(args: $membersArgs) {
    id
    firstName
    lastName
    fianceFirstName
    fianceLastName
  }
  upsertWeddingData(args: $weddingDateArgs, allowUnconfirmed: false) {
    id
    weddingDate
  }
  updateWeddingWebsite(attributes: $weddingWebsiteAttrs) {
    id
    weddingLocation
  }
}
    `;
export type UpdateWeddingInfoMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateWeddingInfoMutation, UpdateWeddingInfoMutationVariables>;

/**
 * __useUpdateWeddingInfoMutation__
 *
 * To run a mutation, you first call `useUpdateWeddingInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWeddingInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWeddingInfoMutation, { data, loading, error }] = useUpdateWeddingInfoMutation({
 *   variables: {
 *      membersArgs: // value for 'membersArgs'
 *      weddingDateArgs: // value for 'weddingDateArgs'
 *      weddingWebsiteAttrs: // value for 'weddingWebsiteAttrs'
 *   },
 * });
 */
export function useUpdateWeddingInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWeddingInfoMutation, UpdateWeddingInfoMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateWeddingInfoMutation, UpdateWeddingInfoMutationVariables>(UpdateWeddingInfoMutationDocument, baseOptions);
      }
export type UpdateWeddingInfoMutationHookResult = ReturnType<typeof useUpdateWeddingInfoMutation>;
export type UpdateWeddingInfoMutationMutationResult = ApolloReactCommon.MutationResult<UpdateWeddingInfoMutation>;
export type UpdateWeddingInfoMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWeddingInfoMutation, UpdateWeddingInfoMutationVariables>;
export const ReorderPageItemsMutationDocument = gql`
    mutation reorderPageItemsMutation($attributes: WWS_ReorderPageItemAttrs!) {
  reorderPageItems(attributes: $attributes) {
    id
    rank
    type
    ...BasicItems
    ...StoryItems
    ...HeadlineItems
    ...AccommodationItems
    ...ActivityItems
    ...TransportationItems
    ...ParagraphItems
    ...PhotoGalleryItems
    ...PhotoTimelineItems
    ...PersonItems
    ...PhotoItems
    ...GifItems
    ...EmbedItems
    ...QuestionItems
    ...LivestreamItems
    ...DressCodeItems
    ...CoverPhotoItems
  }
}
    ${BasicItemsFragmentDoc}
${StoryItemsFragmentDoc}
${HeadlineItemsFragmentDoc}
${AccommodationItemsFragmentDoc}
${ActivityItemsFragmentDoc}
${TransportationItemsFragmentDoc}
${ParagraphItemsFragmentDoc}
${PhotoGalleryItemsFragmentDoc}
${PhotoTimelineItemsFragmentDoc}
${PersonItemsFragmentDoc}
${PhotoItemsFragmentDoc}
${GifItemsFragmentDoc}
${EmbedItemsFragmentDoc}
${QuestionItemsFragmentDoc}
${LivestreamItemsFragmentDoc}
${DressCodeItemsFragmentDoc}
${CoverPhotoItemsFragmentDoc}`;
export type ReorderPageItemsMutationMutationFn = ApolloReactCommon.MutationFunction<ReorderPageItemsMutation, ReorderPageItemsMutationVariables>;

/**
 * __useReorderPageItemsMutation__
 *
 * To run a mutation, you first call `useReorderPageItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderPageItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderPageItemsMutation, { data, loading, error }] = useReorderPageItemsMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useReorderPageItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReorderPageItemsMutation, ReorderPageItemsMutationVariables>) {
        return ApolloReactHooks.useMutation<ReorderPageItemsMutation, ReorderPageItemsMutationVariables>(ReorderPageItemsMutationDocument, baseOptions);
      }
export type ReorderPageItemsMutationHookResult = ReturnType<typeof useReorderPageItemsMutation>;
export type ReorderPageItemsMutationMutationResult = ApolloReactCommon.MutationResult<ReorderPageItemsMutation>;
export type ReorderPageItemsMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ReorderPageItemsMutation, ReorderPageItemsMutationVariables>;
export const CreateAccommodationItemMutationDocument = gql`
    mutation createAccommodationItemMutation($attributes: WWS_CreateAccommodationItemAttrs!) {
  item: createAccommodationItem(attributes: $attributes) {
    id
    email
    rank
    type
    description
    name
    phone
    website
    address
    guestCode
    rate
    checkInDate
    checkOutDate
    hotelPlannerId
    hotelId
    provider
    photo {
      mediaUrl
      mediaApiId
      width
      height
      cropX
      cropY
      rotation
      aspectRatio {
        name
        value
      }
    }
  }
}
    `;
export type CreateAccommodationItemMutationMutationFn = ApolloReactCommon.MutationFunction<CreateAccommodationItemMutation, CreateAccommodationItemMutationVariables>;

/**
 * __useCreateAccommodationItemMutation__
 *
 * To run a mutation, you first call `useCreateAccommodationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccommodationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccommodationItemMutation, { data, loading, error }] = useCreateAccommodationItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateAccommodationItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAccommodationItemMutation, CreateAccommodationItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAccommodationItemMutation, CreateAccommodationItemMutationVariables>(CreateAccommodationItemMutationDocument, baseOptions);
      }
export type CreateAccommodationItemMutationHookResult = ReturnType<typeof useCreateAccommodationItemMutation>;
export type CreateAccommodationItemMutationMutationResult = ApolloReactCommon.MutationResult<CreateAccommodationItemMutation>;
export type CreateAccommodationItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAccommodationItemMutation, CreateAccommodationItemMutationVariables>;
export const UpdateAccommodationItemMutationDocument = gql`
    mutation updateAccommodationItemMutation($attributes: WWS_UpdateAccommodationItemAttrs!) {
  updateAccommodationItem(attributes: $attributes) {
    id
    email
    rank
    type
    description
    name
    phone
    website
    address
    guestCode
    rate
    checkInDate
    checkOutDate
    hotelPlannerId
    hotelId
    photo {
      mediaUrl
      mediaApiId
      width
      height
      cropX
      cropY
      rotation
      aspectRatio {
        name
        value
      }
    }
  }
}
    `;
export type UpdateAccommodationItemMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateAccommodationItemMutation, UpdateAccommodationItemMutationVariables>;

/**
 * __useUpdateAccommodationItemMutation__
 *
 * To run a mutation, you first call `useUpdateAccommodationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccommodationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccommodationItemMutation, { data, loading, error }] = useUpdateAccommodationItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateAccommodationItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAccommodationItemMutation, UpdateAccommodationItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAccommodationItemMutation, UpdateAccommodationItemMutationVariables>(UpdateAccommodationItemMutationDocument, baseOptions);
      }
export type UpdateAccommodationItemMutationHookResult = ReturnType<typeof useUpdateAccommodationItemMutation>;
export type UpdateAccommodationItemMutationMutationResult = ApolloReactCommon.MutationResult<UpdateAccommodationItemMutation>;
export type UpdateAccommodationItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAccommodationItemMutation, UpdateAccommodationItemMutationVariables>;
export const AccommodationQueryDocument = gql`
    query AccommodationQuery($id: Int!, $pageId: Int!) {
  page(id: $pageId) {
    accommodationItem(id: $id) {
      id
      email
      rank
      type
      description
      name
      phone
      website
      address
      guestCode
      rate
      checkInDate
      checkOutDate
      hotelPlannerId
      hotelId
      provider
      photo {
        mediaUrl
        mediaApiId
        width
        height
        cropX
        cropY
        rotation
        aspectRatio {
          name
          value
        }
      }
    }
  }
}
    `;

/**
 * __useAccommodationQuery__
 *
 * To run a query within a React component, call `useAccommodationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useAccommodationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationQuery, AccommodationQueryVariables>) {
        return ApolloReactHooks.useQuery<AccommodationQuery, AccommodationQueryVariables>(AccommodationQueryDocument, baseOptions);
      }
export function useAccommodationQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationQuery, AccommodationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AccommodationQuery, AccommodationQueryVariables>(AccommodationQueryDocument, baseOptions);
        }
export type AccommodationQueryHookResult = ReturnType<typeof useAccommodationQuery>;
export type AccommodationQueryLazyQueryHookResult = ReturnType<typeof useAccommodationQueryLazyQuery>;
export type AccommodationQueryQueryResult = ApolloReactCommon.QueryResult<AccommodationQuery, AccommodationQueryVariables>;
export const DeleteAccommodationItemMutationDocument = gql`
    mutation deleteAccommodationItemMutation($attributes: WWS_DeletePageItemAttributes!) {
  deletePageItem(attributes: $attributes)
}
    `;
export type DeleteAccommodationItemMutationMutationFn = ApolloReactCommon.MutationFunction<DeleteAccommodationItemMutation, DeleteAccommodationItemMutationVariables>;

/**
 * __useDeleteAccommodationItemMutation__
 *
 * To run a mutation, you first call `useDeleteAccommodationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccommodationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccommodationItemMutation, { data, loading, error }] = useDeleteAccommodationItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDeleteAccommodationItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAccommodationItemMutation, DeleteAccommodationItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteAccommodationItemMutation, DeleteAccommodationItemMutationVariables>(DeleteAccommodationItemMutationDocument, baseOptions);
      }
export type DeleteAccommodationItemMutationHookResult = ReturnType<typeof useDeleteAccommodationItemMutation>;
export type DeleteAccommodationItemMutationMutationResult = ApolloReactCommon.MutationResult<DeleteAccommodationItemMutation>;
export type DeleteAccommodationItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAccommodationItemMutation, DeleteAccommodationItemMutationVariables>;
export const CreateActivityItemMutationDocument = gql`
    mutation createActivityItemMutation($attributes: WWS_CreateBusinessItemAttrs!) {
  item: createActivityItem(attributes: $attributes) {
    ...ActivityItems
  }
}
    ${ActivityItemsFragmentDoc}`;
export type CreateActivityItemMutationMutationFn = ApolloReactCommon.MutationFunction<CreateActivityItemMutation, CreateActivityItemMutationVariables>;

/**
 * __useCreateActivityItemMutation__
 *
 * To run a mutation, you first call `useCreateActivityItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActivityItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActivityItemMutation, { data, loading, error }] = useCreateActivityItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateActivityItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateActivityItemMutation, CreateActivityItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateActivityItemMutation, CreateActivityItemMutationVariables>(CreateActivityItemMutationDocument, baseOptions);
      }
export type CreateActivityItemMutationHookResult = ReturnType<typeof useCreateActivityItemMutation>;
export type CreateActivityItemMutationMutationResult = ApolloReactCommon.MutationResult<CreateActivityItemMutation>;
export type CreateActivityItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateActivityItemMutation, CreateActivityItemMutationVariables>;
export const UpdateActivityItemMutationDocument = gql`
    mutation updateActivityItemMutation($attributes: WWS_UpdateBusinessItemAttrs!) {
  updateActivityItem(attributes: $attributes) {
    ...ActivityItems
  }
}
    ${ActivityItemsFragmentDoc}`;
export type UpdateActivityItemMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateActivityItemMutation, UpdateActivityItemMutationVariables>;

/**
 * __useUpdateActivityItemMutation__
 *
 * To run a mutation, you first call `useUpdateActivityItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityItemMutation, { data, loading, error }] = useUpdateActivityItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateActivityItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateActivityItemMutation, UpdateActivityItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateActivityItemMutation, UpdateActivityItemMutationVariables>(UpdateActivityItemMutationDocument, baseOptions);
      }
export type UpdateActivityItemMutationHookResult = ReturnType<typeof useUpdateActivityItemMutation>;
export type UpdateActivityItemMutationMutationResult = ApolloReactCommon.MutationResult<UpdateActivityItemMutation>;
export type UpdateActivityItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateActivityItemMutation, UpdateActivityItemMutationVariables>;
export const ActivityQueryDocument = gql`
    query ActivityQuery($id: Int!, $pageId: Int!) {
  page(id: $pageId) {
    activityItem(id: $id) {
      ...ActivityItems
    }
  }
}
    ${ActivityItemsFragmentDoc}`;

/**
 * __useActivityQuery__
 *
 * To run a query within a React component, call `useActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useActivityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActivityQuery, ActivityQueryVariables>) {
        return ApolloReactHooks.useQuery<ActivityQuery, ActivityQueryVariables>(ActivityQueryDocument, baseOptions);
      }
export function useActivityQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActivityQuery, ActivityQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ActivityQuery, ActivityQueryVariables>(ActivityQueryDocument, baseOptions);
        }
export type ActivityQueryHookResult = ReturnType<typeof useActivityQuery>;
export type ActivityQueryLazyQueryHookResult = ReturnType<typeof useActivityQueryLazyQuery>;
export type ActivityQueryQueryResult = ApolloReactCommon.QueryResult<ActivityQuery, ActivityQueryVariables>;
export const DeleteActivityItemMutationDocument = gql`
    mutation deleteActivityItemMutation($attributes: WWS_DeletePageItemAttributes!) {
  deletePageItem(attributes: $attributes)
}
    `;
export type DeleteActivityItemMutationMutationFn = ApolloReactCommon.MutationFunction<DeleteActivityItemMutation, DeleteActivityItemMutationVariables>;

/**
 * __useDeleteActivityItemMutation__
 *
 * To run a mutation, you first call `useDeleteActivityItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActivityItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActivityItemMutation, { data, loading, error }] = useDeleteActivityItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDeleteActivityItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteActivityItemMutation, DeleteActivityItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteActivityItemMutation, DeleteActivityItemMutationVariables>(DeleteActivityItemMutationDocument, baseOptions);
      }
export type DeleteActivityItemMutationHookResult = ReturnType<typeof useDeleteActivityItemMutation>;
export type DeleteActivityItemMutationMutationResult = ApolloReactCommon.MutationResult<DeleteActivityItemMutation>;
export type DeleteActivityItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteActivityItemMutation, DeleteActivityItemMutationVariables>;
export const UpdateBasicItemMutationDocument = gql`
    mutation updateBasicItemMutation($attributes: WWS_UpdateBasicItemAttrs!) {
  updateBasicItem(attributes: $attributes) {
    ...BasicItems
  }
}
    ${BasicItemsFragmentDoc}`;
export type UpdateBasicItemMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateBasicItemMutation, UpdateBasicItemMutationVariables>;

/**
 * __useUpdateBasicItemMutation__
 *
 * To run a mutation, you first call `useUpdateBasicItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBasicItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBasicItemMutation, { data, loading, error }] = useUpdateBasicItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateBasicItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBasicItemMutation, UpdateBasicItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBasicItemMutation, UpdateBasicItemMutationVariables>(UpdateBasicItemMutationDocument, baseOptions);
      }
export type UpdateBasicItemMutationHookResult = ReturnType<typeof useUpdateBasicItemMutation>;
export type UpdateBasicItemMutationMutationResult = ApolloReactCommon.MutationResult<UpdateBasicItemMutation>;
export type UpdateBasicItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBasicItemMutation, UpdateBasicItemMutationVariables>;
export const BasicQueryDocument = gql`
    query basicQuery($id: Int!, $pageId: Int!) {
  page(id: $pageId) {
    basicItem(id: $id) {
      ...BasicItems
    }
  }
}
    ${BasicItemsFragmentDoc}`;

/**
 * __useBasicQuery__
 *
 * To run a query within a React component, call `useBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useBasicQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BasicQuery, BasicQueryVariables>) {
        return ApolloReactHooks.useQuery<BasicQuery, BasicQueryVariables>(BasicQueryDocument, baseOptions);
      }
export function useBasicQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BasicQuery, BasicQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BasicQuery, BasicQueryVariables>(BasicQueryDocument, baseOptions);
        }
export type BasicQueryHookResult = ReturnType<typeof useBasicQuery>;
export type BasicQueryLazyQueryHookResult = ReturnType<typeof useBasicQueryLazyQuery>;
export type BasicQueryQueryResult = ApolloReactCommon.QueryResult<BasicQuery, BasicQueryVariables>;
export const DeleteBasicItemMutationDocument = gql`
    mutation deleteBasicItemMutation($id: Int!, $pageId: Int!) {
  deletePageItem(attributes: {id: $id, pageId: $pageId})
}
    `;
export type DeleteBasicItemMutationMutationFn = ApolloReactCommon.MutationFunction<DeleteBasicItemMutation, DeleteBasicItemMutationVariables>;

/**
 * __useDeleteBasicItemMutation__
 *
 * To run a mutation, you first call `useDeleteBasicItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBasicItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBasicItemMutation, { data, loading, error }] = useDeleteBasicItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useDeleteBasicItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBasicItemMutation, DeleteBasicItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteBasicItemMutation, DeleteBasicItemMutationVariables>(DeleteBasicItemMutationDocument, baseOptions);
      }
export type DeleteBasicItemMutationHookResult = ReturnType<typeof useDeleteBasicItemMutation>;
export type DeleteBasicItemMutationMutationResult = ApolloReactCommon.MutationResult<DeleteBasicItemMutation>;
export type DeleteBasicItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteBasicItemMutation, DeleteBasicItemMutationVariables>;
export const CreateDressCodeItemMutationDocument = gql`
    mutation createDressCodeItemMutation($attributes: WWS_CreateDressCodeItemAttrs!) {
  createDressCodeItem(attributes: $attributes) {
    ...DressCodeItems
  }
}
    ${DressCodeItemsFragmentDoc}`;
export type CreateDressCodeItemMutationMutationFn = ApolloReactCommon.MutationFunction<CreateDressCodeItemMutation, CreateDressCodeItemMutationVariables>;

/**
 * __useCreateDressCodeItemMutation__
 *
 * To run a mutation, you first call `useCreateDressCodeItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDressCodeItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDressCodeItemMutation, { data, loading, error }] = useCreateDressCodeItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateDressCodeItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDressCodeItemMutation, CreateDressCodeItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateDressCodeItemMutation, CreateDressCodeItemMutationVariables>(CreateDressCodeItemMutationDocument, baseOptions);
      }
export type CreateDressCodeItemMutationHookResult = ReturnType<typeof useCreateDressCodeItemMutation>;
export type CreateDressCodeItemMutationMutationResult = ApolloReactCommon.MutationResult<CreateDressCodeItemMutation>;
export type CreateDressCodeItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDressCodeItemMutation, CreateDressCodeItemMutationVariables>;
export const UpdateDressCodeItemMutationDocument = gql`
    mutation updateDressCodeItemMutation($attributes: WWS_UpdateDressCodeItemAttrs!) {
  updateDressCodeItem(attributes: $attributes) {
    ...DressCodeItems
  }
}
    ${DressCodeItemsFragmentDoc}`;
export type UpdateDressCodeItemMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateDressCodeItemMutation, UpdateDressCodeItemMutationVariables>;

/**
 * __useUpdateDressCodeItemMutation__
 *
 * To run a mutation, you first call `useUpdateDressCodeItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDressCodeItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDressCodeItemMutation, { data, loading, error }] = useUpdateDressCodeItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateDressCodeItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDressCodeItemMutation, UpdateDressCodeItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateDressCodeItemMutation, UpdateDressCodeItemMutationVariables>(UpdateDressCodeItemMutationDocument, baseOptions);
      }
export type UpdateDressCodeItemMutationHookResult = ReturnType<typeof useUpdateDressCodeItemMutation>;
export type UpdateDressCodeItemMutationMutationResult = ApolloReactCommon.MutationResult<UpdateDressCodeItemMutation>;
export type UpdateDressCodeItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDressCodeItemMutation, UpdateDressCodeItemMutationVariables>;
export const DeleteDressCodeItemMutationDocument = gql`
    mutation deleteDressCodeItemMutation($attributes: WWS_DeletePageItemAttributes!) {
  deletePageItem(attributes: $attributes)
}
    `;
export type DeleteDressCodeItemMutationMutationFn = ApolloReactCommon.MutationFunction<DeleteDressCodeItemMutation, DeleteDressCodeItemMutationVariables>;

/**
 * __useDeleteDressCodeItemMutation__
 *
 * To run a mutation, you first call `useDeleteDressCodeItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDressCodeItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDressCodeItemMutation, { data, loading, error }] = useDeleteDressCodeItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDeleteDressCodeItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDressCodeItemMutation, DeleteDressCodeItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteDressCodeItemMutation, DeleteDressCodeItemMutationVariables>(DeleteDressCodeItemMutationDocument, baseOptions);
      }
export type DeleteDressCodeItemMutationHookResult = ReturnType<typeof useDeleteDressCodeItemMutation>;
export type DeleteDressCodeItemMutationMutationResult = ApolloReactCommon.MutationResult<DeleteDressCodeItemMutation>;
export type DeleteDressCodeItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteDressCodeItemMutation, DeleteDressCodeItemMutationVariables>;
export const DressCodeQueryDocument = gql`
    query dressCodeQuery($pageId: Int!, $id: Int) {
  page(id: $pageId) {
    id
    items {
      ... on WWS_DressCodeItem {
        ...DressCodeItems
      }
    }
  }
}
    ${DressCodeItemsFragmentDoc}`;

/**
 * __useDressCodeQuery__
 *
 * To run a query within a React component, call `useDressCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDressCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDressCodeQuery({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDressCodeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DressCodeQuery, DressCodeQueryVariables>) {
        return ApolloReactHooks.useQuery<DressCodeQuery, DressCodeQueryVariables>(DressCodeQueryDocument, baseOptions);
      }
export function useDressCodeQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DressCodeQuery, DressCodeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DressCodeQuery, DressCodeQueryVariables>(DressCodeQueryDocument, baseOptions);
        }
export type DressCodeQueryHookResult = ReturnType<typeof useDressCodeQuery>;
export type DressCodeQueryLazyQueryHookResult = ReturnType<typeof useDressCodeQueryLazyQuery>;
export type DressCodeQueryQueryResult = ApolloReactCommon.QueryResult<DressCodeQuery, DressCodeQueryVariables>;
export const CreateEmbedItemMutationDocument = gql`
    mutation createEmbedItemMutation($attributes: WWS_CreateEmbedItemAttrs!) {
  createEmbedItem(attributes: $attributes) {
    ...EmbedItems
  }
}
    ${EmbedItemsFragmentDoc}`;
export type CreateEmbedItemMutationMutationFn = ApolloReactCommon.MutationFunction<CreateEmbedItemMutation, CreateEmbedItemMutationVariables>;

/**
 * __useCreateEmbedItemMutation__
 *
 * To run a mutation, you first call `useCreateEmbedItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmbedItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmbedItemMutation, { data, loading, error }] = useCreateEmbedItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateEmbedItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEmbedItemMutation, CreateEmbedItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateEmbedItemMutation, CreateEmbedItemMutationVariables>(CreateEmbedItemMutationDocument, baseOptions);
      }
export type CreateEmbedItemMutationHookResult = ReturnType<typeof useCreateEmbedItemMutation>;
export type CreateEmbedItemMutationMutationResult = ApolloReactCommon.MutationResult<CreateEmbedItemMutation>;
export type CreateEmbedItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateEmbedItemMutation, CreateEmbedItemMutationVariables>;
export const UpdateEmbedItemMutationDocument = gql`
    mutation updateEmbedItemMutation($attributes: WWS_UpdateEmbedItemAttrs!) {
  updateEmbedItem(attributes: $attributes) {
    ...EmbedItems
  }
}
    ${EmbedItemsFragmentDoc}`;
export type UpdateEmbedItemMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateEmbedItemMutation, UpdateEmbedItemMutationVariables>;

/**
 * __useUpdateEmbedItemMutation__
 *
 * To run a mutation, you first call `useUpdateEmbedItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmbedItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmbedItemMutation, { data, loading, error }] = useUpdateEmbedItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateEmbedItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEmbedItemMutation, UpdateEmbedItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEmbedItemMutation, UpdateEmbedItemMutationVariables>(UpdateEmbedItemMutationDocument, baseOptions);
      }
export type UpdateEmbedItemMutationHookResult = ReturnType<typeof useUpdateEmbedItemMutation>;
export type UpdateEmbedItemMutationMutationResult = ApolloReactCommon.MutationResult<UpdateEmbedItemMutation>;
export type UpdateEmbedItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEmbedItemMutation, UpdateEmbedItemMutationVariables>;
export const EmbedQueryDocument = gql`
    query embedQuery($id: Int!, $pageId: Int!) {
  page(id: $pageId) {
    id
    embedItem(id: $id) {
      ...EmbedItems
    }
  }
}
    ${EmbedItemsFragmentDoc}`;

/**
 * __useEmbedQuery__
 *
 * To run a query within a React component, call `useEmbedQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmbedQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmbedQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useEmbedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EmbedQuery, EmbedQueryVariables>) {
        return ApolloReactHooks.useQuery<EmbedQuery, EmbedQueryVariables>(EmbedQueryDocument, baseOptions);
      }
export function useEmbedQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EmbedQuery, EmbedQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EmbedQuery, EmbedQueryVariables>(EmbedQueryDocument, baseOptions);
        }
export type EmbedQueryHookResult = ReturnType<typeof useEmbedQuery>;
export type EmbedQueryLazyQueryHookResult = ReturnType<typeof useEmbedQueryLazyQuery>;
export type EmbedQueryQueryResult = ApolloReactCommon.QueryResult<EmbedQuery, EmbedQueryVariables>;
export const DeleteEmbedItemMutationDocument = gql`
    mutation deleteEmbedItemMutation($id: Int!, $pageId: Int!) {
  deletePageItem(attributes: {id: $id, pageId: $pageId})
}
    `;
export type DeleteEmbedItemMutationMutationFn = ApolloReactCommon.MutationFunction<DeleteEmbedItemMutation, DeleteEmbedItemMutationVariables>;

/**
 * __useDeleteEmbedItemMutation__
 *
 * To run a mutation, you first call `useDeleteEmbedItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmbedItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmbedItemMutation, { data, loading, error }] = useDeleteEmbedItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useDeleteEmbedItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteEmbedItemMutation, DeleteEmbedItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteEmbedItemMutation, DeleteEmbedItemMutationVariables>(DeleteEmbedItemMutationDocument, baseOptions);
      }
export type DeleteEmbedItemMutationHookResult = ReturnType<typeof useDeleteEmbedItemMutation>;
export type DeleteEmbedItemMutationMutationResult = ApolloReactCommon.MutationResult<DeleteEmbedItemMutation>;
export type DeleteEmbedItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteEmbedItemMutation, DeleteEmbedItemMutationVariables>;
export const CreateGifItemMutationDocument = gql`
    mutation createGifItemMutation($attributes: WWS_CreateGifItemAttrs!) {
  createGifItem(attributes: $attributes) {
    ...GifItems
  }
}
    ${GifItemsFragmentDoc}`;
export type CreateGifItemMutationMutationFn = ApolloReactCommon.MutationFunction<CreateGifItemMutation, CreateGifItemMutationVariables>;

/**
 * __useCreateGifItemMutation__
 *
 * To run a mutation, you first call `useCreateGifItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGifItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGifItemMutation, { data, loading, error }] = useCreateGifItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateGifItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateGifItemMutation, CreateGifItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateGifItemMutation, CreateGifItemMutationVariables>(CreateGifItemMutationDocument, baseOptions);
      }
export type CreateGifItemMutationHookResult = ReturnType<typeof useCreateGifItemMutation>;
export type CreateGifItemMutationMutationResult = ApolloReactCommon.MutationResult<CreateGifItemMutation>;
export type CreateGifItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateGifItemMutation, CreateGifItemMutationVariables>;
export const DeleteGifItemDocument = gql`
    mutation deleteGifItem($attributes: WWS_DeletePageItemAttributes!) {
  deletePageItem(attributes: $attributes)
}
    `;
export type DeleteGifItemMutationFn = ApolloReactCommon.MutationFunction<DeleteGifItemMutation, DeleteGifItemMutationVariables>;

/**
 * __useDeleteGifItemMutation__
 *
 * To run a mutation, you first call `useDeleteGifItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGifItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGifItemMutation, { data, loading, error }] = useDeleteGifItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDeleteGifItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteGifItemMutation, DeleteGifItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteGifItemMutation, DeleteGifItemMutationVariables>(DeleteGifItemDocument, baseOptions);
      }
export type DeleteGifItemMutationHookResult = ReturnType<typeof useDeleteGifItemMutation>;
export type DeleteGifItemMutationResult = ApolloReactCommon.MutationResult<DeleteGifItemMutation>;
export type DeleteGifItemMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteGifItemMutation, DeleteGifItemMutationVariables>;
export const CreateHeadlineItemMutationDocument = gql`
    mutation createHeadlineItemMutation($attributes: WWS_CreateHeadlineItemAttrs!) {
  createHeadlineItem(attributes: $attributes) {
    ...HeadlineItems
  }
}
    ${HeadlineItemsFragmentDoc}`;
export type CreateHeadlineItemMutationMutationFn = ApolloReactCommon.MutationFunction<CreateHeadlineItemMutation, CreateHeadlineItemMutationVariables>;

/**
 * __useCreateHeadlineItemMutation__
 *
 * To run a mutation, you first call `useCreateHeadlineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHeadlineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHeadlineItemMutation, { data, loading, error }] = useCreateHeadlineItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateHeadlineItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateHeadlineItemMutation, CreateHeadlineItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateHeadlineItemMutation, CreateHeadlineItemMutationVariables>(CreateHeadlineItemMutationDocument, baseOptions);
      }
export type CreateHeadlineItemMutationHookResult = ReturnType<typeof useCreateHeadlineItemMutation>;
export type CreateHeadlineItemMutationMutationResult = ApolloReactCommon.MutationResult<CreateHeadlineItemMutation>;
export type CreateHeadlineItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateHeadlineItemMutation, CreateHeadlineItemMutationVariables>;
export const UpdateHeadlineItemMutationDocument = gql`
    mutation updateHeadlineItemMutation($attributes: WWS_UpdateHeadlineItemAttrs!) {
  updateHeadlineItem(attributes: $attributes) {
    ...HeadlineItems
  }
}
    ${HeadlineItemsFragmentDoc}`;
export type UpdateHeadlineItemMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateHeadlineItemMutation, UpdateHeadlineItemMutationVariables>;

/**
 * __useUpdateHeadlineItemMutation__
 *
 * To run a mutation, you first call `useUpdateHeadlineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHeadlineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHeadlineItemMutation, { data, loading, error }] = useUpdateHeadlineItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateHeadlineItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateHeadlineItemMutation, UpdateHeadlineItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateHeadlineItemMutation, UpdateHeadlineItemMutationVariables>(UpdateHeadlineItemMutationDocument, baseOptions);
      }
export type UpdateHeadlineItemMutationHookResult = ReturnType<typeof useUpdateHeadlineItemMutation>;
export type UpdateHeadlineItemMutationMutationResult = ApolloReactCommon.MutationResult<UpdateHeadlineItemMutation>;
export type UpdateHeadlineItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateHeadlineItemMutation, UpdateHeadlineItemMutationVariables>;
export const DeleteHeadlineItemMutationDocument = gql`
    mutation deleteHeadlineItemMutation($attributes: WWS_DeletePageItemAttributes!) {
  deletePageItem(attributes: $attributes)
}
    `;
export type DeleteHeadlineItemMutationMutationFn = ApolloReactCommon.MutationFunction<DeleteHeadlineItemMutation, DeleteHeadlineItemMutationVariables>;

/**
 * __useDeleteHeadlineItemMutation__
 *
 * To run a mutation, you first call `useDeleteHeadlineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHeadlineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHeadlineItemMutation, { data, loading, error }] = useDeleteHeadlineItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDeleteHeadlineItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteHeadlineItemMutation, DeleteHeadlineItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteHeadlineItemMutation, DeleteHeadlineItemMutationVariables>(DeleteHeadlineItemMutationDocument, baseOptions);
      }
export type DeleteHeadlineItemMutationHookResult = ReturnType<typeof useDeleteHeadlineItemMutation>;
export type DeleteHeadlineItemMutationMutationResult = ApolloReactCommon.MutationResult<DeleteHeadlineItemMutation>;
export type DeleteHeadlineItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteHeadlineItemMutation, DeleteHeadlineItemMutationVariables>;
export const HeadlineQueryDocument = gql`
    query headlineQuery($id: Int!, $pageId: Int!) {
  page(id: $pageId) {
    id
    headlineItem(id: $id) {
      ...HeadlineItems
    }
  }
}
    ${HeadlineItemsFragmentDoc}`;

/**
 * __useHeadlineQuery__
 *
 * To run a query within a React component, call `useHeadlineQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeadlineQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeadlineQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useHeadlineQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HeadlineQuery, HeadlineQueryVariables>) {
        return ApolloReactHooks.useQuery<HeadlineQuery, HeadlineQueryVariables>(HeadlineQueryDocument, baseOptions);
      }
export function useHeadlineQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HeadlineQuery, HeadlineQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<HeadlineQuery, HeadlineQueryVariables>(HeadlineQueryDocument, baseOptions);
        }
export type HeadlineQueryHookResult = ReturnType<typeof useHeadlineQuery>;
export type HeadlineQueryLazyQueryHookResult = ReturnType<typeof useHeadlineQueryLazyQuery>;
export type HeadlineQueryQueryResult = ApolloReactCommon.QueryResult<HeadlineQuery, HeadlineQueryVariables>;
export const CreateLivestreamItemMutationDocument = gql`
    mutation createLivestreamItemMutation($attributes: WWS_CreateLivestreamItemAttrs!) {
  createLivestreamItem(attributes: $attributes) {
    ...LivestreamItems
  }
}
    ${LivestreamItemsFragmentDoc}`;
export type CreateLivestreamItemMutationMutationFn = ApolloReactCommon.MutationFunction<CreateLivestreamItemMutation, CreateLivestreamItemMutationVariables>;

/**
 * __useCreateLivestreamItemMutation__
 *
 * To run a mutation, you first call `useCreateLivestreamItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLivestreamItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLivestreamItemMutation, { data, loading, error }] = useCreateLivestreamItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateLivestreamItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLivestreamItemMutation, CreateLivestreamItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateLivestreamItemMutation, CreateLivestreamItemMutationVariables>(CreateLivestreamItemMutationDocument, baseOptions);
      }
export type CreateLivestreamItemMutationHookResult = ReturnType<typeof useCreateLivestreamItemMutation>;
export type CreateLivestreamItemMutationMutationResult = ApolloReactCommon.MutationResult<CreateLivestreamItemMutation>;
export type CreateLivestreamItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateLivestreamItemMutation, CreateLivestreamItemMutationVariables>;
export const UpdateLivestreamItemMutationDocument = gql`
    mutation updateLivestreamItemMutation($attributes: WWS_UpdateLivestreamItemAttrs!) {
  updateLivestreamItem(attributes: $attributes) {
    ...LivestreamItems
  }
}
    ${LivestreamItemsFragmentDoc}`;
export type UpdateLivestreamItemMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateLivestreamItemMutation, UpdateLivestreamItemMutationVariables>;

/**
 * __useUpdateLivestreamItemMutation__
 *
 * To run a mutation, you first call `useUpdateLivestreamItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLivestreamItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLivestreamItemMutation, { data, loading, error }] = useUpdateLivestreamItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateLivestreamItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateLivestreamItemMutation, UpdateLivestreamItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateLivestreamItemMutation, UpdateLivestreamItemMutationVariables>(UpdateLivestreamItemMutationDocument, baseOptions);
      }
export type UpdateLivestreamItemMutationHookResult = ReturnType<typeof useUpdateLivestreamItemMutation>;
export type UpdateLivestreamItemMutationMutationResult = ApolloReactCommon.MutationResult<UpdateLivestreamItemMutation>;
export type UpdateLivestreamItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateLivestreamItemMutation, UpdateLivestreamItemMutationVariables>;
export const LivestreamQueryDocument = gql`
    query livestreamQuery($id: Int!, $pageId: Int!) {
  page(id: $pageId) {
    id
    livestreamItem(id: $id) {
      ...LivestreamItems
    }
  }
}
    ${LivestreamItemsFragmentDoc}`;

/**
 * __useLivestreamQuery__
 *
 * To run a query within a React component, call `useLivestreamQuery` and pass it any options that fit your needs.
 * When your component renders, `useLivestreamQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLivestreamQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useLivestreamQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LivestreamQuery, LivestreamQueryVariables>) {
        return ApolloReactHooks.useQuery<LivestreamQuery, LivestreamQueryVariables>(LivestreamQueryDocument, baseOptions);
      }
export function useLivestreamQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LivestreamQuery, LivestreamQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LivestreamQuery, LivestreamQueryVariables>(LivestreamQueryDocument, baseOptions);
        }
export type LivestreamQueryHookResult = ReturnType<typeof useLivestreamQuery>;
export type LivestreamQueryLazyQueryHookResult = ReturnType<typeof useLivestreamQueryLazyQuery>;
export type LivestreamQueryQueryResult = ApolloReactCommon.QueryResult<LivestreamQuery, LivestreamQueryVariables>;
export const DeleteLivestreamItemMutationDocument = gql`
    mutation deleteLivestreamItemMutation($id: Int!, $pageId: Int!) {
  deletePageItem(attributes: {id: $id, pageId: $pageId})
}
    `;
export type DeleteLivestreamItemMutationMutationFn = ApolloReactCommon.MutationFunction<DeleteLivestreamItemMutation, DeleteLivestreamItemMutationVariables>;

/**
 * __useDeleteLivestreamItemMutation__
 *
 * To run a mutation, you first call `useDeleteLivestreamItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLivestreamItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLivestreamItemMutation, { data, loading, error }] = useDeleteLivestreamItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useDeleteLivestreamItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLivestreamItemMutation, DeleteLivestreamItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteLivestreamItemMutation, DeleteLivestreamItemMutationVariables>(DeleteLivestreamItemMutationDocument, baseOptions);
      }
export type DeleteLivestreamItemMutationHookResult = ReturnType<typeof useDeleteLivestreamItemMutation>;
export type DeleteLivestreamItemMutationMutationResult = ApolloReactCommon.MutationResult<DeleteLivestreamItemMutation>;
export type DeleteLivestreamItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteLivestreamItemMutation, DeleteLivestreamItemMutationVariables>;
export const CreateParagraphItemMutationDocument = gql`
    mutation createParagraphItemMutation($attributes: WWS_CreateParagraphItemAttrs!) {
  createParagraphItem(attributes: $attributes) {
    ...ParagraphItems
  }
}
    ${ParagraphItemsFragmentDoc}`;
export type CreateParagraphItemMutationMutationFn = ApolloReactCommon.MutationFunction<CreateParagraphItemMutation, CreateParagraphItemMutationVariables>;

/**
 * __useCreateParagraphItemMutation__
 *
 * To run a mutation, you first call `useCreateParagraphItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateParagraphItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createParagraphItemMutation, { data, loading, error }] = useCreateParagraphItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateParagraphItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateParagraphItemMutation, CreateParagraphItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateParagraphItemMutation, CreateParagraphItemMutationVariables>(CreateParagraphItemMutationDocument, baseOptions);
      }
export type CreateParagraphItemMutationHookResult = ReturnType<typeof useCreateParagraphItemMutation>;
export type CreateParagraphItemMutationMutationResult = ApolloReactCommon.MutationResult<CreateParagraphItemMutation>;
export type CreateParagraphItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateParagraphItemMutation, CreateParagraphItemMutationVariables>;
export const UpdateParagraphItemMutationDocument = gql`
    mutation updateParagraphItemMutation($attributes: WWS_UpdateParagraphItemAttrs!) {
  updateParagraphItem(attributes: $attributes) {
    ...ParagraphItems
  }
}
    ${ParagraphItemsFragmentDoc}`;
export type UpdateParagraphItemMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateParagraphItemMutation, UpdateParagraphItemMutationVariables>;

/**
 * __useUpdateParagraphItemMutation__
 *
 * To run a mutation, you first call `useUpdateParagraphItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParagraphItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParagraphItemMutation, { data, loading, error }] = useUpdateParagraphItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateParagraphItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateParagraphItemMutation, UpdateParagraphItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateParagraphItemMutation, UpdateParagraphItemMutationVariables>(UpdateParagraphItemMutationDocument, baseOptions);
      }
export type UpdateParagraphItemMutationHookResult = ReturnType<typeof useUpdateParagraphItemMutation>;
export type UpdateParagraphItemMutationMutationResult = ApolloReactCommon.MutationResult<UpdateParagraphItemMutation>;
export type UpdateParagraphItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateParagraphItemMutation, UpdateParagraphItemMutationVariables>;
export const ParagraphQueryDocument = gql`
    query paragraphQuery($id: Int!, $pageId: Int!) {
  page(id: $pageId) {
    paragraphItem(id: $id) {
      ...ParagraphItems
    }
  }
}
    ${ParagraphItemsFragmentDoc}`;

/**
 * __useParagraphQuery__
 *
 * To run a query within a React component, call `useParagraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useParagraphQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParagraphQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useParagraphQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ParagraphQuery, ParagraphQueryVariables>) {
        return ApolloReactHooks.useQuery<ParagraphQuery, ParagraphQueryVariables>(ParagraphQueryDocument, baseOptions);
      }
export function useParagraphQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ParagraphQuery, ParagraphQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ParagraphQuery, ParagraphQueryVariables>(ParagraphQueryDocument, baseOptions);
        }
export type ParagraphQueryHookResult = ReturnType<typeof useParagraphQuery>;
export type ParagraphQueryLazyQueryHookResult = ReturnType<typeof useParagraphQueryLazyQuery>;
export type ParagraphQueryQueryResult = ApolloReactCommon.QueryResult<ParagraphQuery, ParagraphQueryVariables>;
export const DeleteParagraphItemMutationDocument = gql`
    mutation deleteParagraphItemMutation($attributes: WWS_DeletePageItemAttributes!) {
  deletePageItem(attributes: $attributes)
}
    `;
export type DeleteParagraphItemMutationMutationFn = ApolloReactCommon.MutationFunction<DeleteParagraphItemMutation, DeleteParagraphItemMutationVariables>;

/**
 * __useDeleteParagraphItemMutation__
 *
 * To run a mutation, you first call `useDeleteParagraphItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteParagraphItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteParagraphItemMutation, { data, loading, error }] = useDeleteParagraphItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDeleteParagraphItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteParagraphItemMutation, DeleteParagraphItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteParagraphItemMutation, DeleteParagraphItemMutationVariables>(DeleteParagraphItemMutationDocument, baseOptions);
      }
export type DeleteParagraphItemMutationHookResult = ReturnType<typeof useDeleteParagraphItemMutation>;
export type DeleteParagraphItemMutationMutationResult = ApolloReactCommon.MutationResult<DeleteParagraphItemMutation>;
export type DeleteParagraphItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteParagraphItemMutation, DeleteParagraphItemMutationVariables>;
export const CreatePersonItemMutationDocument = gql`
    mutation createPersonItemMutation($attributes: WWS_CreatePersonItemAttrs!) {
  createPersonItem(attributes: $attributes) {
    ...PersonItems
  }
}
    ${PersonItemsFragmentDoc}`;
export type CreatePersonItemMutationMutationFn = ApolloReactCommon.MutationFunction<CreatePersonItemMutation, CreatePersonItemMutationVariables>;

/**
 * __useCreatePersonItemMutation__
 *
 * To run a mutation, you first call `useCreatePersonItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonItemMutation, { data, loading, error }] = useCreatePersonItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreatePersonItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePersonItemMutation, CreatePersonItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePersonItemMutation, CreatePersonItemMutationVariables>(CreatePersonItemMutationDocument, baseOptions);
      }
export type CreatePersonItemMutationHookResult = ReturnType<typeof useCreatePersonItemMutation>;
export type CreatePersonItemMutationMutationResult = ApolloReactCommon.MutationResult<CreatePersonItemMutation>;
export type CreatePersonItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePersonItemMutation, CreatePersonItemMutationVariables>;
export const UpdatePersonItemMutationDocument = gql`
    mutation updatePersonItemMutation($attributes: WWS_UpdatePersonItemAttrs!) {
  updatePersonItem(attributes: $attributes) {
    ...PersonItems
  }
}
    ${PersonItemsFragmentDoc}`;
export type UpdatePersonItemMutationMutationFn = ApolloReactCommon.MutationFunction<UpdatePersonItemMutation, UpdatePersonItemMutationVariables>;

/**
 * __useUpdatePersonItemMutation__
 *
 * To run a mutation, you first call `useUpdatePersonItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonItemMutation, { data, loading, error }] = useUpdatePersonItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdatePersonItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePersonItemMutation, UpdatePersonItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePersonItemMutation, UpdatePersonItemMutationVariables>(UpdatePersonItemMutationDocument, baseOptions);
      }
export type UpdatePersonItemMutationHookResult = ReturnType<typeof useUpdatePersonItemMutation>;
export type UpdatePersonItemMutationMutationResult = ApolloReactCommon.MutationResult<UpdatePersonItemMutation>;
export type UpdatePersonItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePersonItemMutation, UpdatePersonItemMutationVariables>;
export const PersonQueryDocument = gql`
    query personQuery($id: Int!, $pageId: Int!) {
  page(id: $pageId) {
    id
    personItem(id: $id) {
      ...PersonItems
    }
  }
}
    ${PersonItemsFragmentDoc}`;

/**
 * __usePersonQuery__
 *
 * To run a query within a React component, call `usePersonQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function usePersonQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PersonQuery, PersonQueryVariables>) {
        return ApolloReactHooks.useQuery<PersonQuery, PersonQueryVariables>(PersonQueryDocument, baseOptions);
      }
export function usePersonQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PersonQuery, PersonQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PersonQuery, PersonQueryVariables>(PersonQueryDocument, baseOptions);
        }
export type PersonQueryHookResult = ReturnType<typeof usePersonQuery>;
export type PersonQueryLazyQueryHookResult = ReturnType<typeof usePersonQueryLazyQuery>;
export type PersonQueryQueryResult = ApolloReactCommon.QueryResult<PersonQuery, PersonQueryVariables>;
export const DeletePersonItemMutationDocument = gql`
    mutation deletePersonItemMutation($id: Int!, $pageId: Int!) {
  deletePageItem(attributes: {id: $id, pageId: $pageId})
}
    `;
export type DeletePersonItemMutationMutationFn = ApolloReactCommon.MutationFunction<DeletePersonItemMutation, DeletePersonItemMutationVariables>;

/**
 * __useDeletePersonItemMutation__
 *
 * To run a mutation, you first call `useDeletePersonItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonItemMutation, { data, loading, error }] = useDeletePersonItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useDeletePersonItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePersonItemMutation, DeletePersonItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeletePersonItemMutation, DeletePersonItemMutationVariables>(DeletePersonItemMutationDocument, baseOptions);
      }
export type DeletePersonItemMutationHookResult = ReturnType<typeof useDeletePersonItemMutation>;
export type DeletePersonItemMutationMutationResult = ApolloReactCommon.MutationResult<DeletePersonItemMutation>;
export type DeletePersonItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePersonItemMutation, DeletePersonItemMutationVariables>;
export const CreatePhotoGalleryItemMutationDocument = gql`
    mutation createPhotoGalleryItemMutation($attributes: WWS_CreatePhotoGalleryItemAttrs!) {
  item: createPhotoGalleryItem(attributes: $attributes) {
    id
    layout
    photoItems {
      ...PhotoItems
    }
    rank
    type
  }
}
    ${PhotoItemsFragmentDoc}`;
export type CreatePhotoGalleryItemMutationMutationFn = ApolloReactCommon.MutationFunction<CreatePhotoGalleryItemMutation, CreatePhotoGalleryItemMutationVariables>;

/**
 * __useCreatePhotoGalleryItemMutation__
 *
 * To run a mutation, you first call `useCreatePhotoGalleryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhotoGalleryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhotoGalleryItemMutation, { data, loading, error }] = useCreatePhotoGalleryItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreatePhotoGalleryItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePhotoGalleryItemMutation, CreatePhotoGalleryItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePhotoGalleryItemMutation, CreatePhotoGalleryItemMutationVariables>(CreatePhotoGalleryItemMutationDocument, baseOptions);
      }
export type CreatePhotoGalleryItemMutationHookResult = ReturnType<typeof useCreatePhotoGalleryItemMutation>;
export type CreatePhotoGalleryItemMutationMutationResult = ApolloReactCommon.MutationResult<CreatePhotoGalleryItemMutation>;
export type CreatePhotoGalleryItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePhotoGalleryItemMutation, CreatePhotoGalleryItemMutationVariables>;
export const UpdatePhotoGalleryItemMutationDocument = gql`
    mutation updatePhotoGalleryItemMutation($attributes: WWS_UpdatePhotoGalleryItemAttrs!) {
  item: updatePhotoGalleryItem(attributes: $attributes) {
    id
    layout
    photoItems {
      ...PhotoItems
    }
    rank
    type
  }
}
    ${PhotoItemsFragmentDoc}`;
export type UpdatePhotoGalleryItemMutationMutationFn = ApolloReactCommon.MutationFunction<UpdatePhotoGalleryItemMutation, UpdatePhotoGalleryItemMutationVariables>;

/**
 * __useUpdatePhotoGalleryItemMutation__
 *
 * To run a mutation, you first call `useUpdatePhotoGalleryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhotoGalleryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhotoGalleryItemMutation, { data, loading, error }] = useUpdatePhotoGalleryItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdatePhotoGalleryItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePhotoGalleryItemMutation, UpdatePhotoGalleryItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePhotoGalleryItemMutation, UpdatePhotoGalleryItemMutationVariables>(UpdatePhotoGalleryItemMutationDocument, baseOptions);
      }
export type UpdatePhotoGalleryItemMutationHookResult = ReturnType<typeof useUpdatePhotoGalleryItemMutation>;
export type UpdatePhotoGalleryItemMutationMutationResult = ApolloReactCommon.MutationResult<UpdatePhotoGalleryItemMutation>;
export type UpdatePhotoGalleryItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePhotoGalleryItemMutation, UpdatePhotoGalleryItemMutationVariables>;
export const DeletePhotoGalleryItemMutationDocument = gql`
    mutation deletePhotoGalleryItemMutation($attributes: WWS_DeletePageItemAttributes!) {
  deletePageItem(attributes: $attributes)
}
    `;
export type DeletePhotoGalleryItemMutationMutationFn = ApolloReactCommon.MutationFunction<DeletePhotoGalleryItemMutation, DeletePhotoGalleryItemMutationVariables>;

/**
 * __useDeletePhotoGalleryItemMutation__
 *
 * To run a mutation, you first call `useDeletePhotoGalleryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePhotoGalleryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePhotoGalleryItemMutation, { data, loading, error }] = useDeletePhotoGalleryItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDeletePhotoGalleryItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePhotoGalleryItemMutation, DeletePhotoGalleryItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeletePhotoGalleryItemMutation, DeletePhotoGalleryItemMutationVariables>(DeletePhotoGalleryItemMutationDocument, baseOptions);
      }
export type DeletePhotoGalleryItemMutationHookResult = ReturnType<typeof useDeletePhotoGalleryItemMutation>;
export type DeletePhotoGalleryItemMutationMutationResult = ApolloReactCommon.MutationResult<DeletePhotoGalleryItemMutation>;
export type DeletePhotoGalleryItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePhotoGalleryItemMutation, DeletePhotoGalleryItemMutationVariables>;
export const PhotoGalleryQueryDocument = gql`
    query photoGalleryQuery($id: Int!, $pageId: Int!) {
  page(id: $pageId) {
    id
    photoGalleryItem(id: $id) {
      id
      photoItems {
        ...PhotoItems
      }
    }
  }
}
    ${PhotoItemsFragmentDoc}`;

/**
 * __usePhotoGalleryQuery__
 *
 * To run a query within a React component, call `usePhotoGalleryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotoGalleryQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotoGalleryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function usePhotoGalleryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PhotoGalleryQuery, PhotoGalleryQueryVariables>) {
        return ApolloReactHooks.useQuery<PhotoGalleryQuery, PhotoGalleryQueryVariables>(PhotoGalleryQueryDocument, baseOptions);
      }
export function usePhotoGalleryQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PhotoGalleryQuery, PhotoGalleryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PhotoGalleryQuery, PhotoGalleryQueryVariables>(PhotoGalleryQueryDocument, baseOptions);
        }
export type PhotoGalleryQueryHookResult = ReturnType<typeof usePhotoGalleryQuery>;
export type PhotoGalleryQueryLazyQueryHookResult = ReturnType<typeof usePhotoGalleryQueryLazyQuery>;
export type PhotoGalleryQueryQueryResult = ApolloReactCommon.QueryResult<PhotoGalleryQuery, PhotoGalleryQueryVariables>;
export const CreatePhotoItemMutationDocument = gql`
    mutation createPhotoItemMutation($attributes: WWS_CreatePhotoItemAttrs!) {
  createPhotoItem(attributes: $attributes) {
    ...PhotoItems
  }
}
    ${PhotoItemsFragmentDoc}`;
export type CreatePhotoItemMutationMutationFn = ApolloReactCommon.MutationFunction<CreatePhotoItemMutation, CreatePhotoItemMutationVariables>;

/**
 * __useCreatePhotoItemMutation__
 *
 * To run a mutation, you first call `useCreatePhotoItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhotoItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhotoItemMutation, { data, loading, error }] = useCreatePhotoItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreatePhotoItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePhotoItemMutation, CreatePhotoItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePhotoItemMutation, CreatePhotoItemMutationVariables>(CreatePhotoItemMutationDocument, baseOptions);
      }
export type CreatePhotoItemMutationHookResult = ReturnType<typeof useCreatePhotoItemMutation>;
export type CreatePhotoItemMutationMutationResult = ApolloReactCommon.MutationResult<CreatePhotoItemMutation>;
export type CreatePhotoItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePhotoItemMutation, CreatePhotoItemMutationVariables>;
export const UpdatePhotoItemMutationDocument = gql`
    mutation updatePhotoItemMutation($attributes: WWS_UpdatePhotoItemAttrs!) {
  updatePhotoItem(attributes: $attributes) {
    ...PhotoItems
  }
}
    ${PhotoItemsFragmentDoc}`;
export type UpdatePhotoItemMutationMutationFn = ApolloReactCommon.MutationFunction<UpdatePhotoItemMutation, UpdatePhotoItemMutationVariables>;

/**
 * __useUpdatePhotoItemMutation__
 *
 * To run a mutation, you first call `useUpdatePhotoItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhotoItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhotoItemMutation, { data, loading, error }] = useUpdatePhotoItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdatePhotoItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePhotoItemMutation, UpdatePhotoItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePhotoItemMutation, UpdatePhotoItemMutationVariables>(UpdatePhotoItemMutationDocument, baseOptions);
      }
export type UpdatePhotoItemMutationHookResult = ReturnType<typeof useUpdatePhotoItemMutation>;
export type UpdatePhotoItemMutationMutationResult = ApolloReactCommon.MutationResult<UpdatePhotoItemMutation>;
export type UpdatePhotoItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePhotoItemMutation, UpdatePhotoItemMutationVariables>;
export const DeletePhotoItemDocument = gql`
    mutation deletePhotoItem($attributes: WWS_DeletePageItemAttributes!) {
  deletePageItem(attributes: $attributes)
}
    `;
export type DeletePhotoItemMutationFn = ApolloReactCommon.MutationFunction<DeletePhotoItemMutation, DeletePhotoItemMutationVariables>;

/**
 * __useDeletePhotoItemMutation__
 *
 * To run a mutation, you first call `useDeletePhotoItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePhotoItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePhotoItemMutation, { data, loading, error }] = useDeletePhotoItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDeletePhotoItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePhotoItemMutation, DeletePhotoItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeletePhotoItemMutation, DeletePhotoItemMutationVariables>(DeletePhotoItemDocument, baseOptions);
      }
export type DeletePhotoItemMutationHookResult = ReturnType<typeof useDeletePhotoItemMutation>;
export type DeletePhotoItemMutationResult = ApolloReactCommon.MutationResult<DeletePhotoItemMutation>;
export type DeletePhotoItemMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePhotoItemMutation, DeletePhotoItemMutationVariables>;
export const MediaApiJwtQueryDocument = gql`
    query MediaApiJwtQuery {
  mediaApiJwt {
    token
  }
}
    `;

/**
 * __useMediaApiJwtQuery__
 *
 * To run a query within a React component, call `useMediaApiJwtQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaApiJwtQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaApiJwtQuery({
 *   variables: {
 *   },
 * });
 */
export function useMediaApiJwtQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MediaApiJwtQuery, MediaApiJwtQueryVariables>) {
        return ApolloReactHooks.useQuery<MediaApiJwtQuery, MediaApiJwtQueryVariables>(MediaApiJwtQueryDocument, baseOptions);
      }
export function useMediaApiJwtQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MediaApiJwtQuery, MediaApiJwtQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MediaApiJwtQuery, MediaApiJwtQueryVariables>(MediaApiJwtQueryDocument, baseOptions);
        }
export type MediaApiJwtQueryHookResult = ReturnType<typeof useMediaApiJwtQuery>;
export type MediaApiJwtQueryLazyQueryHookResult = ReturnType<typeof useMediaApiJwtQueryLazyQuery>;
export type MediaApiJwtQueryQueryResult = ApolloReactCommon.QueryResult<MediaApiJwtQuery, MediaApiJwtQueryVariables>;
export const CreatePhotoTimelineItemMutationDocument = gql`
    mutation createPhotoTimelineItemMutation($attributes: WWS_CreatePhotoTimelineItemAttrs!) {
  item: createPhotoTimelineItem(attributes: $attributes) {
    id
    layout
    photoItems {
      ...PhotoItems
    }
    rank
    type
  }
}
    ${PhotoItemsFragmentDoc}`;
export type CreatePhotoTimelineItemMutationMutationFn = ApolloReactCommon.MutationFunction<CreatePhotoTimelineItemMutation, CreatePhotoTimelineItemMutationVariables>;

/**
 * __useCreatePhotoTimelineItemMutation__
 *
 * To run a mutation, you first call `useCreatePhotoTimelineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhotoTimelineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhotoTimelineItemMutation, { data, loading, error }] = useCreatePhotoTimelineItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreatePhotoTimelineItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePhotoTimelineItemMutation, CreatePhotoTimelineItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePhotoTimelineItemMutation, CreatePhotoTimelineItemMutationVariables>(CreatePhotoTimelineItemMutationDocument, baseOptions);
      }
export type CreatePhotoTimelineItemMutationHookResult = ReturnType<typeof useCreatePhotoTimelineItemMutation>;
export type CreatePhotoTimelineItemMutationMutationResult = ApolloReactCommon.MutationResult<CreatePhotoTimelineItemMutation>;
export type CreatePhotoTimelineItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePhotoTimelineItemMutation, CreatePhotoTimelineItemMutationVariables>;
export const UpdatePhotoTimelineItemMutationDocument = gql`
    mutation updatePhotoTimelineItemMutation($attributes: WWS_UpdatePhotoTimelineItemAttrs!) {
  item: updatePhotoTimelineItem(attributes: $attributes) {
    id
    layout
    photoItems {
      ...PhotoItems
    }
    rank
    type
  }
}
    ${PhotoItemsFragmentDoc}`;
export type UpdatePhotoTimelineItemMutationMutationFn = ApolloReactCommon.MutationFunction<UpdatePhotoTimelineItemMutation, UpdatePhotoTimelineItemMutationVariables>;

/**
 * __useUpdatePhotoTimelineItemMutation__
 *
 * To run a mutation, you first call `useUpdatePhotoTimelineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhotoTimelineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhotoTimelineItemMutation, { data, loading, error }] = useUpdatePhotoTimelineItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdatePhotoTimelineItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePhotoTimelineItemMutation, UpdatePhotoTimelineItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePhotoTimelineItemMutation, UpdatePhotoTimelineItemMutationVariables>(UpdatePhotoTimelineItemMutationDocument, baseOptions);
      }
export type UpdatePhotoTimelineItemMutationHookResult = ReturnType<typeof useUpdatePhotoTimelineItemMutation>;
export type UpdatePhotoTimelineItemMutationMutationResult = ApolloReactCommon.MutationResult<UpdatePhotoTimelineItemMutation>;
export type UpdatePhotoTimelineItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePhotoTimelineItemMutation, UpdatePhotoTimelineItemMutationVariables>;
export const DeletePhotoTimelineItemMutationDocument = gql`
    mutation deletePhotoTimelineItemMutation($attributes: WWS_DeletePageItemAttributes!) {
  deletePageItem(attributes: $attributes)
}
    `;
export type DeletePhotoTimelineItemMutationMutationFn = ApolloReactCommon.MutationFunction<DeletePhotoTimelineItemMutation, DeletePhotoTimelineItemMutationVariables>;

/**
 * __useDeletePhotoTimelineItemMutation__
 *
 * To run a mutation, you first call `useDeletePhotoTimelineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePhotoTimelineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePhotoTimelineItemMutation, { data, loading, error }] = useDeletePhotoTimelineItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDeletePhotoTimelineItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePhotoTimelineItemMutation, DeletePhotoTimelineItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeletePhotoTimelineItemMutation, DeletePhotoTimelineItemMutationVariables>(DeletePhotoTimelineItemMutationDocument, baseOptions);
      }
export type DeletePhotoTimelineItemMutationHookResult = ReturnType<typeof useDeletePhotoTimelineItemMutation>;
export type DeletePhotoTimelineItemMutationMutationResult = ApolloReactCommon.MutationResult<DeletePhotoTimelineItemMutation>;
export type DeletePhotoTimelineItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePhotoTimelineItemMutation, DeletePhotoTimelineItemMutationVariables>;
export const PhotoTimelineQueryDocument = gql`
    query photoTimelineQuery($id: Int!, $pageId: Int!) {
  page(id: $pageId) {
    id
    photoTimelineItem(id: $id) {
      id
      photoItems {
        ...PhotoItems
      }
    }
  }
}
    ${PhotoItemsFragmentDoc}`;

/**
 * __usePhotoTimelineQuery__
 *
 * To run a query within a React component, call `usePhotoTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotoTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotoTimelineQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function usePhotoTimelineQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PhotoTimelineQuery, PhotoTimelineQueryVariables>) {
        return ApolloReactHooks.useQuery<PhotoTimelineQuery, PhotoTimelineQueryVariables>(PhotoTimelineQueryDocument, baseOptions);
      }
export function usePhotoTimelineQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PhotoTimelineQuery, PhotoTimelineQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PhotoTimelineQuery, PhotoTimelineQueryVariables>(PhotoTimelineQueryDocument, baseOptions);
        }
export type PhotoTimelineQueryHookResult = ReturnType<typeof usePhotoTimelineQuery>;
export type PhotoTimelineQueryLazyQueryHookResult = ReturnType<typeof usePhotoTimelineQueryLazyQuery>;
export type PhotoTimelineQueryQueryResult = ApolloReactCommon.QueryResult<PhotoTimelineQuery, PhotoTimelineQueryVariables>;
export const CreateQuestionItemMutationDocument = gql`
    mutation createQuestionItemMutation($attributes: WWS_CreateQuestionItemAttrs!) {
  createQuestionItem(attributes: $attributes) {
    ...QuestionItems
  }
}
    ${QuestionItemsFragmentDoc}`;
export type CreateQuestionItemMutationMutationFn = ApolloReactCommon.MutationFunction<CreateQuestionItemMutation, CreateQuestionItemMutationVariables>;

/**
 * __useCreateQuestionItemMutation__
 *
 * To run a mutation, you first call `useCreateQuestionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionItemMutation, { data, loading, error }] = useCreateQuestionItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateQuestionItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateQuestionItemMutation, CreateQuestionItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateQuestionItemMutation, CreateQuestionItemMutationVariables>(CreateQuestionItemMutationDocument, baseOptions);
      }
export type CreateQuestionItemMutationHookResult = ReturnType<typeof useCreateQuestionItemMutation>;
export type CreateQuestionItemMutationMutationResult = ApolloReactCommon.MutationResult<CreateQuestionItemMutation>;
export type CreateQuestionItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateQuestionItemMutation, CreateQuestionItemMutationVariables>;
export const UpdateQuestionItemMutationDocument = gql`
    mutation updateQuestionItemMutation($attributes: WWS_UpdateQuestionItemAttrs!) {
  updateQuestionItem(attributes: $attributes) {
    ...QuestionItems
  }
}
    ${QuestionItemsFragmentDoc}`;
export type UpdateQuestionItemMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateQuestionItemMutation, UpdateQuestionItemMutationVariables>;

/**
 * __useUpdateQuestionItemMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionItemMutation, { data, loading, error }] = useUpdateQuestionItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateQuestionItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateQuestionItemMutation, UpdateQuestionItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateQuestionItemMutation, UpdateQuestionItemMutationVariables>(UpdateQuestionItemMutationDocument, baseOptions);
      }
export type UpdateQuestionItemMutationHookResult = ReturnType<typeof useUpdateQuestionItemMutation>;
export type UpdateQuestionItemMutationMutationResult = ApolloReactCommon.MutationResult<UpdateQuestionItemMutation>;
export type UpdateQuestionItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateQuestionItemMutation, UpdateQuestionItemMutationVariables>;
export const DeleteQuestionItemMutationDocument = gql`
    mutation deleteQuestionItemMutation($attributes: WWS_DeletePageItemAttributes!) {
  deletePageItem(attributes: $attributes)
}
    `;
export type DeleteQuestionItemMutationMutationFn = ApolloReactCommon.MutationFunction<DeleteQuestionItemMutation, DeleteQuestionItemMutationVariables>;

/**
 * __useDeleteQuestionItemMutation__
 *
 * To run a mutation, you first call `useDeleteQuestionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuestionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuestionItemMutation, { data, loading, error }] = useDeleteQuestionItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDeleteQuestionItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteQuestionItemMutation, DeleteQuestionItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteQuestionItemMutation, DeleteQuestionItemMutationVariables>(DeleteQuestionItemMutationDocument, baseOptions);
      }
export type DeleteQuestionItemMutationHookResult = ReturnType<typeof useDeleteQuestionItemMutation>;
export type DeleteQuestionItemMutationMutationResult = ApolloReactCommon.MutationResult<DeleteQuestionItemMutation>;
export type DeleteQuestionItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteQuestionItemMutation, DeleteQuestionItemMutationVariables>;
export const QuestionQueryDocument = gql`
    query questionQuery($id: Int!, $pageId: Int!) {
  page(id: $pageId) {
    id
    questionItem(id: $id) {
      ...QuestionItems
    }
  }
}
    ${QuestionItemsFragmentDoc}`;

/**
 * __useQuestionQuery__
 *
 * To run a query within a React component, call `useQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useQuestionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<QuestionQuery, QuestionQueryVariables>) {
        return ApolloReactHooks.useQuery<QuestionQuery, QuestionQueryVariables>(QuestionQueryDocument, baseOptions);
      }
export function useQuestionQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QuestionQuery, QuestionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<QuestionQuery, QuestionQueryVariables>(QuestionQueryDocument, baseOptions);
        }
export type QuestionQueryHookResult = ReturnType<typeof useQuestionQuery>;
export type QuestionQueryLazyQueryHookResult = ReturnType<typeof useQuestionQueryLazyQuery>;
export type QuestionQueryQueryResult = ApolloReactCommon.QueryResult<QuestionQuery, QuestionQueryVariables>;
export const CreateStoryItemMutationDocument = gql`
    mutation createStoryItemMutation($attributes: WWS_CreateStoryItemAttrs!) {
  createStoryItem(attributes: $attributes) {
    ...StoryItems
  }
}
    ${StoryItemsFragmentDoc}`;
export type CreateStoryItemMutationMutationFn = ApolloReactCommon.MutationFunction<CreateStoryItemMutation, CreateStoryItemMutationVariables>;

/**
 * __useCreateStoryItemMutation__
 *
 * To run a mutation, you first call `useCreateStoryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStoryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStoryItemMutation, { data, loading, error }] = useCreateStoryItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateStoryItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStoryItemMutation, CreateStoryItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateStoryItemMutation, CreateStoryItemMutationVariables>(CreateStoryItemMutationDocument, baseOptions);
      }
export type CreateStoryItemMutationHookResult = ReturnType<typeof useCreateStoryItemMutation>;
export type CreateStoryItemMutationMutationResult = ApolloReactCommon.MutationResult<CreateStoryItemMutation>;
export type CreateStoryItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateStoryItemMutation, CreateStoryItemMutationVariables>;
export const UpdateStoryItemMutationDocument = gql`
    mutation updateStoryItemMutation($attributes: WWS_UpdateStoryItemAttrs!) {
  updateStoryItem(attributes: $attributes) {
    ...StoryItems
  }
}
    ${StoryItemsFragmentDoc}`;
export type UpdateStoryItemMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateStoryItemMutation, UpdateStoryItemMutationVariables>;

/**
 * __useUpdateStoryItemMutation__
 *
 * To run a mutation, you first call `useUpdateStoryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStoryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStoryItemMutation, { data, loading, error }] = useUpdateStoryItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateStoryItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStoryItemMutation, UpdateStoryItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateStoryItemMutation, UpdateStoryItemMutationVariables>(UpdateStoryItemMutationDocument, baseOptions);
      }
export type UpdateStoryItemMutationHookResult = ReturnType<typeof useUpdateStoryItemMutation>;
export type UpdateStoryItemMutationMutationResult = ApolloReactCommon.MutationResult<UpdateStoryItemMutation>;
export type UpdateStoryItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateStoryItemMutation, UpdateStoryItemMutationVariables>;
export const StoryQueryDocument = gql`
    query storyQuery($id: Int!, $pageId: Int!) {
  page(id: $pageId) {
    id
    storyItem(id: $id) {
      ...StoryItems
    }
  }
}
    ${StoryItemsFragmentDoc}`;

/**
 * __useStoryQuery__
 *
 * To run a query within a React component, call `useStoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoryQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useStoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StoryQuery, StoryQueryVariables>) {
        return ApolloReactHooks.useQuery<StoryQuery, StoryQueryVariables>(StoryQueryDocument, baseOptions);
      }
export function useStoryQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StoryQuery, StoryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<StoryQuery, StoryQueryVariables>(StoryQueryDocument, baseOptions);
        }
export type StoryQueryHookResult = ReturnType<typeof useStoryQuery>;
export type StoryQueryLazyQueryHookResult = ReturnType<typeof useStoryQueryLazyQuery>;
export type StoryQueryQueryResult = ApolloReactCommon.QueryResult<StoryQuery, StoryQueryVariables>;
export const DeleteStoryItemMutationDocument = gql`
    mutation deleteStoryItemMutation($id: Int!, $pageId: Int!) {
  deletePageItem(attributes: {id: $id, pageId: $pageId})
}
    `;
export type DeleteStoryItemMutationMutationFn = ApolloReactCommon.MutationFunction<DeleteStoryItemMutation, DeleteStoryItemMutationVariables>;

/**
 * __useDeleteStoryItemMutation__
 *
 * To run a mutation, you first call `useDeleteStoryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStoryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStoryItemMutation, { data, loading, error }] = useDeleteStoryItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useDeleteStoryItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteStoryItemMutation, DeleteStoryItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteStoryItemMutation, DeleteStoryItemMutationVariables>(DeleteStoryItemMutationDocument, baseOptions);
      }
export type DeleteStoryItemMutationHookResult = ReturnType<typeof useDeleteStoryItemMutation>;
export type DeleteStoryItemMutationMutationResult = ApolloReactCommon.MutationResult<DeleteStoryItemMutation>;
export type DeleteStoryItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteStoryItemMutation, DeleteStoryItemMutationVariables>;
export const UpdateTransportationItemMutationDocument = gql`
    mutation updateTransportationItemMutation($attributes: WWS_UpdateBusinessItemAttrs!) {
  updateTransportationItem(attributes: $attributes) {
    ...TransportationItems
  }
}
    ${TransportationItemsFragmentDoc}`;
export type UpdateTransportationItemMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateTransportationItemMutation, UpdateTransportationItemMutationVariables>;

/**
 * __useUpdateTransportationItemMutation__
 *
 * To run a mutation, you first call `useUpdateTransportationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransportationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransportationItemMutation, { data, loading, error }] = useUpdateTransportationItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateTransportationItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTransportationItemMutation, UpdateTransportationItemMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateTransportationItemMutation, UpdateTransportationItemMutationVariables>(UpdateTransportationItemMutationDocument, baseOptions);
      }
export type UpdateTransportationItemMutationHookResult = ReturnType<typeof useUpdateTransportationItemMutation>;
export type UpdateTransportationItemMutationMutationResult = ApolloReactCommon.MutationResult<UpdateTransportationItemMutation>;
export type UpdateTransportationItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTransportationItemMutation, UpdateTransportationItemMutationVariables>;
export const CreateTransportationItemMutationDocument = gql`
    mutation createTransportationItemMutation($attributes: WWS_CreateBusinessItemAttrs!) {
  item: createTransportationItem(attributes: $attributes) {
    ...TransportationItems
  }
}
    ${TransportationItemsFragmentDoc}`;
export type CreateTransportationItemMutationMutationFn = ApolloReactCommon.MutationFunction<CreateTransportationItemMutation, CreateTransportationItemMutationVariables>;

/**
 * __useCreateTransportationItemMutation__
 *
 * To run a mutation, you first call `useCreateTransportationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransportationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransportationItemMutation, { data, loading, error }] = useCreateTransportationItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateTransportationItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTransportationItemMutation, CreateTransportationItemMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateTransportationItemMutation, CreateTransportationItemMutationVariables>(CreateTransportationItemMutationDocument, baseOptions);
      }
export type CreateTransportationItemMutationHookResult = ReturnType<typeof useCreateTransportationItemMutation>;
export type CreateTransportationItemMutationMutationResult = ApolloReactCommon.MutationResult<CreateTransportationItemMutation>;
export type CreateTransportationItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTransportationItemMutation, CreateTransportationItemMutationVariables>;
export const TransportationQueryDocument = gql`
    query TransportationQuery($id: Int!, $pageId: Int!) {
  page(id: $pageId) {
    transportationItem(id: $id) {
      ...TransportationItems
    }
  }
}
    ${TransportationItemsFragmentDoc}`;

/**
 * __useTransportationQuery__
 *
 * To run a query within a React component, call `useTransportationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransportationQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransportationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useTransportationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TransportationQuery, TransportationQueryVariables>) {
        return ApolloReactHooks.useQuery<TransportationQuery, TransportationQueryVariables>(TransportationQueryDocument, baseOptions);
      }
export function useTransportationQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TransportationQuery, TransportationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TransportationQuery, TransportationQueryVariables>(TransportationQueryDocument, baseOptions);
        }
export type TransportationQueryHookResult = ReturnType<typeof useTransportationQuery>;
export type TransportationQueryLazyQueryHookResult = ReturnType<typeof useTransportationQueryLazyQuery>;
export type TransportationQueryQueryResult = ApolloReactCommon.QueryResult<TransportationQuery, TransportationQueryVariables>;
export const DeleteTransportationItemMutationDocument = gql`
    mutation deleteTransportationItemMutation($attributes: WWS_DeletePageItemAttributes!) {
  deletePageItem(attributes: $attributes)
}
    `;
export type DeleteTransportationItemMutationMutationFn = ApolloReactCommon.MutationFunction<DeleteTransportationItemMutation, DeleteTransportationItemMutationVariables>;

/**
 * __useDeleteTransportationItemMutation__
 *
 * To run a mutation, you first call `useDeleteTransportationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTransportationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTransportationItemMutation, { data, loading, error }] = useDeleteTransportationItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDeleteTransportationItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTransportationItemMutation, DeleteTransportationItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteTransportationItemMutation, DeleteTransportationItemMutationVariables>(DeleteTransportationItemMutationDocument, baseOptions);
      }
export type DeleteTransportationItemMutationHookResult = ReturnType<typeof useDeleteTransportationItemMutation>;
export type DeleteTransportationItemMutationMutationResult = ApolloReactCommon.MutationResult<DeleteTransportationItemMutation>;
export type DeleteTransportationItemMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteTransportationItemMutation, DeleteTransportationItemMutationVariables>;
export const PageQueryDocument = gql`
    query pageQuery($id: Int!) {
  page(id: $id) {
    ...Pages
  }
}
    ${PagesFragmentDoc}`;

/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PageQuery, PageQueryVariables>) {
        return ApolloReactHooks.useQuery<PageQuery, PageQueryVariables>(PageQueryDocument, baseOptions);
      }
export function usePageQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PageQuery, PageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PageQuery, PageQueryVariables>(PageQueryDocument, baseOptions);
        }
export type PageQueryHookResult = ReturnType<typeof usePageQuery>;
export type PageQueryLazyQueryHookResult = ReturnType<typeof usePageQueryLazyQuery>;
export type PageQueryQueryResult = ApolloReactCommon.QueryResult<PageQuery, PageQueryVariables>;
export const UpdatePageMutationDocument = gql`
    mutation updatePageMutation($id: Int!, $attributes: WWS_PageAttributes!) {
  updatePage(id: $id, attributes: $attributes) {
    ...Pages
  }
}
    ${PagesFragmentDoc}`;
export type UpdatePageMutationMutationFn = ApolloReactCommon.MutationFunction<UpdatePageMutation, UpdatePageMutationVariables>;

/**
 * __useUpdatePageMutation__
 *
 * To run a mutation, you first call `useUpdatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageMutation, { data, loading, error }] = useUpdatePageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdatePageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePageMutation, UpdatePageMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePageMutation, UpdatePageMutationVariables>(UpdatePageMutationDocument, baseOptions);
      }
export type UpdatePageMutationHookResult = ReturnType<typeof useUpdatePageMutation>;
export type UpdatePageMutationMutationResult = ApolloReactCommon.MutationResult<UpdatePageMutation>;
export type UpdatePageMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePageMutation, UpdatePageMutationVariables>;
export const UpdateRegistryPageMutationDocument = gql`
    mutation updateRegistryPageMutation($id: Int!, $attributes: WWS_PageAttributes!, $weddingAttrs: WWS_WeddingWebsiteAttributes!) {
  updatePage(id: $id, attributes: $attributes) {
    ...Pages
  }
  updateWeddingWebsite(attributes: $weddingAttrs) {
    id
    registryNote
  }
}
    ${PagesFragmentDoc}`;
export type UpdateRegistryPageMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateRegistryPageMutation, UpdateRegistryPageMutationVariables>;

/**
 * __useUpdateRegistryPageMutation__
 *
 * To run a mutation, you first call `useUpdateRegistryPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegistryPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegistryPageMutation, { data, loading, error }] = useUpdateRegistryPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *      weddingAttrs: // value for 'weddingAttrs'
 *   },
 * });
 */
export function useUpdateRegistryPageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRegistryPageMutation, UpdateRegistryPageMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateRegistryPageMutation, UpdateRegistryPageMutationVariables>(UpdateRegistryPageMutationDocument, baseOptions);
      }
export type UpdateRegistryPageMutationHookResult = ReturnType<typeof useUpdateRegistryPageMutation>;
export type UpdateRegistryPageMutationMutationResult = ApolloReactCommon.MutationResult<UpdateRegistryPageMutation>;
export type UpdateRegistryPageMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRegistryPageMutation, UpdateRegistryPageMutationVariables>;
export const DeletePageMutationDocument = gql`
    mutation deletePageMutation($id: Int!) {
  deletePage(id: $id) {
    id
    title
    show
    rank
    type
  }
}
    `;
export type DeletePageMutationMutationFn = ApolloReactCommon.MutationFunction<DeletePageMutation, DeletePageMutationVariables>;

/**
 * __useDeletePageMutation__
 *
 * To run a mutation, you first call `useDeletePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePageMutation, { data, loading, error }] = useDeletePageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePageMutation, DeletePageMutationVariables>) {
        return ApolloReactHooks.useMutation<DeletePageMutation, DeletePageMutationVariables>(DeletePageMutationDocument, baseOptions);
      }
export type DeletePageMutationHookResult = ReturnType<typeof useDeletePageMutation>;
export type DeletePageMutationMutationResult = ApolloReactCommon.MutationResult<DeletePageMutation>;
export type DeletePageMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePageMutation, DeletePageMutationVariables>;
export const UpdateThemeMutationDocument = gql`
    mutation updateThemeMutation($id: Int!) {
  updateSelectedTheme(id: $id) {
    id
    previewUrl
    name
    family
    designerUrl
    previewImage {
      mediaApiId
    }
    mobilePreviewImage {
      mediaApiId
    }
    stationaryPreviewImage {
      mediaApiId
    }
    themeDesigner {
      name
      companyName
    }
    familyThemes {
      id
      swatchUrl
      name
    }
  }
}
    `;
export type UpdateThemeMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateThemeMutation, UpdateThemeMutationVariables>;

/**
 * __useUpdateThemeMutation__
 *
 * To run a mutation, you first call `useUpdateThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThemeMutation, { data, loading, error }] = useUpdateThemeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateThemeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateThemeMutation, UpdateThemeMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateThemeMutation, UpdateThemeMutationVariables>(UpdateThemeMutationDocument, baseOptions);
      }
export type UpdateThemeMutationHookResult = ReturnType<typeof useUpdateThemeMutation>;
export type UpdateThemeMutationMutationResult = ApolloReactCommon.MutationResult<UpdateThemeMutation>;
export type UpdateThemeMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateThemeMutation, UpdateThemeMutationVariables>;
export const PrintPromotionMutationDocument = gql`
    mutation printPromotionMutation {
  printPromotion {
    id
    imageUrl
    title
    description
    mainCtaUrl
  }
}
    `;
export type PrintPromotionMutationMutationFn = ApolloReactCommon.MutationFunction<PrintPromotionMutation, PrintPromotionMutationVariables>;

/**
 * __usePrintPromotionMutation__
 *
 * To run a mutation, you first call `usePrintPromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintPromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printPromotionMutation, { data, loading, error }] = usePrintPromotionMutation({
 *   variables: {
 *   },
 * });
 */
export function usePrintPromotionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PrintPromotionMutation, PrintPromotionMutationVariables>) {
        return ApolloReactHooks.useMutation<PrintPromotionMutation, PrintPromotionMutationVariables>(PrintPromotionMutationDocument, baseOptions);
      }
export type PrintPromotionMutationHookResult = ReturnType<typeof usePrintPromotionMutation>;
export type PrintPromotionMutationMutationResult = ApolloReactCommon.MutationResult<PrintPromotionMutation>;
export type PrintPromotionMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<PrintPromotionMutation, PrintPromotionMutationVariables>;
export const DismissPromotionMutationDocument = gql`
    mutation dismissPromotionMutation($id: Int!) {
  dismissPromotion(id: $id) {
    id
  }
}
    `;
export type DismissPromotionMutationMutationFn = ApolloReactCommon.MutationFunction<DismissPromotionMutation, DismissPromotionMutationVariables>;

/**
 * __useDismissPromotionMutation__
 *
 * To run a mutation, you first call `useDismissPromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissPromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissPromotionMutation, { data, loading, error }] = useDismissPromotionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDismissPromotionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DismissPromotionMutation, DismissPromotionMutationVariables>) {
        return ApolloReactHooks.useMutation<DismissPromotionMutation, DismissPromotionMutationVariables>(DismissPromotionMutationDocument, baseOptions);
      }
export type DismissPromotionMutationHookResult = ReturnType<typeof useDismissPromotionMutation>;
export type DismissPromotionMutationMutationResult = ApolloReactCommon.MutationResult<DismissPromotionMutation>;
export type DismissPromotionMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DismissPromotionMutation, DismissPromotionMutationVariables>;
export const SearchDomainQueryDocument = gql`
    query searchDomainQuery($domainName: String!) {
  searchDomains(domainName: $domainName) {
    name
    available
    isPremiumName
    price
  }
}
    `;

/**
 * __useSearchDomainQuery__
 *
 * To run a query within a React component, call `useSearchDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDomainQuery({
 *   variables: {
 *      domainName: // value for 'domainName'
 *   },
 * });
 */
export function useSearchDomainQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchDomainQuery, SearchDomainQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchDomainQuery, SearchDomainQueryVariables>(SearchDomainQueryDocument, baseOptions);
      }
export function useSearchDomainQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchDomainQuery, SearchDomainQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchDomainQuery, SearchDomainQueryVariables>(SearchDomainQueryDocument, baseOptions);
        }
export type SearchDomainQueryHookResult = ReturnType<typeof useSearchDomainQuery>;
export type SearchDomainQueryLazyQueryHookResult = ReturnType<typeof useSearchDomainQueryLazyQuery>;
export type SearchDomainQueryQueryResult = ApolloReactCommon.QueryResult<SearchDomainQuery, SearchDomainQueryVariables>;
export const BraintreeTokenQueryDocument = gql`
    query braintreeTokenQuery {
  braintreeToken {
    token
    vendorId
  }
}
    `;

/**
 * __useBraintreeTokenQuery__
 *
 * To run a query within a React component, call `useBraintreeTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useBraintreeTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBraintreeTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useBraintreeTokenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BraintreeTokenQuery, BraintreeTokenQueryVariables>) {
        return ApolloReactHooks.useQuery<BraintreeTokenQuery, BraintreeTokenQueryVariables>(BraintreeTokenQueryDocument, baseOptions);
      }
export function useBraintreeTokenQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BraintreeTokenQuery, BraintreeTokenQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BraintreeTokenQuery, BraintreeTokenQueryVariables>(BraintreeTokenQueryDocument, baseOptions);
        }
export type BraintreeTokenQueryHookResult = ReturnType<typeof useBraintreeTokenQuery>;
export type BraintreeTokenQueryLazyQueryHookResult = ReturnType<typeof useBraintreeTokenQueryLazyQuery>;
export type BraintreeTokenQueryQueryResult = ApolloReactCommon.QueryResult<BraintreeTokenQuery, BraintreeTokenQueryVariables>;
export const CreatePurchaseDomainMutationDocument = gql`
    mutation createPurchaseDomainMutation($attributes: WWS_CreatePurchaseDomainAttrs!) {
  createPurchaseDomain(attributes: $attributes) {
    id
    name
    showRenewal
    isRenewable
    isInRedemptionPeriod
    isExpired
    expirationDate
    dateOfLastRenewal
    renewalPrice
    createdAt
  }
}
    `;
export type CreatePurchaseDomainMutationMutationFn = ApolloReactCommon.MutationFunction<CreatePurchaseDomainMutation, CreatePurchaseDomainMutationVariables>;

/**
 * __useCreatePurchaseDomainMutation__
 *
 * To run a mutation, you first call `useCreatePurchaseDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePurchaseDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPurchaseDomainMutation, { data, loading, error }] = useCreatePurchaseDomainMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreatePurchaseDomainMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePurchaseDomainMutation, CreatePurchaseDomainMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePurchaseDomainMutation, CreatePurchaseDomainMutationVariables>(CreatePurchaseDomainMutationDocument, baseOptions);
      }
export type CreatePurchaseDomainMutationHookResult = ReturnType<typeof useCreatePurchaseDomainMutation>;
export type CreatePurchaseDomainMutationMutationResult = ApolloReactCommon.MutationResult<CreatePurchaseDomainMutation>;
export type CreatePurchaseDomainMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePurchaseDomainMutation, CreatePurchaseDomainMutationVariables>;
export const UpdatePurchaseDomainMutationDocument = gql`
    mutation updatePurchaseDomainMutation($attributes: WWS_UpdatePurchaseDomainAttrs!) {
  updatePurchaseDomain(attributes: $attributes) {
    id
    name
    showRenewal
    isRenewable
    isInRedemptionPeriod
    isExpired
    expirationDate
    dateOfLastRenewal
    renewalPrice
    createdAt
  }
}
    `;
export type UpdatePurchaseDomainMutationMutationFn = ApolloReactCommon.MutationFunction<UpdatePurchaseDomainMutation, UpdatePurchaseDomainMutationVariables>;

/**
 * __useUpdatePurchaseDomainMutation__
 *
 * To run a mutation, you first call `useUpdatePurchaseDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePurchaseDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePurchaseDomainMutation, { data, loading, error }] = useUpdatePurchaseDomainMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdatePurchaseDomainMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePurchaseDomainMutation, UpdatePurchaseDomainMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdatePurchaseDomainMutation, UpdatePurchaseDomainMutationVariables>(UpdatePurchaseDomainMutationDocument, baseOptions);
      }
export type UpdatePurchaseDomainMutationHookResult = ReturnType<typeof useUpdatePurchaseDomainMutation>;
export type UpdatePurchaseDomainMutationMutationResult = ApolloReactCommon.MutationResult<UpdatePurchaseDomainMutation>;
export type UpdatePurchaseDomainMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePurchaseDomainMutation, UpdatePurchaseDomainMutationVariables>;
export const RegistrySummaryQueryDocument = gql`
    query registrySummaryQuery {
  registrySummary {
    totalActiveGiftsRequested
    totalCashFunds
    totalGiftsReceived
    totalCashCentsReceived
    giftsByStore {
      name
    }
    hasTransactionalRegistry
    registries {
      isDeleted
      hiddenWws
      registryType
    }
  }
}
    `;

/**
 * __useRegistrySummaryQuery__
 *
 * To run a query within a React component, call `useRegistrySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrySummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegistrySummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RegistrySummaryQuery, RegistrySummaryQueryVariables>) {
        return ApolloReactHooks.useQuery<RegistrySummaryQuery, RegistrySummaryQueryVariables>(RegistrySummaryQueryDocument, baseOptions);
      }
export function useRegistrySummaryQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistrySummaryQuery, RegistrySummaryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RegistrySummaryQuery, RegistrySummaryQueryVariables>(RegistrySummaryQueryDocument, baseOptions);
        }
export type RegistrySummaryQueryHookResult = ReturnType<typeof useRegistrySummaryQuery>;
export type RegistrySummaryQueryLazyQueryHookResult = ReturnType<typeof useRegistrySummaryQueryLazyQuery>;
export type RegistrySummaryQueryQueryResult = ApolloReactCommon.QueryResult<RegistrySummaryQuery, RegistrySummaryQueryVariables>;
export const EventRsvpDataQueryDocument = gql`
    query EventRsvpDataQuery {
  eventRsvpData {
    eventId
    guestCount
    acceptCount
    rejectCount
  }
}
    `;

/**
 * __useEventRsvpDataQuery__
 *
 * To run a query within a React component, call `useEventRsvpDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventRsvpDataQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventRsvpDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventRsvpDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventRsvpDataQuery, EventRsvpDataQueryVariables>) {
        return ApolloReactHooks.useQuery<EventRsvpDataQuery, EventRsvpDataQueryVariables>(EventRsvpDataQueryDocument, baseOptions);
      }
export function useEventRsvpDataQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventRsvpDataQuery, EventRsvpDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventRsvpDataQuery, EventRsvpDataQueryVariables>(EventRsvpDataQueryDocument, baseOptions);
        }
export type EventRsvpDataQueryHookResult = ReturnType<typeof useEventRsvpDataQuery>;
export type EventRsvpDataQueryLazyQueryHookResult = ReturnType<typeof useEventRsvpDataQueryLazyQuery>;
export type EventRsvpDataQueryQueryResult = ApolloReactCommon.QueryResult<EventRsvpDataQuery, EventRsvpDataQueryVariables>;
export const UpdateRsvpPageHiddenMutationDocument = gql`
    mutation UpdateRsvpPageHiddenMutation($guestWeddingInput: GDS_UpdateGuestWeddingInput!) {
  updateGuestWedding(input: $guestWeddingInput) {
    rsvpPageHidden
  }
}
    `;
export type UpdateRsvpPageHiddenMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateRsvpPageHiddenMutation, UpdateRsvpPageHiddenMutationVariables>;

/**
 * __useUpdateRsvpPageHiddenMutation__
 *
 * To run a mutation, you first call `useUpdateRsvpPageHiddenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRsvpPageHiddenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRsvpPageHiddenMutation, { data, loading, error }] = useUpdateRsvpPageHiddenMutation({
 *   variables: {
 *      guestWeddingInput: // value for 'guestWeddingInput'
 *   },
 * });
 */
export function useUpdateRsvpPageHiddenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRsvpPageHiddenMutation, UpdateRsvpPageHiddenMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateRsvpPageHiddenMutation, UpdateRsvpPageHiddenMutationVariables>(UpdateRsvpPageHiddenMutationDocument, baseOptions);
      }
export type UpdateRsvpPageHiddenMutationHookResult = ReturnType<typeof useUpdateRsvpPageHiddenMutation>;
export type UpdateRsvpPageHiddenMutationMutationResult = ApolloReactCommon.MutationResult<UpdateRsvpPageHiddenMutation>;
export type UpdateRsvpPageHiddenMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRsvpPageHiddenMutation, UpdateRsvpPageHiddenMutationVariables>;
export const EventQuestionResponseQueryDocument = gql`
    query eventQuestionResponseQuery {
  eventQuestionResponseData {
    eventId
    questionsData {
      text
      type
      questionId
      answerType
      optionCount
      answersData {
        optionId
        text
        responseCount
        responses {
          personId
          firstName
          lastName
        }
      }
    }
  }
}
    `;

/**
 * __useEventQuestionResponseQuery__
 *
 * To run a query within a React component, call `useEventQuestionResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventQuestionResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventQuestionResponseQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventQuestionResponseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventQuestionResponseQuery, EventQuestionResponseQueryVariables>) {
        return ApolloReactHooks.useQuery<EventQuestionResponseQuery, EventQuestionResponseQueryVariables>(EventQuestionResponseQueryDocument, baseOptions);
      }
export function useEventQuestionResponseQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventQuestionResponseQuery, EventQuestionResponseQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventQuestionResponseQuery, EventQuestionResponseQueryVariables>(EventQuestionResponseQueryDocument, baseOptions);
        }
export type EventQuestionResponseQueryHookResult = ReturnType<typeof useEventQuestionResponseQuery>;
export type EventQuestionResponseQueryLazyQueryHookResult = ReturnType<typeof useEventQuestionResponseQueryLazyQuery>;
export type EventQuestionResponseQueryQueryResult = ApolloReactCommon.QueryResult<EventQuestionResponseQuery, EventQuestionResponseQueryVariables>;
export const GuestWeddingQuestionResponseQueryDocument = gql`
    query guestWeddingQuestionResponseQuery {
  guestWeddingQuestionResponseData {
    guestWeddingId
    questionsData {
      type
      text
      questionId
      answerType
      optionCount
      answersData {
        optionId
        text
        responseCount
        responses {
          personId
          firstName
          lastName
        }
      }
    }
  }
}
    `;

/**
 * __useGuestWeddingQuestionResponseQuery__
 *
 * To run a query within a React component, call `useGuestWeddingQuestionResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestWeddingQuestionResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestWeddingQuestionResponseQuery({
 *   variables: {
 *   },
 * });
 */
export function useGuestWeddingQuestionResponseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GuestWeddingQuestionResponseQuery, GuestWeddingQuestionResponseQueryVariables>) {
        return ApolloReactHooks.useQuery<GuestWeddingQuestionResponseQuery, GuestWeddingQuestionResponseQueryVariables>(GuestWeddingQuestionResponseQueryDocument, baseOptions);
      }
export function useGuestWeddingQuestionResponseQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestWeddingQuestionResponseQuery, GuestWeddingQuestionResponseQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GuestWeddingQuestionResponseQuery, GuestWeddingQuestionResponseQueryVariables>(GuestWeddingQuestionResponseQueryDocument, baseOptions);
        }
export type GuestWeddingQuestionResponseQueryHookResult = ReturnType<typeof useGuestWeddingQuestionResponseQuery>;
export type GuestWeddingQuestionResponseQueryLazyQueryHookResult = ReturnType<typeof useGuestWeddingQuestionResponseQueryLazyQuery>;
export type GuestWeddingQuestionResponseQueryQueryResult = ApolloReactCommon.QueryResult<GuestWeddingQuestionResponseQuery, GuestWeddingQuestionResponseQueryVariables>;
export const PasswordMutationDocument = gql`
    mutation passwordMutation($attributes: WWS_WeddingWebsiteAttributes!) {
  updateWeddingWebsite(attributes: $attributes) {
    id
    pin
    pinProtect
  }
}
    `;
export type PasswordMutationMutationFn = ApolloReactCommon.MutationFunction<PasswordMutation, PasswordMutationVariables>;

/**
 * __usePasswordMutation__
 *
 * To run a mutation, you first call `usePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordMutation, { data, loading, error }] = usePasswordMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function usePasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PasswordMutation, PasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<PasswordMutation, PasswordMutationVariables>(PasswordMutationDocument, baseOptions);
      }
export type PasswordMutationHookResult = ReturnType<typeof usePasswordMutation>;
export type PasswordMutationMutationResult = ApolloReactCommon.MutationResult<PasswordMutation>;
export type PasswordMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<PasswordMutation, PasswordMutationVariables>;
export const UrlMutationDocument = gql`
    mutation urlMutation($attributes: WWS_WeddingWebsiteAttributes!) {
  updateWeddingWebsite(attributes: $attributes) {
    id
    vanityUrl
  }
}
    `;
export type UrlMutationMutationFn = ApolloReactCommon.MutationFunction<UrlMutation, UrlMutationVariables>;

/**
 * __useUrlMutation__
 *
 * To run a mutation, you first call `useUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [urlMutation, { data, loading, error }] = useUrlMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UrlMutation, UrlMutationVariables>) {
        return ApolloReactHooks.useMutation<UrlMutation, UrlMutationVariables>(UrlMutationDocument, baseOptions);
      }
export type UrlMutationHookResult = ReturnType<typeof useUrlMutation>;
export type UrlMutationMutationResult = ApolloReactCommon.MutationResult<UrlMutation>;
export type UrlMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UrlMutation, UrlMutationVariables>;
export const DeactivateWebsiteMutationDocument = gql`
    mutation deactivateWebsiteMutation {
  disableWeddingWebsite {
    id
    state
    websiteDisabledAt
  }
}
    `;
export type DeactivateWebsiteMutationMutationFn = ApolloReactCommon.MutationFunction<DeactivateWebsiteMutation, DeactivateWebsiteMutationVariables>;

/**
 * __useDeactivateWebsiteMutation__
 *
 * To run a mutation, you first call `useDeactivateWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateWebsiteMutation, { data, loading, error }] = useDeactivateWebsiteMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeactivateWebsiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeactivateWebsiteMutation, DeactivateWebsiteMutationVariables>) {
        return ApolloReactHooks.useMutation<DeactivateWebsiteMutation, DeactivateWebsiteMutationVariables>(DeactivateWebsiteMutationDocument, baseOptions);
      }
export type DeactivateWebsiteMutationHookResult = ReturnType<typeof useDeactivateWebsiteMutation>;
export type DeactivateWebsiteMutationMutationResult = ApolloReactCommon.MutationResult<DeactivateWebsiteMutation>;
export type DeactivateWebsiteMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeactivateWebsiteMutation, DeactivateWebsiteMutationVariables>;
export const CreateHouseholdsMutationDocument = gql`
    mutation createHouseholdsMutation($input: [GDS_CreateHouseholdInput!]!) {
  createHouseholds(input: $input) {
    id
    description
    rsvpNote
    coupleNote
    people {
      ...People
    }
    address {
      ...GDSAddress
    }
    answers {
      ...GDSAnswer
    }
  }
}
    ${PeopleFragmentDoc}
${GdsAddressFragmentDoc}
${GdsAnswerFragmentDoc}`;
export type CreateHouseholdsMutationMutationFn = ApolloReactCommon.MutationFunction<CreateHouseholdsMutation, CreateHouseholdsMutationVariables>;

/**
 * __useCreateHouseholdsMutation__
 *
 * To run a mutation, you first call `useCreateHouseholdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHouseholdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHouseholdsMutation, { data, loading, error }] = useCreateHouseholdsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHouseholdsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateHouseholdsMutation, CreateHouseholdsMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateHouseholdsMutation, CreateHouseholdsMutationVariables>(CreateHouseholdsMutationDocument, baseOptions);
      }
export type CreateHouseholdsMutationHookResult = ReturnType<typeof useCreateHouseholdsMutation>;
export type CreateHouseholdsMutationMutationResult = ApolloReactCommon.MutationResult<CreateHouseholdsMutation>;
export type CreateHouseholdsMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateHouseholdsMutation, CreateHouseholdsMutationVariables>;
export const SendSaveTheDateEmailMutationDocument = gql`
    mutation sendSaveTheDateEmailMutation($args: SaveTheDateArgs!) {
  sendSaveTheDateEmail(args: $args)
}
    `;
export type SendSaveTheDateEmailMutationMutationFn = ApolloReactCommon.MutationFunction<SendSaveTheDateEmailMutation, SendSaveTheDateEmailMutationVariables>;

/**
 * __useSendSaveTheDateEmailMutation__
 *
 * To run a mutation, you first call `useSendSaveTheDateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSaveTheDateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSaveTheDateEmailMutation, { data, loading, error }] = useSendSaveTheDateEmailMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSendSaveTheDateEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendSaveTheDateEmailMutation, SendSaveTheDateEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendSaveTheDateEmailMutation, SendSaveTheDateEmailMutationVariables>(SendSaveTheDateEmailMutationDocument, baseOptions);
      }
export type SendSaveTheDateEmailMutationHookResult = ReturnType<typeof useSendSaveTheDateEmailMutation>;
export type SendSaveTheDateEmailMutationMutationResult = ApolloReactCommon.MutationResult<SendSaveTheDateEmailMutation>;
export type SendSaveTheDateEmailMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendSaveTheDateEmailMutation, SendSaveTheDateEmailMutationVariables>;
export const SendShareWebsiteEmailMutationDocument = gql`
    mutation sendShareWebsiteEmailMutation($args: ShareWebsiteArgs!) {
  sendShareWebsiteEmail(args: $args)
}
    `;
export type SendShareWebsiteEmailMutationMutationFn = ApolloReactCommon.MutationFunction<SendShareWebsiteEmailMutation, SendShareWebsiteEmailMutationVariables>;

/**
 * __useSendShareWebsiteEmailMutation__
 *
 * To run a mutation, you first call `useSendShareWebsiteEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendShareWebsiteEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendShareWebsiteEmailMutation, { data, loading, error }] = useSendShareWebsiteEmailMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSendShareWebsiteEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendShareWebsiteEmailMutation, SendShareWebsiteEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendShareWebsiteEmailMutation, SendShareWebsiteEmailMutationVariables>(SendShareWebsiteEmailMutationDocument, baseOptions);
      }
export type SendShareWebsiteEmailMutationHookResult = ReturnType<typeof useSendShareWebsiteEmailMutation>;
export type SendShareWebsiteEmailMutationMutationResult = ApolloReactCommon.MutationResult<SendShareWebsiteEmailMutation>;
export type SendShareWebsiteEmailMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendShareWebsiteEmailMutation, SendShareWebsiteEmailMutationVariables>;
export const SendShareWebsiteSmsMutationDocument = gql`
    mutation sendShareWebsiteSmsMutation($args: SmsArgs!) {
  sendShareWebsiteSms(args: $args)
}
    `;
export type SendShareWebsiteSmsMutationMutationFn = ApolloReactCommon.MutationFunction<SendShareWebsiteSmsMutation, SendShareWebsiteSmsMutationVariables>;

/**
 * __useSendShareWebsiteSmsMutation__
 *
 * To run a mutation, you first call `useSendShareWebsiteSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendShareWebsiteSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendShareWebsiteSmsMutation, { data, loading, error }] = useSendShareWebsiteSmsMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSendShareWebsiteSmsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendShareWebsiteSmsMutation, SendShareWebsiteSmsMutationVariables>) {
        return ApolloReactHooks.useMutation<SendShareWebsiteSmsMutation, SendShareWebsiteSmsMutationVariables>(SendShareWebsiteSmsMutationDocument, baseOptions);
      }
export type SendShareWebsiteSmsMutationHookResult = ReturnType<typeof useSendShareWebsiteSmsMutation>;
export type SendShareWebsiteSmsMutationMutationResult = ApolloReactCommon.MutationResult<SendShareWebsiteSmsMutation>;
export type SendShareWebsiteSmsMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendShareWebsiteSmsMutation, SendShareWebsiteSmsMutationVariables>;
export const SendUpdatesEmailMutationDocument = gql`
    mutation sendUpdatesEmailMutation($args: SendUpdatesEmailArgs!) {
  sendUpdatesEmail(args: $args)
}
    `;
export type SendUpdatesEmailMutationMutationFn = ApolloReactCommon.MutationFunction<SendUpdatesEmailMutation, SendUpdatesEmailMutationVariables>;

/**
 * __useSendUpdatesEmailMutation__
 *
 * To run a mutation, you first call `useSendUpdatesEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendUpdatesEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendUpdatesEmailMutation, { data, loading, error }] = useSendUpdatesEmailMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSendUpdatesEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendUpdatesEmailMutation, SendUpdatesEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendUpdatesEmailMutation, SendUpdatesEmailMutationVariables>(SendUpdatesEmailMutationDocument, baseOptions);
      }
export type SendUpdatesEmailMutationHookResult = ReturnType<typeof useSendUpdatesEmailMutation>;
export type SendUpdatesEmailMutationMutationResult = ApolloReactCommon.MutationResult<SendUpdatesEmailMutation>;
export type SendUpdatesEmailMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendUpdatesEmailMutation, SendUpdatesEmailMutationVariables>;
export const SendShareDayOfDetailsSmsMutationDocument = gql`
    mutation sendShareDayOfDetailsSmsMutation($args: SmsArgs!) {
  sendShareDayOfDetailsSms(args: $args)
}
    `;
export type SendShareDayOfDetailsSmsMutationMutationFn = ApolloReactCommon.MutationFunction<SendShareDayOfDetailsSmsMutation, SendShareDayOfDetailsSmsMutationVariables>;

/**
 * __useSendShareDayOfDetailsSmsMutation__
 *
 * To run a mutation, you first call `useSendShareDayOfDetailsSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendShareDayOfDetailsSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendShareDayOfDetailsSmsMutation, { data, loading, error }] = useSendShareDayOfDetailsSmsMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSendShareDayOfDetailsSmsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendShareDayOfDetailsSmsMutation, SendShareDayOfDetailsSmsMutationVariables>) {
        return ApolloReactHooks.useMutation<SendShareDayOfDetailsSmsMutation, SendShareDayOfDetailsSmsMutationVariables>(SendShareDayOfDetailsSmsMutationDocument, baseOptions);
      }
export type SendShareDayOfDetailsSmsMutationHookResult = ReturnType<typeof useSendShareDayOfDetailsSmsMutation>;
export type SendShareDayOfDetailsSmsMutationMutationResult = ApolloReactCommon.MutationResult<SendShareDayOfDetailsSmsMutation>;
export type SendShareDayOfDetailsSmsMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendShareDayOfDetailsSmsMutation, SendShareDayOfDetailsSmsMutationVariables>;
export const SendShareDayOfDetailsEmailMutationDocument = gql`
    mutation sendShareDayOfDetailsEmailMutation($args: ShareDayOfDetailsEmailArgs!) {
  sendShareDayOfDetailsEmail(args: $args)
}
    `;
export type SendShareDayOfDetailsEmailMutationMutationFn = ApolloReactCommon.MutationFunction<SendShareDayOfDetailsEmailMutation, SendShareDayOfDetailsEmailMutationVariables>;

/**
 * __useSendShareDayOfDetailsEmailMutation__
 *
 * To run a mutation, you first call `useSendShareDayOfDetailsEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendShareDayOfDetailsEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendShareDayOfDetailsEmailMutation, { data, loading, error }] = useSendShareDayOfDetailsEmailMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSendShareDayOfDetailsEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendShareDayOfDetailsEmailMutation, SendShareDayOfDetailsEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendShareDayOfDetailsEmailMutation, SendShareDayOfDetailsEmailMutationVariables>(SendShareDayOfDetailsEmailMutationDocument, baseOptions);
      }
export type SendShareDayOfDetailsEmailMutationHookResult = ReturnType<typeof useSendShareDayOfDetailsEmailMutation>;
export type SendShareDayOfDetailsEmailMutationMutationResult = ApolloReactCommon.MutationResult<SendShareDayOfDetailsEmailMutation>;
export type SendShareDayOfDetailsEmailMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendShareDayOfDetailsEmailMutation, SendShareDayOfDetailsEmailMutationVariables>;
export const SendUpdatesSmsMutationDocument = gql`
    mutation sendUpdatesSmsMutation($args: SmsArgs!) {
  sendUpdatesSms(args: $args)
}
    `;
export type SendUpdatesSmsMutationMutationFn = ApolloReactCommon.MutationFunction<SendUpdatesSmsMutation, SendUpdatesSmsMutationVariables>;

/**
 * __useSendUpdatesSmsMutation__
 *
 * To run a mutation, you first call `useSendUpdatesSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendUpdatesSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendUpdatesSmsMutation, { data, loading, error }] = useSendUpdatesSmsMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSendUpdatesSmsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendUpdatesSmsMutation, SendUpdatesSmsMutationVariables>) {
        return ApolloReactHooks.useMutation<SendUpdatesSmsMutation, SendUpdatesSmsMutationVariables>(SendUpdatesSmsMutationDocument, baseOptions);
      }
export type SendUpdatesSmsMutationHookResult = ReturnType<typeof useSendUpdatesSmsMutation>;
export type SendUpdatesSmsMutationMutationResult = ApolloReactCommon.MutationResult<SendUpdatesSmsMutation>;
export type SendUpdatesSmsMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendUpdatesSmsMutation, SendUpdatesSmsMutationVariables>;
export const SendLocalHotelEmailMutationDocument = gql`
    mutation sendLocalHotelEmailMutation($args: LinkEmailArgs!) {
  sendLocalHotelEmail(args: $args)
}
    `;
export type SendLocalHotelEmailMutationMutationFn = ApolloReactCommon.MutationFunction<SendLocalHotelEmailMutation, SendLocalHotelEmailMutationVariables>;

/**
 * __useSendLocalHotelEmailMutation__
 *
 * To run a mutation, you first call `useSendLocalHotelEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendLocalHotelEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendLocalHotelEmailMutation, { data, loading, error }] = useSendLocalHotelEmailMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSendLocalHotelEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendLocalHotelEmailMutation, SendLocalHotelEmailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendLocalHotelEmailMutation, SendLocalHotelEmailMutationVariables>(SendLocalHotelEmailMutationDocument, baseOptions);
      }
export type SendLocalHotelEmailMutationHookResult = ReturnType<typeof useSendLocalHotelEmailMutation>;
export type SendLocalHotelEmailMutationMutationResult = ApolloReactCommon.MutationResult<SendLocalHotelEmailMutation>;
export type SendLocalHotelEmailMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendLocalHotelEmailMutation, SendLocalHotelEmailMutationVariables>;
export const SendLocalHotelSmsMutationDocument = gql`
    mutation sendLocalHotelSmsMutation($args: SmsArgs!) {
  sendLocalHotelSms(args: $args)
}
    `;
export type SendLocalHotelSmsMutationMutationFn = ApolloReactCommon.MutationFunction<SendLocalHotelSmsMutation, SendLocalHotelSmsMutationVariables>;

/**
 * __useSendLocalHotelSmsMutation__
 *
 * To run a mutation, you first call `useSendLocalHotelSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendLocalHotelSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendLocalHotelSmsMutation, { data, loading, error }] = useSendLocalHotelSmsMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSendLocalHotelSmsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendLocalHotelSmsMutation, SendLocalHotelSmsMutationVariables>) {
        return ApolloReactHooks.useMutation<SendLocalHotelSmsMutation, SendLocalHotelSmsMutationVariables>(SendLocalHotelSmsMutationDocument, baseOptions);
      }
export type SendLocalHotelSmsMutationHookResult = ReturnType<typeof useSendLocalHotelSmsMutation>;
export type SendLocalHotelSmsMutationMutationResult = ApolloReactCommon.MutationResult<SendLocalHotelSmsMutation>;
export type SendLocalHotelSmsMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendLocalHotelSmsMutation, SendLocalHotelSmsMutationVariables>;
export const MessagingSequenceQueryDocument = gql`
    query messagingSequenceQuery($id: String!) {
  messagingSequence(id: $id) {
    displayName
    id
    defaultEmailSubject
    defaultEmailBody
    defaultLinkText
    defaultSmsBody
    type
  }
}
    `;

/**
 * __useMessagingSequenceQuery__
 *
 * To run a query within a React component, call `useMessagingSequenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagingSequenceQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagingSequenceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessagingSequenceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MessagingSequenceQuery, MessagingSequenceQueryVariables>) {
        return ApolloReactHooks.useQuery<MessagingSequenceQuery, MessagingSequenceQueryVariables>(MessagingSequenceQueryDocument, baseOptions);
      }
export function useMessagingSequenceQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MessagingSequenceQuery, MessagingSequenceQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MessagingSequenceQuery, MessagingSequenceQueryVariables>(MessagingSequenceQueryDocument, baseOptions);
        }
export type MessagingSequenceQueryHookResult = ReturnType<typeof useMessagingSequenceQuery>;
export type MessagingSequenceQueryLazyQueryHookResult = ReturnType<typeof useMessagingSequenceQueryLazyQuery>;
export type MessagingSequenceQueryQueryResult = ApolloReactCommon.QueryResult<MessagingSequenceQuery, MessagingSequenceQueryVariables>;
export const SelectedThemeQueryDocument = gql`
    query selectedThemeQuery {
  theme {
    id
    previewImage {
      mediaApiId
    }
    name
    designerUrl
    family
    themeDesigner {
      name
      companyName
    }
    stationaryPreviewImage {
      mediaApiId
    }
  }
}
    `;

/**
 * __useSelectedThemeQuery__
 *
 * To run a query within a React component, call `useSelectedThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedThemeQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectedThemeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SelectedThemeQuery, SelectedThemeQueryVariables>) {
        return ApolloReactHooks.useQuery<SelectedThemeQuery, SelectedThemeQueryVariables>(SelectedThemeQueryDocument, baseOptions);
      }
export function useSelectedThemeQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectedThemeQuery, SelectedThemeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SelectedThemeQuery, SelectedThemeQueryVariables>(SelectedThemeQueryDocument, baseOptions);
        }
export type SelectedThemeQueryHookResult = ReturnType<typeof useSelectedThemeQuery>;
export type SelectedThemeQueryLazyQueryHookResult = ReturnType<typeof useSelectedThemeQueryLazyQuery>;
export type SelectedThemeQueryQueryResult = ApolloReactCommon.QueryResult<SelectedThemeQuery, SelectedThemeQueryVariables>;
export const SelectedThemeMutationDocument = gql`
    mutation selectedThemeMutation($id: Int!) {
  updateSelectedTheme(id: $id) {
    id
    previewImage {
      mediaApiId
    }
    name
    designerUrl
    family
    themeDesigner {
      name
      companyName
    }
    stationaryPreviewImage {
      mediaApiId
    }
  }
}
    `;
export type SelectedThemeMutationMutationFn = ApolloReactCommon.MutationFunction<SelectedThemeMutation, SelectedThemeMutationVariables>;

/**
 * __useSelectedThemeMutation__
 *
 * To run a mutation, you first call `useSelectedThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectedThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectedThemeMutation, { data, loading, error }] = useSelectedThemeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSelectedThemeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SelectedThemeMutation, SelectedThemeMutationVariables>) {
        return ApolloReactHooks.useMutation<SelectedThemeMutation, SelectedThemeMutationVariables>(SelectedThemeMutationDocument, baseOptions);
      }
export type SelectedThemeMutationHookResult = ReturnType<typeof useSelectedThemeMutation>;
export type SelectedThemeMutationMutationResult = ApolloReactCommon.MutationResult<SelectedThemeMutation>;
export type SelectedThemeMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SelectedThemeMutation, SelectedThemeMutationVariables>;
export const CreateCoverPhotoOnWebsiteMutationDocument = gql`
    mutation createCoverPhotoOnWebsiteMutation($attributes: WWS_PhotoAttributes!) {
  createCoverPhotoOnWebsite(attributes: $attributes) {
    id
    coverPhoto {
      mediaApiId
      mediaUrl
      cropX
      cropY
      width
      height
      originalMediaUrl
    }
  }
}
    `;
export type CreateCoverPhotoOnWebsiteMutationMutationFn = ApolloReactCommon.MutationFunction<CreateCoverPhotoOnWebsiteMutation, CreateCoverPhotoOnWebsiteMutationVariables>;

/**
 * __useCreateCoverPhotoOnWebsiteMutation__
 *
 * To run a mutation, you first call `useCreateCoverPhotoOnWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoverPhotoOnWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoverPhotoOnWebsiteMutation, { data, loading, error }] = useCreateCoverPhotoOnWebsiteMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateCoverPhotoOnWebsiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCoverPhotoOnWebsiteMutation, CreateCoverPhotoOnWebsiteMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCoverPhotoOnWebsiteMutation, CreateCoverPhotoOnWebsiteMutationVariables>(CreateCoverPhotoOnWebsiteMutationDocument, baseOptions);
      }
export type CreateCoverPhotoOnWebsiteMutationHookResult = ReturnType<typeof useCreateCoverPhotoOnWebsiteMutation>;
export type CreateCoverPhotoOnWebsiteMutationMutationResult = ApolloReactCommon.MutationResult<CreateCoverPhotoOnWebsiteMutation>;
export type CreateCoverPhotoOnWebsiteMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCoverPhotoOnWebsiteMutation, CreateCoverPhotoOnWebsiteMutationVariables>;
export const DeleteCoverPhotoOnWebsiteMutationDocument = gql`
    mutation deleteCoverPhotoOnWebsiteMutation {
  deleteCoverPhotoOnWebsite {
    id
    coverPhoto {
      mediaApiId
      mediaUrl
      cropX
      cropY
      width
      height
      originalMediaUrl
    }
  }
}
    `;
export type DeleteCoverPhotoOnWebsiteMutationMutationFn = ApolloReactCommon.MutationFunction<DeleteCoverPhotoOnWebsiteMutation, DeleteCoverPhotoOnWebsiteMutationVariables>;

/**
 * __useDeleteCoverPhotoOnWebsiteMutation__
 *
 * To run a mutation, you first call `useDeleteCoverPhotoOnWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoverPhotoOnWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoverPhotoOnWebsiteMutation, { data, loading, error }] = useDeleteCoverPhotoOnWebsiteMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteCoverPhotoOnWebsiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCoverPhotoOnWebsiteMutation, DeleteCoverPhotoOnWebsiteMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteCoverPhotoOnWebsiteMutation, DeleteCoverPhotoOnWebsiteMutationVariables>(DeleteCoverPhotoOnWebsiteMutationDocument, baseOptions);
      }
export type DeleteCoverPhotoOnWebsiteMutationHookResult = ReturnType<typeof useDeleteCoverPhotoOnWebsiteMutation>;
export type DeleteCoverPhotoOnWebsiteMutationMutationResult = ApolloReactCommon.MutationResult<DeleteCoverPhotoOnWebsiteMutation>;
export type DeleteCoverPhotoOnWebsiteMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCoverPhotoOnWebsiteMutation, DeleteCoverPhotoOnWebsiteMutationVariables>;
export const HouseholdQueryDocument = gql`
    query householdQuery {
  households {
    id
    description
    rsvpNote
    coupleNote
    people {
      ...People
    }
    address {
      ...GDSAddress
    }
    answers {
      ...GDSAnswer
    }
  }
}
    ${PeopleFragmentDoc}
${GdsAddressFragmentDoc}
${GdsAnswerFragmentDoc}`;

/**
 * __useHouseholdQuery__
 *
 * To run a query within a React component, call `useHouseholdQuery` and pass it any options that fit your needs.
 * When your component renders, `useHouseholdQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHouseholdQuery({
 *   variables: {
 *   },
 * });
 */
export function useHouseholdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HouseholdQuery, HouseholdQueryVariables>) {
        return ApolloReactHooks.useQuery<HouseholdQuery, HouseholdQueryVariables>(HouseholdQueryDocument, baseOptions);
      }
export function useHouseholdQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HouseholdQuery, HouseholdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<HouseholdQuery, HouseholdQueryVariables>(HouseholdQueryDocument, baseOptions);
        }
export type HouseholdQueryHookResult = ReturnType<typeof useHouseholdQuery>;
export type HouseholdQueryLazyQueryHookResult = ReturnType<typeof useHouseholdQueryLazyQuery>;
export type HouseholdQueryQueryResult = ApolloReactCommon.QueryResult<HouseholdQuery, HouseholdQueryVariables>;
export const EventsQueryDocument = gql`
    query eventsQuery {
  events {
    id
    weddingId
    attire
    requireRsvp
    notes
    name
    type
    date
    time
    endTime
    visible
    createdAt
    location {
      ...Locations
    }
    questions {
      ...Questions
    }
    subEvents {
      id
      name
      time
      endTime
      type
      attire
      notes
      visible
      location {
        ...Locations
      }
    }
  }
}
    ${LocationsFragmentDoc}
${QuestionsFragmentDoc}`;

/**
 * __useEventsQuery__
 *
 * To run a query within a React component, call `useEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventsQuery, EventsQueryVariables>) {
        return ApolloReactHooks.useQuery<EventsQuery, EventsQueryVariables>(EventsQueryDocument, baseOptions);
      }
export function useEventsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventsQuery, EventsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EventsQuery, EventsQueryVariables>(EventsQueryDocument, baseOptions);
        }
export type EventsQueryHookResult = ReturnType<typeof useEventsQuery>;
export type EventsQueryLazyQueryHookResult = ReturnType<typeof useEventsQueryLazyQuery>;
export type EventsQueryQueryResult = ApolloReactCommon.QueryResult<EventsQuery, EventsQueryVariables>;
export const WeddingDateComponentWeddingDatePreferencesDocument = gql`
    query weddingDateComponentWeddingDatePreferences {
  weddingDatePreferences {
    datePreference
    hideDate
    season
    year
    weddingDate
    weddingDateFormat
    weddingDateRangeStart
    weddingDateRangeEnd
    hideCountdown
  }
}
    `;

/**
 * __useWeddingDateComponentWeddingDatePreferencesQuery__
 *
 * To run a query within a React component, call `useWeddingDateComponentWeddingDatePreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeddingDateComponentWeddingDatePreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeddingDateComponentWeddingDatePreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useWeddingDateComponentWeddingDatePreferencesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WeddingDateComponentWeddingDatePreferencesQuery, WeddingDateComponentWeddingDatePreferencesQueryVariables>) {
        return ApolloReactHooks.useQuery<WeddingDateComponentWeddingDatePreferencesQuery, WeddingDateComponentWeddingDatePreferencesQueryVariables>(WeddingDateComponentWeddingDatePreferencesDocument, baseOptions);
      }
export function useWeddingDateComponentWeddingDatePreferencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WeddingDateComponentWeddingDatePreferencesQuery, WeddingDateComponentWeddingDatePreferencesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<WeddingDateComponentWeddingDatePreferencesQuery, WeddingDateComponentWeddingDatePreferencesQueryVariables>(WeddingDateComponentWeddingDatePreferencesDocument, baseOptions);
        }
export type WeddingDateComponentWeddingDatePreferencesQueryHookResult = ReturnType<typeof useWeddingDateComponentWeddingDatePreferencesQuery>;
export type WeddingDateComponentWeddingDatePreferencesLazyQueryHookResult = ReturnType<typeof useWeddingDateComponentWeddingDatePreferencesLazyQuery>;
export type WeddingDateComponentWeddingDatePreferencesQueryResult = ApolloReactCommon.QueryResult<WeddingDateComponentWeddingDatePreferencesQuery, WeddingDateComponentWeddingDatePreferencesQueryVariables>;
export const WeddingDateComponentEventsQueryDocument = gql`
    query weddingDateComponentEventsQuery {
  events {
    id
    weddingId
    name
    type
    date
    time
    endTime
  }
}
    `;

/**
 * __useWeddingDateComponentEventsQuery__
 *
 * To run a query within a React component, call `useWeddingDateComponentEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeddingDateComponentEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeddingDateComponentEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWeddingDateComponentEventsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WeddingDateComponentEventsQuery, WeddingDateComponentEventsQueryVariables>) {
        return ApolloReactHooks.useQuery<WeddingDateComponentEventsQuery, WeddingDateComponentEventsQueryVariables>(WeddingDateComponentEventsQueryDocument, baseOptions);
      }
export function useWeddingDateComponentEventsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WeddingDateComponentEventsQuery, WeddingDateComponentEventsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<WeddingDateComponentEventsQuery, WeddingDateComponentEventsQueryVariables>(WeddingDateComponentEventsQueryDocument, baseOptions);
        }
export type WeddingDateComponentEventsQueryHookResult = ReturnType<typeof useWeddingDateComponentEventsQuery>;
export type WeddingDateComponentEventsQueryLazyQueryHookResult = ReturnType<typeof useWeddingDateComponentEventsQueryLazyQuery>;
export type WeddingDateComponentEventsQueryQueryResult = ApolloReactCommon.QueryResult<WeddingDateComponentEventsQuery, WeddingDateComponentEventsQueryVariables>;
export const UnleashFeatureToggleDocument = gql`
    query UnleashFeatureToggle {
  unleashFeatureToggles {
    name
    enabled
  }
}
    `;

/**
 * __useUnleashFeatureToggleQuery__
 *
 * To run a query within a React component, call `useUnleashFeatureToggleQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnleashFeatureToggleQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnleashFeatureToggleQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnleashFeatureToggleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UnleashFeatureToggleQuery, UnleashFeatureToggleQueryVariables>) {
        return ApolloReactHooks.useQuery<UnleashFeatureToggleQuery, UnleashFeatureToggleQueryVariables>(UnleashFeatureToggleDocument, baseOptions);
      }
export function useUnleashFeatureToggleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnleashFeatureToggleQuery, UnleashFeatureToggleQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<UnleashFeatureToggleQuery, UnleashFeatureToggleQueryVariables>(UnleashFeatureToggleDocument, baseOptions);
        }
export type UnleashFeatureToggleQueryHookResult = ReturnType<typeof useUnleashFeatureToggleQuery>;
export type UnleashFeatureToggleLazyQueryHookResult = ReturnType<typeof useUnleashFeatureToggleLazyQuery>;
export type UnleashFeatureToggleQueryResult = ApolloReactCommon.QueryResult<UnleashFeatureToggleQuery, UnleashFeatureToggleQueryVariables>;
export const VisibilityMutationDocument = gql`
    mutation visibilityMutation($attributes: WWS_WeddingWebsiteAttributes!) {
  updateWeddingWebsite(attributes: $attributes) {
    id
    searchable
  }
}
    `;
export type VisibilityMutationMutationFn = ApolloReactCommon.MutationFunction<VisibilityMutation, VisibilityMutationVariables>;

/**
 * __useVisibilityMutation__
 *
 * To run a mutation, you first call `useVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [visibilityMutation, { data, loading, error }] = useVisibilityMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useVisibilityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VisibilityMutation, VisibilityMutationVariables>) {
        return ApolloReactHooks.useMutation<VisibilityMutation, VisibilityMutationVariables>(VisibilityMutationDocument, baseOptions);
      }
export type VisibilityMutationHookResult = ReturnType<typeof useVisibilityMutation>;
export type VisibilityMutationMutationResult = ApolloReactCommon.MutationResult<VisibilityMutation>;
export type VisibilityMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<VisibilityMutation, VisibilityMutationVariables>;
export const GetAttireCategoriesDocument = gql`
    query GetAttireCategories {
  attireCategories {
    id
    label
    description
  }
}
    `;

/**
 * __useGetAttireCategoriesQuery__
 *
 * To run a query within a React component, call `useGetAttireCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttireCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttireCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAttireCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAttireCategoriesQuery, GetAttireCategoriesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAttireCategoriesQuery, GetAttireCategoriesQueryVariables>(GetAttireCategoriesDocument, baseOptions);
      }
export function useGetAttireCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAttireCategoriesQuery, GetAttireCategoriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAttireCategoriesQuery, GetAttireCategoriesQueryVariables>(GetAttireCategoriesDocument, baseOptions);
        }
export type GetAttireCategoriesQueryHookResult = ReturnType<typeof useGetAttireCategoriesQuery>;
export type GetAttireCategoriesLazyQueryHookResult = ReturnType<typeof useGetAttireCategoriesLazyQuery>;
export type GetAttireCategoriesQueryResult = ApolloReactCommon.QueryResult<GetAttireCategoriesQuery, GetAttireCategoriesQueryVariables>;
export const DeletePageItemDocument = gql`
    mutation deletePageItem($attributes: WWS_DeletePageItemAttributes!) {
  deletePageItem(attributes: $attributes)
}
    `;
export type DeletePageItemMutationFn = ApolloReactCommon.MutationFunction<DeletePageItemMutation, DeletePageItemMutationVariables>;

/**
 * __useDeletePageItemMutation__
 *
 * To run a mutation, you first call `useDeletePageItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePageItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePageItemMutation, { data, loading, error }] = useDeletePageItemMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useDeletePageItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePageItemMutation, DeletePageItemMutationVariables>) {
        return ApolloReactHooks.useMutation<DeletePageItemMutation, DeletePageItemMutationVariables>(DeletePageItemDocument, baseOptions);
      }
export type DeletePageItemMutationHookResult = ReturnType<typeof useDeletePageItemMutation>;
export type DeletePageItemMutationResult = ApolloReactCommon.MutationResult<DeletePageItemMutation>;
export type DeletePageItemMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePageItemMutation, DeletePageItemMutationVariables>;
export const GetThemeFilterOptionsDocument = gql`
    query GetThemeFilterOptions {
  themeFilterOptions {
    colors
    seasons
    themeStyles {
      label
      key
    }
  }
}
    `;

/**
 * __useGetThemeFilterOptionsQuery__
 *
 * To run a query within a React component, call `useGetThemeFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThemeFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThemeFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetThemeFilterOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetThemeFilterOptionsQuery, GetThemeFilterOptionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetThemeFilterOptionsQuery, GetThemeFilterOptionsQueryVariables>(GetThemeFilterOptionsDocument, baseOptions);
      }
export function useGetThemeFilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetThemeFilterOptionsQuery, GetThemeFilterOptionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetThemeFilterOptionsQuery, GetThemeFilterOptionsQueryVariables>(GetThemeFilterOptionsDocument, baseOptions);
        }
export type GetThemeFilterOptionsQueryHookResult = ReturnType<typeof useGetThemeFilterOptionsQuery>;
export type GetThemeFilterOptionsLazyQueryHookResult = ReturnType<typeof useGetThemeFilterOptionsLazyQuery>;
export type GetThemeFilterOptionsQueryResult = ApolloReactCommon.QueryResult<GetThemeFilterOptionsQuery, GetThemeFilterOptionsQueryVariables>;
export const PublishWeddingWebsiteMutationDocument = gql`
    mutation publishWeddingWebsiteMutation {
  publishWeddingWebsite {
    id
    slug
    state
  }
}
    `;
export type PublishWeddingWebsiteMutationMutationFn = ApolloReactCommon.MutationFunction<PublishWeddingWebsiteMutation, PublishWeddingWebsiteMutationVariables>;

/**
 * __usePublishWeddingWebsiteMutation__
 *
 * To run a mutation, you first call `usePublishWeddingWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishWeddingWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishWeddingWebsiteMutation, { data, loading, error }] = usePublishWeddingWebsiteMutation({
 *   variables: {
 *   },
 * });
 */
export function usePublishWeddingWebsiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PublishWeddingWebsiteMutation, PublishWeddingWebsiteMutationVariables>) {
        return ApolloReactHooks.useMutation<PublishWeddingWebsiteMutation, PublishWeddingWebsiteMutationVariables>(PublishWeddingWebsiteMutationDocument, baseOptions);
      }
export type PublishWeddingWebsiteMutationHookResult = ReturnType<typeof usePublishWeddingWebsiteMutation>;
export type PublishWeddingWebsiteMutationMutationResult = ApolloReactCommon.MutationResult<PublishWeddingWebsiteMutation>;
export type PublishWeddingWebsiteMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<PublishWeddingWebsiteMutation, PublishWeddingWebsiteMutationVariables>;
export const SignupMutationDocument = gql`
    mutation signupMutation($attributes: SignupArgs!) {
  signup(args: $attributes) {
    member {
      id
      firstName
      lastName
      fianceFirstName
      fianceLastName
      email
      legacyUserId
      username
    }
    wedding {
      id
      weddingDate
      budgetRange
      guestRange
      market {
        city
        state
        country
        code
      }
    }
    session {
      token
    }
    weddingWebsite {
      id
      searchable
      slug
      source
      state
      userUuid
      weddingUuid
      vanityRoot
      vanityUrl
      themeId
    }
  }
}
    `;
export type SignupMutationMutationFn = ApolloReactCommon.MutationFunction<SignupMutation, SignupMutationVariables>;

/**
 * __useSignupMutation__
 *
 * To run a mutation, you first call `useSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMutation, { data, loading, error }] = useSignupMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useSignupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SignupMutation, SignupMutationVariables>) {
        return ApolloReactHooks.useMutation<SignupMutation, SignupMutationVariables>(SignupMutationDocument, baseOptions);
      }
export type SignupMutationHookResult = ReturnType<typeof useSignupMutation>;
export type SignupMutationMutationResult = ApolloReactCommon.MutationResult<SignupMutation>;
export type SignupMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SignupMutation, SignupMutationVariables>;
export const SignupUninitializedMutationDocument = gql`
    mutation signupUninitializedMutation($attributes: SignupArgs!) {
  signupUninitialized(args: $attributes) {
    member {
      id
      firstName
      lastName
      fianceFirstName
      fianceLastName
      email
      legacyUserId
      username
    }
    wedding {
      id
      weddingDate
      budgetRange
      guestRange
      market {
        city
        state
        country
        code
      }
    }
    session {
      token
    }
    weddingWebsite {
      id
      searchable
      slug
      source
      state
      userUuid
      weddingUuid
      vanityRoot
      vanityUrl
      themeId
    }
  }
}
    `;
export type SignupUninitializedMutationMutationFn = ApolloReactCommon.MutationFunction<SignupUninitializedMutation, SignupUninitializedMutationVariables>;

/**
 * __useSignupUninitializedMutation__
 *
 * To run a mutation, you first call `useSignupUninitializedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupUninitializedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupUninitializedMutation, { data, loading, error }] = useSignupUninitializedMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useSignupUninitializedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SignupUninitializedMutation, SignupUninitializedMutationVariables>) {
        return ApolloReactHooks.useMutation<SignupUninitializedMutation, SignupUninitializedMutationVariables>(SignupUninitializedMutationDocument, baseOptions);
      }
export type SignupUninitializedMutationHookResult = ReturnType<typeof useSignupUninitializedMutation>;
export type SignupUninitializedMutationMutationResult = ApolloReactCommon.MutationResult<SignupUninitializedMutation>;
export type SignupUninitializedMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<SignupUninitializedMutation, SignupUninitializedMutationVariables>;
export const UpdateBasicInfoMutationDocument = gql`
    mutation updateBasicInfoMutation($membersArgs: MemberArgs!, $weddingWebsiteAttrs: WWS_WeddingWebsiteAttributes!) {
  updateMember(args: $membersArgs) {
    id
    firstName
    lastName
    fianceFirstName
    fianceLastName
    __typename
  }
  updateWeddingWebsite(attributes: $weddingWebsiteAttrs) {
    id
    weddingLocation
    __typename
  }
}
    `;
export type UpdateBasicInfoMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateBasicInfoMutation, UpdateBasicInfoMutationVariables>;

/**
 * __useUpdateBasicInfoMutation__
 *
 * To run a mutation, you first call `useUpdateBasicInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBasicInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBasicInfoMutation, { data, loading, error }] = useUpdateBasicInfoMutation({
 *   variables: {
 *      membersArgs: // value for 'membersArgs'
 *      weddingWebsiteAttrs: // value for 'weddingWebsiteAttrs'
 *   },
 * });
 */
export function useUpdateBasicInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBasicInfoMutation, UpdateBasicInfoMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBasicInfoMutation, UpdateBasicInfoMutationVariables>(UpdateBasicInfoMutationDocument, baseOptions);
      }
export type UpdateBasicInfoMutationHookResult = ReturnType<typeof useUpdateBasicInfoMutation>;
export type UpdateBasicInfoMutationMutationResult = ApolloReactCommon.MutationResult<UpdateBasicInfoMutation>;
export type UpdateBasicInfoMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBasicInfoMutation, UpdateBasicInfoMutationVariables>;
export const WwsOnboardingWeddingDatePreferencesDocument = gql`
    query wwsOnboardingWeddingDatePreferences {
  weddingDatePreferences {
    datePreference
    hideDate
    season
    year
    weddingDate
    weddingDateFormat
    weddingDateRangeStart
    weddingDateRangeEnd
    hideCountdown
  }
}
    `;

/**
 * __useWwsOnboardingWeddingDatePreferencesQuery__
 *
 * To run a query within a React component, call `useWwsOnboardingWeddingDatePreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWwsOnboardingWeddingDatePreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWwsOnboardingWeddingDatePreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useWwsOnboardingWeddingDatePreferencesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WwsOnboardingWeddingDatePreferencesQuery, WwsOnboardingWeddingDatePreferencesQueryVariables>) {
        return ApolloReactHooks.useQuery<WwsOnboardingWeddingDatePreferencesQuery, WwsOnboardingWeddingDatePreferencesQueryVariables>(WwsOnboardingWeddingDatePreferencesDocument, baseOptions);
      }
export function useWwsOnboardingWeddingDatePreferencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WwsOnboardingWeddingDatePreferencesQuery, WwsOnboardingWeddingDatePreferencesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<WwsOnboardingWeddingDatePreferencesQuery, WwsOnboardingWeddingDatePreferencesQueryVariables>(WwsOnboardingWeddingDatePreferencesDocument, baseOptions);
        }
export type WwsOnboardingWeddingDatePreferencesQueryHookResult = ReturnType<typeof useWwsOnboardingWeddingDatePreferencesQuery>;
export type WwsOnboardingWeddingDatePreferencesLazyQueryHookResult = ReturnType<typeof useWwsOnboardingWeddingDatePreferencesLazyQuery>;
export type WwsOnboardingWeddingDatePreferencesQueryResult = ApolloReactCommon.QueryResult<WwsOnboardingWeddingDatePreferencesQuery, WwsOnboardingWeddingDatePreferencesQueryVariables>;
export const WwsOnboardingUpdateDatePrefMutationDocument = gql`
    mutation wwsOnboardingUpdateDatePrefMutation($weddingDatePrefAttrs: UpdateWeddingDatePreferencesArgs!) {
  updateWeddingDatePreferences(args: $weddingDatePrefAttrs) {
    datePreference
    year
    season
    hideDate
    weddingDate
    weddingDateFormat
    weddingDateRangeStart
    weddingDateRangeEnd
    hideCountdown
  }
}
    `;
export type WwsOnboardingUpdateDatePrefMutationMutationFn = ApolloReactCommon.MutationFunction<WwsOnboardingUpdateDatePrefMutation, WwsOnboardingUpdateDatePrefMutationVariables>;

/**
 * __useWwsOnboardingUpdateDatePrefMutation__
 *
 * To run a mutation, you first call `useWwsOnboardingUpdateDatePrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWwsOnboardingUpdateDatePrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wwsOnboardingUpdateDatePrefMutation, { data, loading, error }] = useWwsOnboardingUpdateDatePrefMutation({
 *   variables: {
 *      weddingDatePrefAttrs: // value for 'weddingDatePrefAttrs'
 *   },
 * });
 */
export function useWwsOnboardingUpdateDatePrefMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WwsOnboardingUpdateDatePrefMutation, WwsOnboardingUpdateDatePrefMutationVariables>) {
        return ApolloReactHooks.useMutation<WwsOnboardingUpdateDatePrefMutation, WwsOnboardingUpdateDatePrefMutationVariables>(WwsOnboardingUpdateDatePrefMutationDocument, baseOptions);
      }
export type WwsOnboardingUpdateDatePrefMutationHookResult = ReturnType<typeof useWwsOnboardingUpdateDatePrefMutation>;
export type WwsOnboardingUpdateDatePrefMutationMutationResult = ApolloReactCommon.MutationResult<WwsOnboardingUpdateDatePrefMutation>;
export type WwsOnboardingUpdateDatePrefMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<WwsOnboardingUpdateDatePrefMutation, WwsOnboardingUpdateDatePrefMutationVariables>;
export const UpdateDatePrefMutationDocument = gql`
    mutation updateDatePrefMutation($weddingDatePrefAttrs: UpdateWeddingDatePreferencesArgs!) {
  updateWeddingDatePreferences(args: $weddingDatePrefAttrs) {
    datePreference
    year
    season
    hideDate
    weddingDate
    weddingDateFormat
    weddingDateRangeStart
    weddingDateRangeEnd
    hideCountdown
    __typename
  }
}
    `;
export type UpdateDatePrefMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateDatePrefMutation, UpdateDatePrefMutationVariables>;

/**
 * __useUpdateDatePrefMutation__
 *
 * To run a mutation, you first call `useUpdateDatePrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDatePrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDatePrefMutation, { data, loading, error }] = useUpdateDatePrefMutation({
 *   variables: {
 *      weddingDatePrefAttrs: // value for 'weddingDatePrefAttrs'
 *   },
 * });
 */
export function useUpdateDatePrefMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDatePrefMutation, UpdateDatePrefMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateDatePrefMutation, UpdateDatePrefMutationVariables>(UpdateDatePrefMutationDocument, baseOptions);
      }
export type UpdateDatePrefMutationHookResult = ReturnType<typeof useUpdateDatePrefMutation>;
export type UpdateDatePrefMutationMutationResult = ApolloReactCommon.MutationResult<UpdateDatePrefMutation>;
export type UpdateDatePrefMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDatePrefMutation, UpdateDatePrefMutationVariables>;
export const UpdateWeddingDateMutationDocument = gql`
    mutation updateWeddingDateMutation($date: String!) {
  updateWeddingDate(date: $date) {
    id
    weddingDate
    budgetRange
    guestRange
    market {
      city
      state
      country
      code
    }
  }
}
    `;
export type UpdateWeddingDateMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateWeddingDateMutation, UpdateWeddingDateMutationVariables>;

/**
 * __useUpdateWeddingDateMutation__
 *
 * To run a mutation, you first call `useUpdateWeddingDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWeddingDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWeddingDateMutation, { data, loading, error }] = useUpdateWeddingDateMutation({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useUpdateWeddingDateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWeddingDateMutation, UpdateWeddingDateMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateWeddingDateMutation, UpdateWeddingDateMutationVariables>(UpdateWeddingDateMutationDocument, baseOptions);
      }
export type UpdateWeddingDateMutationHookResult = ReturnType<typeof useUpdateWeddingDateMutation>;
export type UpdateWeddingDateMutationMutationResult = ApolloReactCommon.MutationResult<UpdateWeddingDateMutation>;
export type UpdateWeddingDateMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWeddingDateMutation, UpdateWeddingDateMutationVariables>;
export const UpdateWeddingWebsiteMutationDocument = gql`
    mutation updateWeddingWebsiteMutation($attributes: WWS_WeddingWebsiteAttributes!) {
  updateWeddingWebsite(attributes: $attributes) {
    id
    searchable
    slug
    source
    state
    userUuid
    weddingUuid
    vanityRoot
    vanityUrl
    themeId
  }
}
    `;
export type UpdateWeddingWebsiteMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateWeddingWebsiteMutation, UpdateWeddingWebsiteMutationVariables>;

/**
 * __useUpdateWeddingWebsiteMutation__
 *
 * To run a mutation, you first call `useUpdateWeddingWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWeddingWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWeddingWebsiteMutation, { data, loading, error }] = useUpdateWeddingWebsiteMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateWeddingWebsiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWeddingWebsiteMutation, UpdateWeddingWebsiteMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateWeddingWebsiteMutation, UpdateWeddingWebsiteMutationVariables>(UpdateWeddingWebsiteMutationDocument, baseOptions);
      }
export type UpdateWeddingWebsiteMutationHookResult = ReturnType<typeof useUpdateWeddingWebsiteMutation>;
export type UpdateWeddingWebsiteMutationMutationResult = ApolloReactCommon.MutationResult<UpdateWeddingWebsiteMutation>;
export type UpdateWeddingWebsiteMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWeddingWebsiteMutation, UpdateWeddingWebsiteMutationVariables>;
export const FlipperExperimentAssignmentQueryDocument = gql`
    query flipperExperimentAssignmentQuery($flipperExperimentBucketId: String!, $flipperExperimentBucketExperimentId: String!) {
  flipperExperimentBucketAssignment(bucketId: $flipperExperimentBucketId, experimentId: $flipperExperimentBucketExperimentId) {
    experiment_id
    variant_name
    bucketing_id
  }
  flipperExperiment(experimentId: $flipperExperimentBucketExperimentId) {
    experiment_name
  }
}
    `;

/**
 * __useFlipperExperimentAssignmentQuery__
 *
 * To run a query within a React component, call `useFlipperExperimentAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlipperExperimentAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlipperExperimentAssignmentQuery({
 *   variables: {
 *      flipperExperimentBucketId: // value for 'flipperExperimentBucketId'
 *      flipperExperimentBucketExperimentId: // value for 'flipperExperimentBucketExperimentId'
 *   },
 * });
 */
export function useFlipperExperimentAssignmentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FlipperExperimentAssignmentQuery, FlipperExperimentAssignmentQueryVariables>) {
        return ApolloReactHooks.useQuery<FlipperExperimentAssignmentQuery, FlipperExperimentAssignmentQueryVariables>(FlipperExperimentAssignmentQueryDocument, baseOptions);
      }
export function useFlipperExperimentAssignmentQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FlipperExperimentAssignmentQuery, FlipperExperimentAssignmentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FlipperExperimentAssignmentQuery, FlipperExperimentAssignmentQueryVariables>(FlipperExperimentAssignmentQueryDocument, baseOptions);
        }
export type FlipperExperimentAssignmentQueryHookResult = ReturnType<typeof useFlipperExperimentAssignmentQuery>;
export type FlipperExperimentAssignmentQueryLazyQueryHookResult = ReturnType<typeof useFlipperExperimentAssignmentQueryLazyQuery>;
export type FlipperExperimentAssignmentQueryQueryResult = ApolloReactCommon.QueryResult<FlipperExperimentAssignmentQuery, FlipperExperimentAssignmentQueryVariables>;
export const FlipperExperimentBucketQueryDocument = gql`
    query flipperExperimentBucketQuery($flipperExperimentBucketId: String!, $flipperExperimentBucketExperimentId: String!, $flipperVariantId: String, $flipperForce: String) {
  flipperExperimentBucket(bucketId: $flipperExperimentBucketId, experimentId: $flipperExperimentBucketExperimentId, variantId: $flipperVariantId, force: $flipperForce) {
    experiment_id
    bucketing_id
    variant_name
  }
  flipperExperiment(experimentId: $flipperExperimentBucketExperimentId) {
    experiment_name
  }
}
    `;

/**
 * __useFlipperExperimentBucketQuery__
 *
 * To run a query within a React component, call `useFlipperExperimentBucketQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlipperExperimentBucketQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlipperExperimentBucketQuery({
 *   variables: {
 *      flipperExperimentBucketId: // value for 'flipperExperimentBucketId'
 *      flipperExperimentBucketExperimentId: // value for 'flipperExperimentBucketExperimentId'
 *      flipperVariantId: // value for 'flipperVariantId'
 *      flipperForce: // value for 'flipperForce'
 *   },
 * });
 */
export function useFlipperExperimentBucketQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FlipperExperimentBucketQuery, FlipperExperimentBucketQueryVariables>) {
        return ApolloReactHooks.useQuery<FlipperExperimentBucketQuery, FlipperExperimentBucketQueryVariables>(FlipperExperimentBucketQueryDocument, baseOptions);
      }
export function useFlipperExperimentBucketQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FlipperExperimentBucketQuery, FlipperExperimentBucketQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FlipperExperimentBucketQuery, FlipperExperimentBucketQueryVariables>(FlipperExperimentBucketQueryDocument, baseOptions);
        }
export type FlipperExperimentBucketQueryHookResult = ReturnType<typeof useFlipperExperimentBucketQuery>;
export type FlipperExperimentBucketQueryLazyQueryHookResult = ReturnType<typeof useFlipperExperimentBucketQueryLazyQuery>;
export type FlipperExperimentBucketQueryQueryResult = ApolloReactCommon.QueryResult<FlipperExperimentBucketQuery, FlipperExperimentBucketQueryVariables>;
export const MembershipQueryDocument = gql`
    query membershipQuery {
  member {
    id
    firstName
    lastName
    fianceFirstName
    fianceLastName
    email
    legacyUserId
    username
  }
}
    `;

/**
 * __useMembershipQuery__
 *
 * To run a query within a React component, call `useMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipQuery({
 *   variables: {
 *   },
 * });
 */
export function useMembershipQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MembershipQuery, MembershipQueryVariables>) {
        return ApolloReactHooks.useQuery<MembershipQuery, MembershipQueryVariables>(MembershipQueryDocument, baseOptions);
      }
export function useMembershipQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MembershipQuery, MembershipQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MembershipQuery, MembershipQueryVariables>(MembershipQueryDocument, baseOptions);
        }
export type MembershipQueryHookResult = ReturnType<typeof useMembershipQuery>;
export type MembershipQueryLazyQueryHookResult = ReturnType<typeof useMembershipQueryLazyQuery>;
export type MembershipQueryQueryResult = ApolloReactCommon.QueryResult<MembershipQuery, MembershipQueryVariables>;
export const PaginateFamilyThemesDocument = gql`
    query PaginateFamilyThemes($nextCursor: Int, $take: Int, $order: WWS_ThemeOrder, $colors: [String!], $seasons: [String!], $styles: [String!]) {
  paginateFamilyThemes(nextCursor: $nextCursor, take: $take, order: $order, colors: $colors, seasons: $seasons, styles: $styles) {
    results {
      family
      themes {
        categoryData
        designerUrl
        family
        id
        mobilePreviewImage {
          mediaApiId
          mediaUrl
        }
        name
        previewImage {
          mediaApiId
          mediaUrl
        }
        swatchImage {
          mediaApiId
        }
      }
    }
    nextCursor
    hasMore
  }
}
    `;

/**
 * __usePaginateFamilyThemesQuery__
 *
 * To run a query within a React component, call `usePaginateFamilyThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginateFamilyThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginateFamilyThemesQuery({
 *   variables: {
 *      nextCursor: // value for 'nextCursor'
 *      take: // value for 'take'
 *      order: // value for 'order'
 *      colors: // value for 'colors'
 *      seasons: // value for 'seasons'
 *      styles: // value for 'styles'
 *   },
 * });
 */
export function usePaginateFamilyThemesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PaginateFamilyThemesQuery, PaginateFamilyThemesQueryVariables>) {
        return ApolloReactHooks.useQuery<PaginateFamilyThemesQuery, PaginateFamilyThemesQueryVariables>(PaginateFamilyThemesDocument, baseOptions);
      }
export function usePaginateFamilyThemesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginateFamilyThemesQuery, PaginateFamilyThemesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PaginateFamilyThemesQuery, PaginateFamilyThemesQueryVariables>(PaginateFamilyThemesDocument, baseOptions);
        }
export type PaginateFamilyThemesQueryHookResult = ReturnType<typeof usePaginateFamilyThemesQuery>;
export type PaginateFamilyThemesLazyQueryHookResult = ReturnType<typeof usePaginateFamilyThemesLazyQuery>;
export type PaginateFamilyThemesQueryResult = ApolloReactCommon.QueryResult<PaginateFamilyThemesQuery, PaginateFamilyThemesQueryVariables>;
export const ThemeQueryDocument = gql`
    query themeQuery($id: Int!) {
  theme(id: $id) {
    categoryData
    designerUrl
    family
    id
    mobilePreviewImage {
      mediaApiId
      mediaUrl
    }
    name
    previewImage {
      mediaApiId
      mediaUrl
    }
    swatchImage {
      mediaApiId
    }
    themeDesigner {
      companyName
      name
    }
    carouselImages
    batch
    testRank
  }
}
    `;

/**
 * __useThemeQuery__
 *
 * To run a query within a React component, call `useThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThemeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useThemeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ThemeQuery, ThemeQueryVariables>) {
        return ApolloReactHooks.useQuery<ThemeQuery, ThemeQueryVariables>(ThemeQueryDocument, baseOptions);
      }
export function useThemeQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ThemeQuery, ThemeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ThemeQuery, ThemeQueryVariables>(ThemeQueryDocument, baseOptions);
        }
export type ThemeQueryHookResult = ReturnType<typeof useThemeQuery>;
export type ThemeQueryLazyQueryHookResult = ReturnType<typeof useThemeQueryLazyQuery>;
export type ThemeQueryQueryResult = ApolloReactCommon.QueryResult<ThemeQuery, ThemeQueryVariables>;
export const ThemesQueryDocument = gql`
    query themesQuery($variant: WWS_FamilyThemeVariant) {
  familyThemes(variant: $variant) {
    family
    themes {
      categoryData
      designerUrl
      family
      id
      mobilePreviewImage {
        mediaApiId
        mediaUrl
      }
      name
      previewImage {
        mediaApiId
        mediaUrl
      }
      swatchImage {
        mediaApiId
      }
      themeDesigner {
        companyName
        name
      }
      carouselImages
      batch
      testRank
    }
  }
}
    `;

/**
 * __useThemesQuery__
 *
 * To run a query within a React component, call `useThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThemesQuery({
 *   variables: {
 *      variant: // value for 'variant'
 *   },
 * });
 */
export function useThemesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ThemesQuery, ThemesQueryVariables>) {
        return ApolloReactHooks.useQuery<ThemesQuery, ThemesQueryVariables>(ThemesQueryDocument, baseOptions);
      }
export function useThemesQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ThemesQuery, ThemesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ThemesQuery, ThemesQueryVariables>(ThemesQueryDocument, baseOptions);
        }
export type ThemesQueryHookResult = ReturnType<typeof useThemesQuery>;
export type ThemesQueryLazyQueryHookResult = ReturnType<typeof useThemesQueryLazyQuery>;
export type ThemesQueryQueryResult = ApolloReactCommon.QueryResult<ThemesQuery, ThemesQueryVariables>;
export const WeddingQueryDocument = gql`
    query weddingQuery {
  wedding {
    id
    weddingDate
    budgetRange
    guestRange
    market {
      city
      state
      country
      code
    }
  }
}
    `;

/**
 * __useWeddingQuery__
 *
 * To run a query within a React component, call `useWeddingQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeddingQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeddingQuery({
 *   variables: {
 *   },
 * });
 */
export function useWeddingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WeddingQuery, WeddingQueryVariables>) {
        return ApolloReactHooks.useQuery<WeddingQuery, WeddingQueryVariables>(WeddingQueryDocument, baseOptions);
      }
export function useWeddingQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WeddingQuery, WeddingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<WeddingQuery, WeddingQueryVariables>(WeddingQueryDocument, baseOptions);
        }
export type WeddingQueryHookResult = ReturnType<typeof useWeddingQuery>;
export type WeddingQueryLazyQueryHookResult = ReturnType<typeof useWeddingQueryLazyQuery>;
export type WeddingQueryQueryResult = ApolloReactCommon.QueryResult<WeddingQuery, WeddingQueryVariables>;
export const WwsOnboardingWeddingWebsiteQueryDocument = gql`
    query wwsOnboardingWeddingWebsiteQuery {
  weddingWebsite {
    id
    searchable
    slug
    source
    state
    userUuid
    weddingUuid
    vanityRoot
    vanityUrl
    themeId
  }
}
    `;

/**
 * __useWwsOnboardingWeddingWebsiteQuery__
 *
 * To run a query within a React component, call `useWwsOnboardingWeddingWebsiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useWwsOnboardingWeddingWebsiteQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWwsOnboardingWeddingWebsiteQuery({
 *   variables: {
 *   },
 * });
 */
export function useWwsOnboardingWeddingWebsiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WwsOnboardingWeddingWebsiteQuery, WwsOnboardingWeddingWebsiteQueryVariables>) {
        return ApolloReactHooks.useQuery<WwsOnboardingWeddingWebsiteQuery, WwsOnboardingWeddingWebsiteQueryVariables>(WwsOnboardingWeddingWebsiteQueryDocument, baseOptions);
      }
export function useWwsOnboardingWeddingWebsiteQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WwsOnboardingWeddingWebsiteQuery, WwsOnboardingWeddingWebsiteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<WwsOnboardingWeddingWebsiteQuery, WwsOnboardingWeddingWebsiteQueryVariables>(WwsOnboardingWeddingWebsiteQueryDocument, baseOptions);
        }
export type WwsOnboardingWeddingWebsiteQueryHookResult = ReturnType<typeof useWwsOnboardingWeddingWebsiteQuery>;
export type WwsOnboardingWeddingWebsiteQueryLazyQueryHookResult = ReturnType<typeof useWwsOnboardingWeddingWebsiteQueryLazyQuery>;
export type WwsOnboardingWeddingWebsiteQueryQueryResult = ApolloReactCommon.QueryResult<WwsOnboardingWeddingWebsiteQuery, WwsOnboardingWeddingWebsiteQueryVariables>;